const dansk = {
    // Errors from API - dynamic error messages
    errors: {
        bad_request:
            'Forespørgslen kunne ikke behandles. Kontrollér dine oplysninger og prøv igen.',
        unauthorized: 'Din session er udløbet. Log ind igen for at fortsætte.',
        forbidden: 'Du har ikke tilladelse til at udføre denne handling.',
        conflict:
            'Der opstod en konflikt med data. Opdatér siden og prøv igen.',
        unprocessable:
            'Nogle felter indeholder ugyldige værdier. Ret dem og prøv igen.',
        internal_server_error: 'Der opstod en systemfejl. Prøv igen om lidt.',
        network:
            'Forbindelsen til serveren kunne ikke oprettes. Tjek din internetforbindelse og prøv igen.',
        unknown_error: 'Der opstod en uventet fejl. Prøv igen.',
    },

    Failed_wrong_update:
        'Opdatering mislykkedes. Prøv igen eller kontakt support, hvis problemet fortsætter.',

    Successfully_created_wrongdoing: 'Forseelse oprettet med succes.',

    Successfully_updated_wrongdoing: 'Forseelse opdateret med succes.',
    wrongDoingMinNameRequired: 'Navnet skal være mindst 4 tegn langt.',
    wrongDoingNameRequired: 'Indtast venligst et navn.',
    wrongDoingNameMaxLength: 'Navnet må ikke overstige 255 tegn.',
    wrongDoingParagraph: 'Indtast venligst afsnit.',
    wrongDoingParagraphMinLength: 'Paragraf skal være mindst 4 tegn.',
    wrongDoingCreateFailed:
        'Forseelsen kunne ikke oprettes. Prøv venligst igen.',
    wrongDoingDeleteFailed:
        'Forseelsen kunne ikke slettes. Prøv venligst igen.',
    clearReasonCreateSuccess: 'Frafaldsårsag oprettet.',
    clearReasonUpdateSuccess: 'Frafaldsårsag opdateret.',
    clearReasonDeleteSuccess: 'Frafaldsårsag slettet.',
    clearReasonCreateFailed:
        'Frafaldsårsagen kunne ikke oprettes. Prøv venligst igen.',
    clearReasonUpdateFailed:
        'Frafaldsårsagen kunne ikke opdateres. Prøv venligst igen.',
    clearReasonDeleteFailed:
        'Frafaldsårsagen kunne ikke slettes. Prøv venligst igen.',
    cameraSettingsNameRequired: 'Indtast venligst et navn.',
    cameraSettingsAddressRequired: 'Vælg venligst en adresse.',
    cameraSettingsTypeRequired: 'Vælg venligst en type.',
    cameraSettingsUsernameRequired: 'Indtast venligst et brugernavn.',
    cameraSettingsPasswordRequired: 'Indtast venligst en adgangskode.',
    cameraSettingsRtspUrlRequired: 'Indtast venligst en RTSP-URL.',
    'RTSP URL': 'RTSP-URL',
    'Heartbeat URL': 'Heartbeat-URL',
    trainingTitleRequired: 'Indtast venligst en træningstitel.',
    trainingContentRequired: 'Indtast venligst træningsindholdet.',
    trainingReadDurationInvalid: 'Læsningstid skal være større end 0.',
    trainingSaveFailed:
        'Træningsmodulet kunne ikke gemmes. Prøv venligst igen.',
    notificationSentToUsers: 'Notifikation sendt til {{count}} bruger(e).',
    notificationSentToUsersShort: 'Sendt til {{count}} bruger(e)',
    notificationFailedCount: '{{count}} mislykkedes',
    notificationSkippedCount: '{{count}} med sprungne kanaler',
    notificationFailedToDeliver: 'Kunne ikke levere til {{count}} bruger(e).',
    notificationSendFailed:
        'Kunne ikke sende notifikationen. Prøv venligst igen.',
    // Fallback: current backend sends these English strings verbatim.
    // Remove once backend switches to sending the snake_case codes above.
    'User has not enabled push notifications on their device':
        'Brugeren har ikke aktiveret push-notifikationer på deres enhed.',
    'Push notification service is temporarily unavailable':
        'Push-notifikationstjenesten er midlertidigt utilgængelig. Prøv venligst igen senere.',
    'Failed to deliver push notification to the device':
        'Push-notifikationen kunne ikke leveres.',
    'Failed to deliver in-app notification':
        'In-app-notifikationen kunne ikke leveres.',
    'User has not set up notification preferences':
        'Brugeren har ikke opsat notifikationspræferencer.',
    'Notification could not be delivered through any channel':
        'Notifikationen kunne ikke leveres via nogen kanal.',

    // subscription rules page:
    'rent.delete.title': 'Slet abonnementsregel',
    'rent.delete.error_title': 'Kunne ikke slette abonnementsregel',
    'rent.delete.warning_title': 'Du er ved at slette denne abonnementsregel',
    'rent.delete.warning_body':
        'Denne handling fjerner reglen og kan påvirke abonnementer, der bruger den.',
    'rent.delete.confirm_info_title': 'Hvad der sker, når du bekræfter',
    'rent.delete.confirm_info_point_1': 'Abonnementsreglen slettes via ID.',

    // buy subscription page public.
    'subscription.invalid_page_title': 'Der opstod en fejl',
    'subscription.invalid_page_body':
        'Dette link er ikke gyldigt lige nu. Prøv igen senere eller kontakt support.',

    VersionWatcher: 'Ny version klar – opdater siden.',

    // Generic
    New: 'Ny',
    Update: 'Opdater',
    Cancel: 'Tilbage',
    Create: 'Opret',
    Delete: 'Slet',
    'Delete singular': 'Slet',
    Upload: 'Upload',
    Close: 'Luk',
    Read: 'Læs',
    'Generate Report': 'Hent Rapport',
    'Generating Report': 'Henter rapport…',
    'Download Report': 'Hent Rapport',
    downloadXlsx: 'Hent XLSX',
    reportFilterError:
        'Rapporten kunne ikke genereres. Anvend filtre for at reducere mængden af resultater.',
    reportGeneratingSlow:
        'Rapporten genereres. Anvend filtre for at øge hastigheden.',
    'Search the table': 'Søg i tabellen',
    Page: 'Side',
    of: 'af',
    Images: 'Billeder',
    Dates: 'Datoer',
    Date: 'Dato',
    Time: 'Tid',
    Note: 'Note',
    optional: '(valgfri)',
    Status: 'Status',
    Country: 'Land',
    'Select All': 'Vælg alle',
    Allow: 'Tillad',
    Business: 'Forretning',
    Search: 'Søg',
    CarBrand: 'Bilmærke',
    FuelName: 'Brændstoftype',
    'Valve control': 'Ventilkontrol',
    SentToCasewhere: 'Sendt til Casewhere',
    More: 'Mere',
    Hide: 'Skjul',
    Other: 'Andre',
    Save: 'Gem',
    Saving: 'Gemmer',
    Unknown: 'Ukendt',
    Choose: 'Vælg',
    Website: 'Hjemmeside',
    more: 'mere',
    'Created date': 'Oprettet dato',
    Parkinglots: 'Parkeringszoner',
    Parkinglot: 'Parkeringsplads',
    Public: 'Offentlig',
    Extra: 'Ekstra',
    'Activate discount codes': 'Aktiver rabatkoder',
    'Disable discount codes': 'Deaktiver rabatkoder',
    'Discount codes': 'Rabatkoder',
    'Choose address': 'Vælg adresse',
    'Validity period': 'Gyldig periode',
    'Valid for an unlimited time': 'Gyldig på ubestemt tid',
    'Set a specific validity period': 'Vælg en gyldig periode',
    'Select the address where discount codes are allowed.':
        'Vælg den adresse, hvor rabatkoder må bruges.',
    'Choose when the discount code should be active. The end date must be after the start date.':
        'Vælg hvornår rabatkoden skal være aktiv. Slutdatoen skal være efter startdatoen.',
    'The discount code is valid until you choose a specific period.':
        'Rabatkoden er gyldig, indtil du vælger en bestemt periode.',
    Copy: 'Kopier',
    Copied: 'Kopieret',
    ' to ': ' til ',
    'Copy failed': 'Kopiering fejlede',
    'New code': 'Ny kode',
    'Mail Settings': 'Mailindstillinger',
    'Unlimited period': 'Ubegrænset periode',
    'Send mail directly': 'Send mail direkte',
    'Send new mail': 'Send ny mail',
    // User
    Username: 'Brugernavn',
    Password: 'Kodeord',
    'Created By': 'Oprettet af',
    'Created by': 'Oprettet af',
    'Created Date': 'Oprettet dato',
    'Updated Date': 'Opdateret dato',
    'Updated by': 'Opdateret af',
    'Last login web': 'Sidste login web',
    'Last login app': 'Sidste login app',
    Admin: 'Admin',
    Write: 'Opret',
    'Can manage all settings and permissions':
        'Kan håndtere alle indstillinger',
    'Can manage standard settings and permissions':
        'Kan håndtere standard indstillinger og oprette/redigere',
    'Can access as a read-only user': 'Kan kun tilgå og se info',
    'User Id': 'Bruger ID',
    DeleteUserConfirmMsg:
        'Hvis du sletter denne bruger, ophører alle deres aktive tilladelser og abonnementer fra i dag med det samme. Er du sikker på, at du vil fortsætte?',
    DeleteAddressAccordionTitle: 'Deaktiver parkeringsadresse',
    DeleteAddressHeading: 'Du er ved at deaktivere adressen',
    DeleteAddressIntro:
        'Handlingen vil slette adressen og gøre den utilgængelig i hele platformen. Nedenfor kan du se konsekvenserne.',
    DeleteAddressEffectsTitle: 'Dette vil ske:',
    DeleteAddressCategoriesRulesTitle: 'Parkeringsregler',
    DeleteAddressCategoriesSubsTitle: 'Abonnementer',
    DeleteAddressCategoriesPermitsTitle: 'Tilladelser',
    DeleteAddressCategoriesAccessTitle: 'Adgang og rettigheder',
    DeleteAddressRulesShortTerm:
        'Korttidsvilkår bliver deaktiveret og vises ikke længere på det offentlige kort til køb af p-billetter eller i platformen.',
    DeleteAddressRulesSubscription:
        'Abonnementsvilkår bliver deaktiveret. Det er ikke længere muligt at købe abonnementer via det offentlige kort, og reglerne vises ikke i platformen.',
    DeleteAddressSubsCancelled:
        'Alle aktive abonnementer på adressen bliver annulleret, men de forbliver aktive indtil udgangen af indeværende måned. (samme proces som ved "Stop abonnement").',
    DeleteAddressPermitsInactive:
        'Alle tilladelser sættes til inaktive og er ikke længere gyldige.',
    DeleteAddressAccessNoSelectFinesPermits:
        'Adressen kan ikke vælges ved oprettelse af afgifter eller tilladelser.',
    DeleteAddressAccessNoSelectUsers:
        'Adressen kan ikke vælges ved oprettelse af brugere.',
    DeleteAddressAccessUsersLoseAccess:
        'Alle nuværende brugere mister adgang til denne parkeringsadresse.',
    DeleteAddressAccessOrgsLoseAccess:
        'Alle eksterne organisationer mister også adgang til adressen.',
    DeleteAddressVisibilityRemoved:
        'Adressen fjernes fra alle adresselister og forsvinder fra platformen samt det offentlige kort.',

    DeleteOrganisationAccordionTitle: 'Deaktiver organisation',
    DeleteOrganisationHeading: 'Du er ved at deaktivere organisationen',
    DeleteOrganisationIntro:
        'Denne handling sletter organisationen og gør den utilgængelig i hele platformen. Alle tilknyttede adresser, regler, tilladelser og brugere bliver påvirket. Nedenfor kan du se konsekvenserne.',
    DeleteOrganisationEffectsTitle: 'Dette sker:',

    DeleteOrganisationCategoriesRulesTitle: 'Parkeringsregler',
    DeleteOrganisationCategoriesSubsTitle: 'Abonnementer',
    DeleteOrganisationCategoriesPermitsTitle: 'Tilladelser',
    DeleteOrganisationCategoriesAccessTitle: 'Adgang og rettigheder',

    DeleteOrganisationRulesTickets:
        'Alle korttidsvilkår tilknyttet organisationens adresser bliver deaktiveret og vises ikke længere på det offentlige kort eller i platformen.',
    DeleteOrganisationRulesSubscriptions:
        'Alle abonnementsvilkår tilknyttet organisationens adresser bliver deaktiveret. Det vil ikke længere være muligt at købe abonnementer via det offentlige kort eller i platformen.',
    DeleteOrganisationSubsCancelled:
        'Alle aktive abonnementer på organisationens adresser bliver annulleret, men de forbliver aktive indtil udgangen af indeværende måned. (samme proces som ved "Stop abonnement").',
    DeleteOrganisationPermitsInactive:
        'Alle tilladelser knyttet til organisationens adresser sættes til inaktive og er ikke længere gyldige.',

    DeleteOrganisationAccessUsersLoseAccess:
        'Alle organisationens brugere mister adgang til platformen og appen.',
    DeleteOrganisationAccessLoginBlocked:
        'Brugere fra denne organisation kan ikke logge ind.',
    DeleteOrganisationAccessOrgsLoseAccess:
        'Alle eksterne organisationer mister også adgang til adresserne.',
    DeleteOrganisationAccessOrganisationUnavailable:
        'Organisationen er ikke længere tilgængelig noget sted i platformen.',
    DeleteOrganisationAccessAddressesUnavailable:
        'Alle organisationens adresser er ikke længere tilgængelige i platformen eller på det offentlige kort.',
    DeleteOrganisationVisibilityRemoved:
        'Organisationen, alle dens adresser og brugere fjernes fra alle lister og søgeresultater og er ikke længere synlige noget sted i platformen eller på det offentlige kort.',
    'Only 1 permit per car per day?': 'Kun 1 tilladelse pr. bil pr. dag?',
    'User Distribution': 'Brugerfordeling',
    'Parking Guard Provision': 'Parkeringsvagtprovision',
    'Select Users': 'Vælg brugere',
    'Select Organisation': 'Vælg organisation',
    'App Fines': 'App Afgifter',
    'App Fines Revert': 'Annuller App Afgifter',
    'App Subscriptions': 'App Abonnementer',

    // Menu
    Home: 'Hjem',
    Dashboard: 'Dashboard',
    'Map of Parking Lots': 'Kort over P-pladser',
    'Parking Lots': 'Parkeringszoner',
    Users: 'Brugere',
    Permits: 'Tilladelser',
    'Permit Reasons': 'Tilladelsesskabelon',
    Fines: 'Afgifter',
    Fines2: 'Gebyrer',
    Tickets: 'P-billet',
    Customers: 'Kunde',
    Backoffice: 'Backoffice',
    Map: 'Kort',
    mapExportSaveAs: 'Gem kort som',
    mapExportSaveAsHint:
        'Download det aktuelle kort og billedtekst som PDF eller PNG.',
    mapExportAsPdf: 'PDF',
    mapExportAsPng: 'PNG',
    mapExportSaving: 'Gemmer…',
    mapExportFailed:
        'Kortet kunne ikke eksporteres. Prøv igen eller tag et skærmbillede.',
    mapExportPdfFailed:
        'Kunne ikke gemme kortet som PDF. Prøv PNG eller et skærmbillede.',
    mapExportPngFailed:
        'Kunne ikke gemme kortet som PNG. Prøv PDF eller et skærmbillede.',
    mapExportCaptionExportedAt: 'Eksporteret: {{datetime}} (CET)',
    mapExportCaptionMode: 'Tilstand: {{mode}}',
    mapExportCaptionPeriod: 'Periode: {{from}} – {{to}}',
    mapExportCaptionOrganisations: 'Organisationer: {{count}} (ID: {{ids}})',
    mapExportCaptionParkingLots: 'Parkeringspladser: {{count}} (ID: {{ids}})',
    mapExportCaptionUsers: 'Brugere: {{count}} (ID: {{ids}})',
    mapExportCaptionStreets: 'Gader: {{count}} ({{names}})',
    mapExportCaptionStreetNumbers: 'Husnumre: {{from}} – {{to}}',
    mapExportCaptionAddressTypes:
        'Parkeringsadressetyper: {{count}} (ID: {{ids}})',
    mapExportCaptionAreaFilter: 'Områdefilter (polygon): {{count}} hjørner',
    mapExportCaptionAreaDraft:
        'Områdevælger (kladde): {{count}} punkt(er) — tilføj mindst 3 og søg for at anvende',
    mapExportCaptionAreaPendingSearch:
        'Områdevælger: {{count}} punkter — kør Søg for at anvende på kortdata',
    mapExportOn: 'Til',
    mapExportOff: 'Fra',
    mapExportCaptionZones: 'Parkeringszoner på kortet: {{state}}',
    mapExportCaptionPins: 'Markører for pladser: {{state}}',
    mapExportCaptionGpsLive: 'Kun live GPS: {{state}}',
    Statistics: 'Statistik',
    Subscriptions: 'Abonnementer',
    oparkoGo: 'Oparko Go',
    permits: 'Tilladelser',
    fines: 'Afgifter',
    subscriptions: 'Abonnementer',
    'Subscription permits': 'Abonnementstilladelser',
    'Organisation list': 'Organisationsliste',
    Finance: 'Finans',
    'Ticket Service': 'Køb en P-billet',
    'Buy a permit': 'Køb en P-billet',
    'Get a permit': 'Få en P-billet',
    'Private Ticket Service': 'Få en P-billet',
    Reports: 'Rapporter',
    Rent: 'Leje',
    Prices: 'Priser',
    'Short term': 'Korttidsvilkår',
    discountCodes: 'Rabatkoder',
    unusedCodes: 'Ubrugte koder',
    usedCodes: 'Brugte koder',
    Rental: 'Abonnementsvilkår',
    Profile: 'Profil',
    Notifications: 'Notifikationer',
    Videowall: 'Videowall',
    'Camera Scans': 'Kamera scanninger',
    'Camera scan': 'Kamera scanning',
    Daily: 'Daglig',
    Area: 'Område',
    'App Permits': 'App Tilladelser',
    'Paid Short Tickets': 'Betalingsparkering',
    'Weekly Heat Map': 'Ugentlig Heat Map',
    Documentation: 'Dokumentation',

    // Settings
    Settings: 'Indstillinger',
    'User Details': 'Brugeroplysninger',
    Language: 'Sprog',
    'Parking Lot': 'P-zone',
    'Parking lot': 'P-zone',
    'Parking Zone': 'Parkeringszone',
    'P-Zone': 'P-zone',
    Street: 'Gade',
    'Street Number': 'Gadenummer',
    ZipCode: 'Postnummer',
    City: 'By',
    'Notification settings': 'Notifikationsindstillinger',
    'WELCOME TO': 'VELKOMMEN TIL',
    'Only receive notifications on the selected days and within the specified time period.':
        'Modtag kun notifikationer på de valgte dage og inden for det angivne tidsrum.',
    'Enable work hours': 'Aktiver arbejdstider',
    'Push in app': 'Push in app',
    'Notify in web': 'Platform',
    Mail: 'Mail',
    Timing: 'Timing',
    'Get notified when new possible fines are detected.':
        'Modtag notifikationer om nye potentielle afgifter.',

    // Login
    Login: 'Log ind',
    'Log out': 'Log ud',
    'Forgot Password': 'Glemt kodeord',
    'Back to login': 'Tilbage til login',
    Email: 'Email',
    'Reset Password': 'Nulstil kodeord',
    'Password reset email sent. Please check your email.':
        'Email til nulstilling af adgangskode sendt. Tjek venligst din email',
    'Something went wrong': 'Noget gik galt',
    'Wrong username or password': 'Forkert brugernavn eller adgangskode',
    'Error resetting password, please retry':
        'Fejl ved nulstilling af adgangskode. Prøv venligst igen',
    'Digital parking solution for every need':
        'Digital parkeringsløsning til ethvert behov',

    // Search bar
    'None selected': 'Ingen valgte',
    'All selected': 'Alle valgt',
    'Only active': 'Kun aktive',
    'Show cancelled': 'Vis annullerede',

    // Frontoffice
    'Latest fines': 'Seneste afgifter',
    'No data available!': 'Ingen tilgængelig data!',
    'There were no datapoints to show on this graph':
        'Der var ingen datapoint at vise på denne graf',
    'Good fines': 'Gode afgifter',
    Annulled: 'Annulleret',
    'Could not fetch fines - please refresh and try again':
        'Kunne ikke hente afgifter - opdater venligst og prøv igen',
    'Something went wrong, could not find any users - Please refresh and try again.':
        'Noget gik galt, kunne ikke finde nogen brugere - vær venlig at opdatere og prøve igen.',
    Activated: 'Aktiveret',
    Deactivated: 'Deaktiveret',
    'Indefinite validity': 'Gyldig på ubestemt tid',
    'Email sent to': 'Mail sendt til',
    'No email sent': 'Ingen mail sendt',
    Customer: 'Kunde',
    'User list': 'Brugerliste',
    'Total Users Shown': 'Brugere vist',
    'Total Events in Period': 'Samlet antal hændelser',
    'Average Events per User': 'Gennemsnitlige hændelser pr. bruger',
    'Create User': 'Opret bruger',
    Yes: 'Ja',
    No: 'Nej',
    'Your Cars': 'Dine biler',
    'Location Name': 'Lokationsnavn',
    'Permit list': 'Tilladelsesliste',
    'Create Permit': 'Opret tilladelse',
    'Start date': 'Startdato',
    'Start Date': 'Startdato',
    End: 'Slut',
    'End date': 'Slutdato',
    'End Date': 'Slutdato',
    'End Session': 'Stop parkering',
    'End with payment': 'Afslut med betaling',
    'End date & time': 'Slutdato og tidspunkt',
    Type: 'Type',
    'Could not find any parking lots - Please refresh and try again.':
        'Kunne ikke finde nogen parkeringspladser - vær venlig at opdatere og prøve igen.',
    'Parking Lots List': 'Parkering Lots List',
    Address: 'Adresse',
    'Parking Map': 'Parkering Map',
    'Could not find any hourly data - Please refresh and try again.':
        'Kunne ikke finde nogen timedata - opdater venligst og prøv igen.',
    'Something went wrong, could not find any daily data - Please refresh and try again.':
        'Noget gik galt, kunne ikke finde nogen daglige data - opdater venligst og prøv igen.',
    'Something went wrong, could not find any look up data - Please refresh and try again.':
        'Noget gik galt, kunne ikke finde nogen look up data - opdater venligst og prøv igen.',
    'Hourly visits count': 'Timesbesøg tæller',
    'Daily visits count': 'Daglige besøgstal',
    'Fine list': 'Afgiftsliste',
    'Could not generate the report - please refresh and try again':
        'Kunne ikke generere rapporten - opdater venligst og prøv igen',
    'country code': 'Landekode',
    'Country Code': 'Landekode',
    cancelFine: 'Hvorfor annullerer I dette gebyr?',
    'Cancel reason': 'Annulleringsårsag',
    Comments: 'Kommentarer',
    'Cancelled fines': 'Annullerede afgifter',
    'Cancelled fines2': 'Annullerede gebyrer',
    'Cancelled data': 'Annullerede',
    'cancellation rate': 'Annulleringsprocent',
    'Active fines': 'Aktive afgifter',
    'Active fines2': 'Gebyrer',
    'Active data': 'Aktive',
    'Total fines': 'Alle afgifter',
    'Parking Lot list': 'Parkeringspladsliste',
    'Reg. nr.': 'Reg. nr.',
    'Reference number': 'Løbenummer',
    'Reference id  / fine id / invoice id':
        'Løbenummer / afgiftsid / fakturanummer',
    'You cannot pay the fine right now.':
        'Det er ikke muligt at betale afgiften lige nu.',
    'If this seems unexpected, please try again later or contact support.':
        'Hvis dette virker uventet, prøv venligst igen senere eller kontakt support.',
    'This fine has been cancelled.': 'Denne afgift er blevet annulleret.',
    'You cannot pay this fine as it has been cancelled.':
        'Du kan ikke betale denne afgift, da den er blevet annulleret.',
    'This case has been sent to debt collection.':
        'Denne sag er sendt til inddrivelse.',
    CollectionMessage:
        'Du kan ikke betale denne afgift her. Brug venligst betalingsinstruktionerne i brevet, e-Boks-beskeden eller e-mailen, du har modtaget. Hvis du ønsker oplysninger om betaling, kan du bruge formularen under fanen "Opret indsigelse" og anmode om oplysninger.',

    CollectionMessageDocu:
        'Sagen er sendt til inddrivelse, og du kan ikke tilgå sagens dokumenter her. Hvis du mener, at dette er en fejl, brug formularen under fanen Opret indsigelse”.',

    'Something went wrong, please try again or contact support if the problem persists.':
        'Noget gik galt, prøv venligst igen eller kontakt support, hvis problemet fortsætter.',
    Code: 'Kode',
    'Parking Ticket ID': 'P-billet ID',
    'Discounted Price': 'Rabatpris',
    'Valid From': 'Gyldig fra',
    'Valid To': 'Gyldig til',
    'Email Sent To': 'E-mail sendt til',
    'Used At': 'Brugt den',

    // Handle fine flow
    documentation: {
        header: 'Se din dokumentation',
        subtitle: 'Få overblik over din dokumentation og detaljer for sagen.',
    },
    complaint: {
        header: 'Opret indsigelse',
        subtitle: 'Oplys årsagen og vedhæft dokumentation for din klage.',
    },
    payFine: {
        header: 'Gennemfør betaling',
        subtitle: 'Betal din sag her.',
    },

    emailSent: {
        header: 'E-mail sendt med succes',
        subtitle: 'Din besked er på vej. Du kan forvente et svar snart.',
    },

    paymentAccepted: {
        header: 'Betaling gennemført',
        subtitle: 'Tak. Din betaling er blevet behandlet.',
    },

    paymentDeclined: {
        header: 'Betaling afvist',
        subtitle: 'Desværre kunne din betaling ikke behandles.',
    },

    // Backoffice
    'Customer list': 'Kunde liste',
    'Something went wrong in searching for customers':
        'Noget gik galt i at søge efter kunder',
    'Create Customer': 'Opret kunde',
    Name: 'Navn',
    description: 'Beskrivelse',
    Description: 'Beskrivelse',
    'Create Fine': 'Opret Afgift',
    'Generate DMR report': 'Hent DMR-rapport',
    'Advanced Report': 'Avanceret rapport',
    'Mass change': 'Masseændring',
    'Customers info': 'Kunder info',
    'Accounting info': 'Regnskabsinfo',
    'Create p-lot': 'Opret p-plads',
    Add: 'Tilføj',
    'Parking Lot Info': 'Parkeringsplads info',
    'Add ruleset': 'Tilføj regelsæt',
    Rules: 'Regler',
    Streets: 'Gader',
    'Show child parking lots': 'Vis underliggende parkeringszoner',
    'Permit sharing': 'Tilladelsesdeling',
    'Group id': 'Gruppe ID',
    'minimum 20 characters': 'mindst 20 tegn',
    'Please provide at least 20 characters': 'Angiv venligst mindst 20 tegn',
    // Modals
    Directions: 'Placering',
    ParkingLotAngles: 'Vinkler',
    'Send Password': 'Send adgangskode',
    Contractor: 'Håndværker',
    'Settlement dates': 'Udbetalingsdatoer',
    'Parking Lot Type': 'P-plads Type',
    'Location Configuration': 'Lokation Indstillinger',
    areaSelector: 'Områdevælger',
    createParkingZone: 'Opret parkeringszone',
    clearZone: 'Ryd zone',
    clickToSelectArea: 'Klik for at vælge område',
    clickToClearArea: 'Klik for at rydde område',
    enterManually: 'Indtast manuelt',
    mapSelector: 'Kortvælger',
    areaCoordinatesMinError: 'Områdekoordinater skal have mindst 3 punkter, ',
    clickMapToAddPoints: 'klik på kortet for at tilføje punkter',
    'Single Point(Latitude/Longitude)': 'Punkt (Breddegrad/Længdegrad)',
    'Wont Update Status': 'Opdaterer ikke status',
    'Wont Update Parking Guard': 'P vagten opdateres ikke',
    'Wont Update Organization': 'Organisationen opdateres ikke',
    Offence: 'Forseelse',
    selectOffense: 'Vælg forseelse',
    streetQualifier: 'Vejtype',
    'Incident information': 'Hændelsesoplysninger',
    'Incident Information': 'Hændelsesoplysninger',
    'Leave a comment...': 'Efterlad en kommentar...',
    Latitude: 'Breddegrad',
    'Area coordinates': 'Område koordinater',
    'Map pin': 'Kort pin',
    'Loading...': 'Indlæser...',
    'Could not find the parking lot you were looking for.':
        'Kunne ikke finde parkeringspladsen, du ledte efter.',
    'Successfully updated the parking lot!':
        'Succesfuldt opdateret parkeringspladsen!',
    'Successfully created new parking lot!':
        'Med succes skabt ny parkeringsplads!',
    'You can now close the modal.': 'Du kan nu lukke modal.',
    'Geographic coordinate': 'Geografisk koordinat',
    Longitude: 'Længdegrad',
    'Parking Lot Details': 'Parkeringsplads detaljer',
    'Rules for parking': 'Regler for parkering',
    'Rules for guest parking': 'Regler for gæsteparkering',
    ruleName: 'Regel navn',
    advancedRuleName: 'Avanceret regel navn',
    customRuleName: 'Brugerdefineret regel navn',
    'Custom permit rules': 'Brugerdefinerede tilladelsesregler',
    'Select parking lots': 'Vælg parkeringspladser',
    '+ Overwrite rule': '+ Overskrivnings regel',
    maxActivePermits: 'Max antal aktive permits',
    maxPermitsPerMonth: 'Max antal oprettede permits',
    durationMinutes: 'Varighed af tilladelser (i minutter)',
    'Show customer': 'Vis kunde',
    'Number of active permits created by one user at the same time':
        'Antal aktive tilladelser oprettet af én bruger på samme tid',
    'Maximum length for created permits in app':
        'Maksimal længde for oprettede tilladelser i ca',
    'Note for app': 'Bemærkninger til app',
    'Profile Image': 'Profilbillede',
    'Street Name': 'Gadenavn',
    'Camera Fines': 'Kameraafgifter',
    'Camera fine list': 'Kameraafgiftsliste',
    'Camera Settings': 'Kameraindstillinger',
    Warning: 'Advarsel',
    'Changing Reg. No.': 'Ændring af Reg. No.',
    'Country and reg. no.': 'Land og reg. nr.',
    'If reg. no. is not correct and you need to adjust it, "Registered before" will not update. Please doublecheck your changes are correct before applying them':
        'Hvis reg. no. ikke er korrekt, og du skal rette det, vil "tidligere registreringer" ikke opdatere. Dobbelttjek venligst, at dine ændringer er korrekte, før du anvender dem',
    'Postal Code': 'Postnummer',
    'House.No': 'Hus.Nr',
    'Parking Terms': 'Parkeringsbetingelser',
    'Fine Price': 'Afgift Pris',
    'Control Type': 'Kontroltype',
    'Camera control': 'Kamerakontrol',
    'Camera Control': 'Kamerakontrol',
    'Guard control': 'P-vagtskontrol',
    'Guard Control': 'P-vagtskontrol',
    'Self control': 'Selvkontrol',
    'Self Ticketing': 'Egenkontrol',
    'Need for collection': 'Behov for indsamling',
    'Parking Spots': 'Parkeringsbåse',
    'Rent?': 'Leje?',
    Distribution: 'Fordeling',
    'Amount of Duty': 'Toldbeløb',
    'Why are you canceling this Fine? - Minimum 20 characters':
        'Hvorfor annullerer du denne afgift? - Minimum 20 tegn',
    'Send and Cancel Fee': 'Send og annullér gebyr',
    'Cancel Fee': 'Annuller gebyr',
    'Cancel Reason': 'Annulleringsårsag',
    'Additional Information': 'Yderligere oplysninger',
    'Could not find the fine you were looking for.':
        'Kunne ikke finde den afgift du søger.',
    'Could not find the permit you were looking for.':
        'Kunne ikke finde den tilladelse, du ledte efter.',
    'Belongs to': 'Tilhører',
    'Internal note': 'Intern note',
    'External note': 'Ekstern note',
    'Could not create the permit - close and try again please':
        'Kunne ikke oprette tilladelsen - tæt og prøv igen venligst',
    'Could not update the permit - close and try again please':
        'Kunne ikke opdatere tilladelsen - luk og prøv igen venligst',
    'User successfully created, you can close the modal again':
        'Bruger med succes oprettet, kan du lukke modal igen',
    'User successfully updated, you can close the modal again':
        'Bruger med succes opdateret, kan du lukke modal igen',
    'User credentials': 'Brugeroplysninger.',
    'Confirm password': 'Bekræft kodeord',
    'New password': 'Nyt kodeord',
    'The password matches': 'Adgangskoden matches',
    'The password does not matches': 'Adgangskoden svarer ikke til',
    'Error changing your password. Please ensure your current password is correct.':
        'Fejl ved ændring af din adgangskode. Sørg for, at din nuværende adgangskode er korrekt.',
    'Password changed successfully.': 'Din adgangskode er blevet ændret.',
    Permissions: 'Tilladelser',
    'Users to manage': 'Brugere til at styre',
    'Activate User': 'Aktiver Bruger',
    'Access to Website': 'Adgang til hjemmesiden',
    'Access to App': 'Adgang til App',
    'Access to API': 'Adgang til API',
    'Handle Fines': 'Håndter Afgifter',
    'Handle Permits': 'Håndter Tilladelser',
    'Handle Subscriptions': 'Håndter Abonnementer',
    User: 'Bruger',
    Permit: 'Tilladelser',
    Fine: 'Afgift',
    'Update customer': 'Opdateringskunde',
    'Customer Type': 'Kunde type',
    Created: 'Oprettet',
    Updated: 'Opdateret',
    'Connected Users': 'Tilknyttede brugere',
    'Connected parking lots': 'Tilknyttede parkeringspladser',
    'Total amount of users:': 'Samlet antal brugere:',
    'Fine successfully updated, you can close the modal again':
        'Afgiften er opdateret, du kan lukke modalet igen',
    'Fine successfully created, you can close the modal again':
        'Afgiften er oprettet, du kan lukke modalet igen',
    'Update Fine': 'Opdater Afgift',
    'New Fine': 'Ny Afgift',
    Brand: 'Mærke',
    Fuel: 'Brændstof',
    Owner: 'Ejer',
    'Parking guard': 'P vagt',
    'House number': 'Husnummer',
    'House nr.': 'Husnummer',
    'Open Parking Lot': 'Åben parkeringsplads',
    'Update parking lot': 'Opdater parkeringsplads',
    'External Customers': 'Eksterne kunder.',
    'Back to Fine': 'Tilbage til afgift',
    'Update user': 'Opdater brugeren',
    'Update User': 'Opdater Bruger',
    'New user': 'Ny bruger',
    'Update subscription': 'Opdater abonnement',
    'New subscription': 'Nyt abonnement',
    'Create subscription': 'Opret abonnement',
    'Create Subscription': 'Opret Abonnement',
    'Creating subscription...': 'Opretter abonnement...',
    'Available subscriptions left': 'Tilgængelige abonnementer',
    'out of': 'ud af',
    'Time rules for parking': 'Tidsregler for parkering',
    'Time rules': 'Tidsregler',
    time: 'tid',
    'Please select': 'Vælg venligst',
    Payments: 'Betalinger',
    'Subscription Id': 'Abonnement ID',
    Phone: 'Telefonnummer',
    'Parkinglot image': 'Parkeringspladsbillede',
    'Parkinglot images': 'Billeder af P-zone',
    'Signage images': 'Billeder af skilte',
    'parkingLots.minObservationTime': 'Min. observationstid (min)',
    'parkingLots.fineDurationMinutes.label': 'Afgiftsudløb - App afgifter',
    'parkingLots.fineDurationMinutes.disabled':
        'Sluttidspunkt sættes altid til midnat',
    'parkingLots.fineDurationMinutes.enabled':
        'Sluttidspunkt sættes til 24 timer efter oprettelse',
    'Collection Price': 'Administrations gebyr',
    'Post Collection Price Per Hour': 'Pris pr. time - Efteropkrævning',
    'Post Collection Price Per Day': 'Pris pr. døgn - Efteropkrævning',
    'Post collection by Day': 'Efteropkrævning - Døgn',
    'Days with free cancellation': 'Antal dage med fri annullering',
    'Allowed free fine cancellation per year':
        'Antal tilladte annulleringer pr. år',
    'Car user type': 'Firma / Person',
    "Keywords (comma-separated, e.g. 'taxi, cab')":
        "Nøgleord (kommasepareret, fx: 'taxi, Post Nord')",
    'Fine restrictions and settings for this parking lot (App)':
        'Forseelses indstillinger for denne P-plads (App)',
    'Confirm licenseplate': 'Bekræft nummerplade',
    'No Connected Users': 'Ingen tilknyttede brugere',
    'Monthly billing': 'Månedlig betaling (kr.)',
    'Billing Period': 'Afregningsfrekvens',
    'Minimum Rent': 'Minimumsleje',
    'Minimum Rent Period': 'Minimumslejeperiode',
    'Rent Type': 'Lejetype',
    'Minimum Rent Amount': 'Minimumslejebeløb',
    'Rent Amount': 'Lejebeløb',
    'Rent Period': 'Lejeperiode',
    '+ Add Coordinate': '+ Opret nyt koordinat',
    '− Remove Last': '− Fjern nederste koordinat',
    'Shift report': 'Vagt rapport',
    'Organisation and parkinglots': 'Organisation og parkeringspladser',
    'Select an organization to see their parking lots':
        'Vælg en organisation for at se deres parkeringspladser',
    'User and permissions': 'Brugerindstillinger',
    'Permission Preset': 'Pre-set indstillinger',
    'Session Permit': 'Session Tilladelse',
    'Attention Permit': 'Intern Tilladelse',
    'Alarm Permit': 'Alarmtilladelse',
    'Admin User': 'Admin bruger',
    'Basic Dashboard User': 'Standard dashboard bruger',
    'Reception user': 'Receptionistbruger',
    'Subscription user': 'Abonnementsbruger',
    'Parking Guard user': 'Parkeringsvagt bruger',
    'Ticket rules': 'Korttidsvilkår',
    'Finance Reports': 'Finans rapport',
    'Camera scan statistics': 'Kamera scan statistik',
    'Camera spot statistics': 'Kamera spot statistik',
    'Customer subscriptions': 'Kunde abonnementer',
    'Create Ticket Rule': 'Opret korttidsvilkår',
    Rulesets: 'Priser og tidsrum',
    'Fee price (DKK)': 'Gebyr (DKK)',
    'Additional hours': 'Ekstra timer',
    'Before you upload, make sure your': 'Inden du uploader skal tjekke at',
    'Image is no more than 4mb big': 'billedet ikke er større end 4mb',
    'Handle Camera Fine': 'Håndter kameraafgift',
    'Min park time': 'Min. parkeringstid',
    Missing: 'Manglende tid',
    'Scan Date': 'Scan Dato',
    Direction: 'Retning',
    'Review and Action': 'Håndtering af kameraafgift',
    'Total Permits': 'Total tilladelser',
    'Total Subscriptions': 'Total abonnementer',
    'Change Password': 'Skift adgangskode',
    'Current Password': 'Nuværende adgangskode',
    'Confirm new password': 'Bekræft ny adgangskode',
    enableAll: 'Aktiver alle',
    'Card details': 'Kortoplysninger',
    'Current Permits': 'Nuværende tilladelser',
    'Next Payment': 'Næste betaling',
    Accept: 'Accepter',
    'Enter your name': 'Indtast dit navn',
    'Enter your address': 'Indtast din adresse',
    'Enter your phonenumber': 'Indtast dit telefonnummer',
    'Enter your email address': 'Indtast din email adresse',
    'Enter your license plate': 'Indtast din nummerplade',
    'Every day': 'Hver dag',
    'Max permits per subscription': 'Maks tilladelser pr. abonnement',
    'Subscription Limit':
        'Abonnementsgrænse for parkeringsplads (0 = ubegrænset)',
    'Add timerule': 'Tilføj tidsregel',
    'Start Time': 'Starttid',
    'End Time': 'Sluttid',
    'Subscription Rule': 'Abonnementsvilkår',
    'Subscription information': 'Abonnementsoplysninger',
    'subscription limit reached': 'Abonnementgrænse nået for parkeringsplads',
    'permit limit exceeded': 'tilladelsesgrænse overskredet',
    'permit.history_deactivated':
        'Tilladelse deaktiveret på grund af sletning af bruger {{userID}} af bruger {{actorID}}',
    'permit.history_transferred':
        'Tilladelse overført fra bruger {{fromUserID}} til bruger {{toUserID}} på grund af sletning af bruger {{actorID}}',
    'permit.limit_exceeded_title': 'For mange tilladelser',
    'permit.limit_exceeded_message':
        'Antallet af tilladelser overstiger den tilladte grænse. Fjern venligst tilladelser, indtil du er inden for den tilladte grænse, og prøv igen.',
    'You already have a user. Please login instead':
        'Der findes allerede en bruger tilknyttet denne email. Log venligst ind i stedet',
    'Could not create subscription for you, try close and open the page again':
        'Kunne ikke oprette abonnement, prøv at lukke og åbne siden igen',
    'Could not create the subscription - please try again.':
        'Kunne ikke oprette abonnementet - prøv igen.',
    Payment: 'Betaling',
    'Payment ID': 'Betalings ID',
    'Current status': 'Nuværende status',
    'Payment Amount': 'Betalingsbeløb',
    'Payment history details': 'Betalingshistorikoplysninger',
    'Payment history details Operations':
        'Betalingshistorikoplysninger Operationer',
    'Redirect you to the payment page, do not refresh or go back!':
        'Redirect dig til betalingssiden, opdater eller gå tilbage!',
    'Show Expired': 'Vis inaktive',
    'Please select a company': 'Vælg venligst et firma',
    "Customer's parking lots": 'Kundens parkeringspladser',
    'User Identity': 'Brugeridentitet',
    Identity: 'Identitet',
    'User Identities': 'Brugeridentiteter.',
    'No identities for user': 'Ingen identiteter for brugeren',
    'Fine Details': 'Afgiftsdetaljer',
    'QR Code': 'QR Kode',
    'Parkinglot Id': 'P-plads ID',
    'Parking Lot Information': 'Parkeringsplads oplysninger',
    'Active Parking lots': 'Aktive parkeringspladser',
    'Inactive Parking lots': 'Inaktive parkeringspladser',
    'No parking lot statistics available.': 'Ingen parkeringspladser fundet',
    'No one has commented or changed status yet.':
        'Ingen har kommenteret eller ændret status endnu.',
    'Leave a note on the incident': 'Forlad en note på hændelsen',
    'Update Fines': 'Opdater Afgifter',
    'This will reset the password and email the new password. Do you want to continue?':
        'Dette vil nulstille adgangskoden og e-maile den nye adgangskode. Vil du fortsætte?',
    'Parking Info': 'Parkeringsinfo',
    Organizations: 'Organisationer',
    Organization: 'Organisation',
    'Payout Details': 'Udbetalingsdetaljer',
    'Bank Registration Number': 'Bank registreringsnummer',
    'Bank Account Number': 'Kontonummer',
    '% for parking guard': '% til p-vagt',
    '% for customer': '% til kunde',
    '% for OPARKO': '% til OPARKO',
    '% for operator': '% til operatør',
    'Charge Distributions': 'Afgiftsfordelinger',
    'There are no Parking Lots': 'Der er ikke nogen parkeringspladser',
    'There are no Users': 'Der er ikke nogen brugere',
    'External Organizations': 'Eksterne Organisationer',
    'Select image': 'Vælg billede',
    'Outside booth': 'Udenfor bås',
    'No permit to the parking area': 'Ingen tilladelse til parkeringspladsen',
    'P-disc exceeded': 'P-skive overskredet',
    'Parking or stopping in prohibited area':
        'Parkering eller stop i forbudt område',
    'Parking in fire lane': 'Parkering på brandvej',
    'Handicap booth without permission': 'Handicapbås uden tilladelse',
    "Organization's Parking Lots": 'Organisationens parkeringspladser',
    'Choose Parking bays': 'Vælg parkeringsbåse',
    'Permanent user': 'Permanent bruger',
    'New Permit': 'Ny Tilladelse',
    'Update Permit': 'Opdater Tilladelse',
    'Created for user': 'Oprettet for bruger',
    Notes: 'Noter',
    'Permit Information': 'Tilladelsesoplysninger',
    'Date not assigned': 'Dato ikke tildelt',
    'Note from creation': 'Note fra oprettelsen',
    'Created at': 'Oprettet',
    'Updated at': 'Opdateret',
    'Address ID': 'Adresse ID',
    'Address name': 'Adressenavn',
    'Address Name': 'Adressenavn',
    'Arrival date': 'Ankomstdato',
    'Arrival Date': 'Ankomstdato',
    'Depart. Date': 'Afrejsedato',
    'Depart. date': 'Afrejsedato',
    Camera: 'Kamera',
    'Camera note': 'Kamera note',
    'Other - Leave a note': 'Andet - Lav et notat',
    'Parking time exceeded': 'Parkeringstid overskredet',
    'Total parking time': 'Samlet parkeringstid',
    Approve: 'Godkend',
    Decline: 'Afvis',
    Back: 'Tilbage',
    'Employee Paid Ticket': 'Employee Paid Ticket',
    'Street name': 'Gadenavn',
    'Postal code': 'Postnummer',
    'Fine price': 'Afgiftspris',
    'Profile image': 'Profilbillede',
    'Parking terms': 'Parkeringsbetingelser',
    'No results found': 'Ingen resultater fundet',
    'Buffer time in minutes': 'Buffertid i minutter',
    'New active permits': 'Nye aktive tilladelser',
    'Active permits': 'Aktive tilladelser',
    'Total active permits for the chosen period':
        'Samlet aktive tilladelser for den valgte periode',
    'Daily average for the chosen period':
        'Dagligt gennemsnit for den valgte periode',
    'Month View': 'Måneds Visning',
    'Day View': 'Dags Visning',
    'Duration of permits': 'Tilladelsers varighed',
    selected: 'valgte',
    Distance: 'Afstand',
    'Organization type': 'Organisationstype',
    'Organization address': 'Organisationens adresse',
    'Organization details': 'Organisationsoplysninger',
    'Create Organization': 'Opret Organisation',
    'Create Organisation': 'Opret Organisation',
    'The permit will be made for every parking lot chosen, and based on the users start and end date.':
        'Parkeringstilladelsen vil blive givet for hver valgt parkeringsplads, baseret på brugernes start- og slutdato.',
    'Comment added by': 'Kommentar tilføjet af',
    'Status changed from': 'Status ændret fra',
    'Status changed by': 'Status ændret af',
    'Type changed from': 'Type ændret fra',
    'Start Date changed from': 'Startdato ændret fra',
    'End Date changed from': 'Slutdato ændret fra',
    'Reg. number has been changed to':
        'Registreringsnummeret er blevet ændret til',
    'New parking fee ID:': 'Nyt afgifts ID:',
    'Fine cancelled by': 'Afgift annulleret af',
    'changed from': 'ændret fra',
    'Not defined': 'Ikke defineret',
    'Not Defined': 'Ikke defineret',
    'Self ticketing': 'Egenkontrol',
    Combination: 'Kombination',
    'P-guard': 'P-vagt',
    'Registered before': 'Tidligere registreringer',
    'Send receipt copy': 'Send kopi af kvittering',
    'You already have a user': 'Du har allerede en bruger',
    'Login to purchase an extra subscription':
        'Log ind for at købe et ekstra abonnement',
    'Missing payment in min': 'Manglende betaling i min',
    'Missing payment in days': 'Manglende betaling i dage',
    'Missing price': 'Manglende pris',
    'Open Subscriber': 'Åbn abonnent',
    'Every permit row is clickable and show data in Permit Modal':
        'Hver tilladelsesrække er klikbar og viser data i Permit Modal',
    'Choosing multiple parking lots creates a singular permit for each address selected':
        'Valg af flere parkeringszoner skaber en enkelt tilladelse for hver valgt zone',
    'These rules only affects the permits created from the app, not permits created by admin from Web':
        'Disse regler påvirker kun tilladelser, der er oprettet via appen, ikke tilladelser oprettet af admin via Web',
    'No images to show!': 'Ingen billeder at vise',
    'There has not yet been uploaded any images':
        'Der er endnu ikke blevet uploadet nogle billeder',
    PermitGuestRuleDescription:
        'Maks aktive tilladelser: 0 = ubegrænset. Angiv ellers et tal for maks tilladelser.',
    'Permit length: The maximum number of minutes a permit can be created for':
        'Varighed af tilladelser: 0 = ubegrænset. Angiv ellers det maksimale antal minutter, en tilladelse kan oprettes for',
    Coords: 'Placering',
    'Additional images': 'Flere billeder',
    'Fine rules': 'Kontrol afgift',
    'Permit rules': 'Kontrol tilladelser',
    'Enforcement type': 'Kontroltype',
    'Offense restrictions': 'Forseelsesbegrænsninger',
    'Select which offences can be used on this parking lot.':
        'Vælg hvilke forseelser der kan bruges på denne parkeringsplads.',
    Permitrules: 'Tilladelsesregler',
    'Connected organisations & users': 'Tilknyttede organisationer og brugere',
    'ID generated upon creation': 'ID genereres ved oprettelse',
    'Bank name': 'Bank navn',
    'Bank country': 'Bank land',
    'Billing Email': 'faktureringsmail',
    'Payment frequency': 'Betalingsfrekvens',
    'Agreed by': 'Aftalt af',
    'Agreed on (Date - Start)': 'Aftalt den (Dato - Start)',
    'Agreed on (Date - End)': 'Aftalt den (Dato - Slut)',
    'Connected parking lots & users':
        'Tilknyttede parkeringspladser og brugere',
    'Terms of service': 'Vilkår og betingelser',
    privateLabelSettings: 'Privat label indstillinger',
    privateLabelLogo: 'Privat label logo',
    complaintEmail: 'Klage e-mail',
    'complaints@example.com': 'klager@eksempel.dk',
    complaintPhoneNumber: 'Klage telefonnummer',
    appServiceEmail: 'App service e-mail',
    appServicePhone: 'App service telefon',
    addPhoneHours: 'Tilføj telefontider',
    appSupport: 'App support',
    supportPhoneHours: 'Support telefontider',
    caseportal: 'Sagsportal',
    caseportalUrl: 'Sagsportal URL',
    upload: 'Upload',
    showDeleted: 'Vis slettede',
    counterDataRetention: 'Dataopbevaring',
    counterDataRetentionPeriod: 'Opbevaringsperiode for tællerdata',
    retentionDays30: '30 dage',
    retentionDays60: '60 dage',
    retentionDays90: '90 dage',
    retentionDays180: '180 dage',
    retentionDays365: '1 år (365 dage)',
    retentionDays730: '2 år (730 dage)',
    featureFlags: 'Funktionsflag',
    featureModules: 'Moduler',
    featureSettings: 'Indstillinger',
    featureOthers: 'Andre',
    noFeatureFlagsConfigured: 'Ingen funktionsflag konfigureret',
    featureFlagsAvailableAfterCreate:
        'Funktionsflag kan konfigureres efter organisationen er oprettet. Gem organisationen først, og åbn den igen for at redigere funktionsflag.',
    paymentFrequency: 'Betalingsfrekvens',
    paymentFrequencyMonthly: 'Månedlig',
    paymentFrequencyQuarterly: 'Kvartalsvis',
    paymentFrequencyYearly: 'Årlig',
    feat_others: 'Andre',
    feat_fine: 'Afgifter',
    feat_fine_create: 'Opret afgift',
    feat_fine_update: 'Opdater afgift',
    feat_fine_bulk_change: 'Masseændring',
    feat_fine_cancel: 'Annuller afgift',
    feat_fine_print: 'Udskriv afgift',
    feat_fine_export: 'Eksporter afgifter',
    feat_fine_qr_fine: 'QR-afgift',
    feat_fine_settlement_dates: 'Afviklingsdatoer',
    feat_fine_yolo: 'YOLO',
    feat_permit: 'Tilladelser',
    feat_permit_create: 'Opret tilladelse',
    feat_permit_delete: 'Slet tilladelse',
    feat_permit_export: 'Eksporter tilladelser',
    feat_permit_update: 'Opdater tilladelse',
    feat_permit_types: 'Tilladelsestyper',
    feat_user: 'Brugere',
    feat_user_create: 'Opret bruger',
    feat_user_delete: 'Slet bruger',
    feat_user_update: 'Opdater bruger',
    feat_user_export: 'Eksporter brugere',
    feat_user_access_group_address: 'Adgangsgruppeadresse',
    feat_user_access_group_auth_permissions: 'Adgangsgruppe tilladelser',
    feat_user_access_group_members: 'Adgangsgruppemedlemmer',
    feat_parkinglot: 'Parkeringspladser',
    feat_parkinglot_create: 'Opret parkeringsplads',
    feat_parkinglot_update: 'Opdater parkeringsplads',
    feat_parkinglot_delete: 'Slet parkeringsplads',
    feat_parkinglot_export: 'Eksporter parkeringspladser',
    feat_camera: 'Kameraer',
    feat_camera_create: 'Opret kamera',
    feat_camera_settings: 'Kameraindstillinger',
    feat_camera_scanning: 'Kamerascanning',
    feat_subscription: 'Abonnementer',
    feat_subscription_create: 'Opret abonnement',
    feat_subscription_delete: 'Slet abonnement',
    feat_subscription_export: 'Eksporter abonnementer',
    feat_ticket: 'P-billetter',
    feat_ticket_create: 'Opret p-billet',
    feat_ticket_update: 'Opdater p-billet',
    feat_ticket_delete: 'Slet p-billet',
    feat_organisation: 'Organisation',
    feat_organisation_create: 'Opret organisation',
    feat_organisation_update: 'Opdater organisation',
    feat_finance: 'Økonomi',
    feat_finance_report_create: 'Opret økonomirapport',
    feat_training_module: 'Uddannelsesmodul',
    feat_api_doc: 'API-dokumentation',
    feat_dashboard_statistics: 'Dashboard statistik',
    feat_dashboard_statistics_fine_activity: 'Gebyroverblik',
    feat_dashboard_statistics_oparkogo_activity: 'OparkoGo aktivitet',
    feat_dashboard_statistics_camera_occupancy: 'Kamera belægning',
    feat_dashboard_statistics_active_permits: 'Aktive tilladelser',
    feat_dashboard_statistics_app_activity: 'App aktivitet',
    feat_dashboard_statistics_user_information: 'Brugerinformation',
    feat_dashboard_statistics_parkinglot_information:
        'Parkeringspladsinformation',
    feat_oparkogo: 'OparkoGo',
    feat_public_oparko_link: 'Oparko offentlig link',
    feat_faq: 'FAQ',
    trainingModules: 'Uddannelsesmoduler',
    apiDocumentation: 'API-dokumentation',
    createCamera: 'Opret kamera',
    createFines: 'Opret afgifter',
    bulkChangeFines: 'Masseændring af afgifter',
    createPermits: 'Opret tilladelser',
    parkingInfoOnDashboard: 'Parkeringsinfo på dashboard',
    fineSearchOnDashboard: 'Bødesøgning på dashboard',
    publicPages: 'Offentlige sider',
    mapOfParkingSpaces: 'Kort over parkeringspladser',
    oparkoComLink: 'Oparko.com link',
    standardLoginOnly: 'Kun standard login',
    featureLabels: 'Etiketter',
    permissionsLabel: 'Tilladelsesetiket',
    parkingSpacesLabel: 'Parkeringspladser etiket',
    mapLabel: 'Kort etiket',
    feesLabel: 'Bøder etiket',
    feeActivityLabel: 'Bødeaktivitet etiket',
    availableLanguages: 'Tilgængelige sprog',
    'Expose to different backoffices': 'Eksponer til andre backoffices',
    exposeToBackoffices: 'Gør {{name}} synlig for følgende backoffices',
    'Belongs to backofficeID': 'Tilhører backofficeID',
    'Privacy policy URL': 'Persondatapolitik URL',
    'Complaint E-mail': 'Klage E-mail',
    VAT: 'CVR',
    Both: 'Kombination',
    Collection: 'Efteropkrævning',
    'Collection By Day': 'Indsamling pr. dag',
    'Set to now': 'Sæt til nu',
    'Add spot': 'Tilføj spot',
    'No limit': 'Ingen begrænsning',
    'Subscription rules': 'Abonnementsvilkår',
    'Spot limit': 'Begrænsning',
    'Parking subscription': 'Abonnementsvilkår',
    'Section id': 'Sektions ID',
    'Subscription rule ID': 'Abonnementsvilkår ID',
    'Create multiple permits': 'Opret flere tilladelser',
    'Cancel immediately': 'Annuller straks',
    Skip: 'Spring over',
    Finish: 'Afslut',
    'Backoffice organisations': 'Backoffice organisationer',
    'User Count': 'Antal brugere',
    'Address Count': 'Antal addresser',
    // Finance
    DKK: 'kr.',
    pcs: 'stk',
    k: 't',
    Revenue: 'Omsætning',
    'Paid Permits': 'P-billetter',
    'Coming soon': 'Kommer snart',
    'Total revenue': 'Samlet omsætning',
    totalRevenueSubtitle: 'Samlet omsætning på tværs af alle kilder',
    'Total paid out': 'Samlet udbetalt',
    'Total outstanding': 'Samlet udestående',
    'Revenue sources for permits in DKK':
        'Indtægtskilder for tilladelser i kr.',
    'Permits per parking operator': 'P-billetter pr. parkeringsoperatør i kr.',
    'Number of parking tickets made through each parking operator.':
        'Antal p-billetter og omsætning lavet gennem hver parkeringsoperatør.',
    'Subtext: This shows the economy and the number of parking tickets':
        'Her vises økonomien og antallet af p-billetter for hver parkeringsoperatør på området, så fordelingen af omsætning kan ses i den valgte periode.',
    'You have no permits to show': 'Du har ikke tilladelser at vise',
    'Revenue by type in DKK': 'Omsætningsfordeling',
    'Revenue distribution from the car parks owned by your organisation. The graph visualizes the turnover of the different products offered.':
        'Omsætningsfordeling fra de parkeringspladser, som din organisation ejer. Grafen visualiserer omsætningen for de forskellige produkter der tilbydes.',
    'Fines by status': `Antal afgifter efter status i kr.`,
    fineShares: 'Afgiftsandele',
    'Multiple fines selected': 'Masseændring af afgifter',
    'Number of fines': 'Antal afgifter',
    'Customer share': 'Kundeandel',
    'P-Warden share': 'P-vagt andel',
    'OPARKO share': 'OPARKO andel',
    'Total Price': 'Total beløb',
    Fees: 'Afgifter',
    OpenFees: 'Åbne afgifter',
    PaidFees: 'Betalte afgifter',
    SettledFees: 'Afregnede afgifter',
    CancelledFees: 'Annullerede afgifter',
    'No Records found': 'Ingen resultater',
    financeNoRecordsHint:
        'Prøv at ændre datointerval eller filtre for at se data.',
    'Post collections': 'Efteropkrævninger',
    'Post collection': 'Efteropkrævninger',
    'Distribution key': 'Fordelingsnøgle',
    'Camera fees': 'Kameraafgifter',
    'Parking permit sales': 'P-billetter',
    'Guard fees': 'Vagtafgifter',
    'Subscription sales': 'Abonnementsalg',
    'Self-ticketing fees': 'Egenkontrol',
    'Active: status explained':
        'Aktiv: En afgift, der er blevet oprettet, men stadig er under behandling',
    'Cancelled: status explained':
        'Annulleret: Afgifter som er annulleret af jer eller OPARKO',
    'Paid: status explained': 'Betalt: Afgiften er betalt til OPARKO',
    'Settled: status explained': 'Afregnet: Afgiften er betalt til kunden',
    'Protected: status explained':
        'Beskyttet: Afgiften er midlertidigt sat på pause',
    'Debt collection/Collectia: status explained':
        'Inddrivelse: Gældsinddrivelsen er i gang ved OPARKOs inkassoselskab',
    Earning: 'Indtjening',
    Payout: 'Udbetaling',
    Invoice: 'Faktura',
    'Report date': 'Rapport dato',
    finance_revenue_barchart:
        'Omsætning i kr. pr. måned for indeværende år opdelt efter omsætningstype',

    revenue_by_type_explanation:
        'Omsætningsfordeling fra de abonnemnter, som din organisation tilbyder. Grafen visualiserer omsætningen for de forskellige abonnementsprodukter der tilbydes.',
    'reveneue_sub_text_sub: abo':
        'Her fremvises økonomien og antallet af abonnementer for hver tjenesteudbyder i området, således at fordelingen af indtægter kan observeres i den valgte periode.',
    'Fines: Every fine that is paid or settled':
        'Afgifter: Alle afgifter der er betalt eller afregnet',
    'Permits: Every permit that is paid':
        'P-billetter: Alle P-billetter der er betalt',
    'Subscriptions: Every payment on all subscriptions':
        'Abonnementer: Alle betalinger på alle abonnementer',
    post_collection_explanation: `Efteropkrævning: Beregnes som 'indsamlingsgebyr' + 'pris pr. time' * 'timer parkeret mere end tilladt' og er en ekstra afgift til parkerede personer, der har parkeret længere end deres tilladelser tillod dem, og fungerer som et alternativ til parkeringsafgifter.`,

    permit_revenue_sources_explanation:
        'Indtægtsbeløbet i kr, som er foretaget på tilladelser for hver parkeringsoperatør.',
    number_of_permits_per_parking_operator_explained:
        'Mængden af tilladelser der er blevet lavet af hver parkeringsoperatør.',

    fine_status_distribution_explanation:
        'Den procentvise fordeling af afgiftsstatusser.',
    'Please wait, your data is being prepared...':
        'Vent venligst, dine data forberedes...',
    'ex-VAT': 'ekskl. moms',
    Unit: 'Enhed',
    Pages: 'Sider',
    Number: 'Antal',
    Amount: 'Beløb',
    'Service and operation of camera system':
        'Service og drift af kamerasystem',
    'Batch Run Reports': 'Kør rapporter i batch',
    "Cannot send invoice while there's a pending report for earlier period":
        'Kan ikke sende faktura, mens der er en afventende rapport for en tidligere periode',
    'Last Batch Run': 'Sidste batchkørsel',
    // Statistic
    fee_search: 'Gammel App',
    fine_search: 'App - afgift oprettet',
    permit_search: 'App - tilladelse oprettet',
    permit_created: 'App - tilladelse oprettet',
    scanner_used: 'App - scanner brugt',
    'Shows a graph of app events for multiple days, sorted by hours.':
        'Viser en graf over app-hændelser for flere dage, sorteret efter timer.',
    'Shows a graph of app events, sorted by dates.':
        'Viser en graf over app-hændelser, sorteret efter datoer.',
    'The use of the old app.': '- Brugen af den gamle app.',
    'Creation of permits in the oparko app.':
        '- Oprettelse af tilladelser i oparko-appen.',
    'Creation of Fines in the oparko app':
        '- Oprettelse af afgifter i oparko-appen.',
    'Scanning of license plates in the oparko app.':
        '- Scanning af nummerplader i oparko-appen.',
    'Permits and Subscriptions per month':
        'Præsenterer månedlige tilladelser, abonnementer og P-billetter, som har været aktiv i denne periode, med en detaljeret opgørelse af, hvad hver enkelt organisation har registreret i den pågældende periode.',
    'Show Day Graph Date': 'Vis graf data i dage',
    'Occupancy by permits': 'Beskæftigelse efter tilladelser',
    'Total parking spots': 'Samlet antal parkeringsbåse',

    'Permits: Shows the amount of permits by period. If more than one week is chosen, the sum of all weeks will be shown on a give period on a weekday.':
        'Tilladelser: Viser antal tilladelser pr. periode. Hvis mere end en uge er valgt vil antallet af tilladelser gældende på hver hverdag blive lagt sammen',
    'Total parking spots: Shows the total amount of parking spots':
        'Samlet antal parkeringsbåse: Viser det samlede antal parkeringsbåse',
    'Average hourly occupancy over the selected period.':
        'Gennemsnitlig timebelægning i den valgte periode',
    'Average daily occupancy over the selected period.':
        'Gennemsnitlig dagsbelægning i den valgte periode.',
    'Average monthly occupancy over the selected period.':
        'Gennemsnitlig månedsbelægning i den valgte periode.',
    'Average for the chosen period': 'Gennemsnit for den valgte periode',
    'Fines for the chosen period': 'Gebyrer for den valgte periode',
    'Average fines per day': 'Gennemsnitlige gebyrer pr. dag',
    Occupancy: 'Gennemsnit',
    'Highest Occupancy': 'Højeste',
    'Lowest Occupancy': 'Laveste',
    'Highest avg for the days in the period.':
        '- Højeste procent for dagene i perioden.',
    'Lowest avg for the days in the period.':
        '- Laveste procent for dagene i perioden.',
    'Avg for the days in the period.': '- Gennemsnit for dagene i perioden.',
    'Show Spot Scan': 'Viser pletscanning',
    'Show Camera Scan': 'Viser kamerascanning',
    no_permit: 'Ingen tilladelse',
    permit: 'Tilladelse',
    ticket: 'P-billet',
    subscription: 'Abonnement',
    'Too many organisations selected': 'For mange organisationer valgt',
    'Can not generate report for the selected parking lots.':
        'Kan ikke generere rapport for de valgte parkeringspladser.',
    'Can not generate report for the selected organisations.':
        'Kan ikke generere rapport for de valgte organisationer.',

    Average: 'Gennemsnit',
    Highest: 'Højeste',
    Lowest: 'Laveste',
    'Hourly camera activity count': 'Kameraaktivitet pr. time',
    'Daily camera activity count': 'Kameraaktivitet pr. dag',
    'Camera activity': 'Kameraaktivitet',
    'App activity': 'App aktivitet',
    Arrivals: 'Ankomster',
    Departures: 'Afgange',
    'Show only fine activity': 'Vis kun afgiftsaktivitet',
    'Hourly app activity count': 'App aktivitet pr. time',
    'Daily app activity count': 'App aktivitet pr. dag',
    Scanner: 'Scanner',
    'Fine created': 'Afgift oprettet',

    // Date Picker
    Between: 'Imellem',
    From: 'Fra',
    To: 'Til',
    Period: 'Periode',
    Max: 'Maks antal',
    Min: 'Minimum antal',
    Prior: 'Før',
    Custom: 'Tilpas',
    Today: 'Idag',
    'Since Yesterday': 'Efter igår',
    'This Week': 'Denne uge',
    Anytime: 'Enhver tid',
    'Last month': 'Sidste md',
    'Last 3 months': 'Sidste 3 mdr',
    'Last 12 months': 'Sidste 12 mdr',
    'Start Date cannot be after End Date':
        'Startdato kan ikke være efter slutdato',
    'Date cannot be after today': 'Dato må ikke være efter i dag',
    Ticket_Rule: 'Tilladelse Regel',
    Rule_sets: 'Regelsæt',
    Details: 'Detaljer',
    InformationGuide: 'Informationsguide',
    RuleSetsDescription:
        "Under 'Regelsæt' kan du definere unikke billetregler. Du kan lave så mange, som du har brug for:",
    PickDays: 'Vælg hvilke dage reglerne gælder for',
    PickTime: 'Vælg tidspunktet på dagen',
    PickUnit:
        'Vælg enheden efterfulgt af "minimum" og "maksimum" antal timer/dage, der kan købes med denne regel',

    // Table Values
    company: 'selskab',
    private: 'privat',
    Inactive: 'Inaktiv',
    Active: 'Aktiv',
    Paid: 'Betalt',
    'Not paid': 'Ikke betalt',
    'Paid ': 'Betalt',
    Settled: 'Afregnet',
    'Settled ': 'Afregnet',
    Hidden: 'Annulleret',
    'Hidden ': 'Annulleret',
    Cancelled: 'Annulleret',
    Protected: 'Beskyttet',
    'Protected ': 'Beskyttet',
    'Guest parking': 'Gæsteparkering',
    Ticket: 'Billet',
    'Paid Ticket': 'Betalt billet',
    'Only for backoffice': 'Kun for backoffice',
    'Editable permit': 'Redigerbar tilladelse',
    Employee: 'Medarbejder',
    'Permanent permit': 'Permanent tilladelse',
    'Debt collection': 'Inddrivelse',
    Collectia: 'Collectia',
    'Active - handled manually': 'Aktiv - håndteres manuelt',
    'Active - Manuel': 'Aktiv - manuel',
    'Active - System': 'Aktivt - system',
    'Under - Recovery': 'Under inddrivelse',
    'Settled with parking guard': 'Afregnet med P vagt',
    'Cancelled - Pending approval': 'Annulleret - Afventer godkendelse',
    'Fine Exported': 'Afgift eksporteret',
    'Export Failed': 'Eksport fejlet',
    'Time Frame': 'Tidsramme',
    'Create Permit Reason': 'Opret Begrundelse',
    permitTypes: 'Tilladelsestyper',
    createPermitType: 'Opret Tilladelsestype',
    approval: 'Godkendt',
    neutral: 'Neutral',
    disapproved: 'Ikke godkendt',
    approved: 'Godkendt',
    nameEnglish: 'Navn (Engelsk)',
    keyValues: 'Nøgleværdier',
    lookupInfo: 'Opslagsinfo',
    lookupTitle: 'Opslagstitel',
    regnoEditable: 'Regnr. redigerbar',
    confirmDelete: 'Bekræft sletning',
    None: 'Ingen',
    'Multi Select': 'Vælg Flere',
    'QR App Fine': 'QR App Afgift',
    'Print App Fine': 'Print App Afgift',
    'Send App Fine': 'Send App Afgift',
    'Camera Fine': 'Kamera Afgift',
    'Camera Collection': 'Kamera efteropkrævning',
    'Camera Collection By Day': 'Efteropkrævninger - døgnparkering',
    Parent: 'Overordnet zone',
    'Parent ID': 'Overordnet ID',
    PaymentZone: 'Betalings zone',
    ResidentZone: 'Beboer zone',
    FlexParkingZone: 'Flex Parkeringszone',
    ResidentStreetsZone: 'Beboergade zone',
    PatrolArea: 'Patrulje Område',
    'addressTypeName.parkingLot': 'Parkeringsplads',
    'addressTypeName.group': 'Gruppe/Parent',
    'addressTypeName.parkingSpot': 'Parkeringsbås',
    'addressTypeName.test': 'Test',
    'addressTypeName.paymentZone': 'Betalingszone',
    'addressTypeName.residentZone': 'Beboerzone',
    'addressTypeName.flexParkingZone': 'Flexparkeringszone',
    'addressTypeName.residentStreetsZone': 'Beboergadezone',
    'addressTypeName.patrolArea': 'Patruljeområde',
    showPatrolAreas: 'Vis Patrulje Områder',
    showParkingZones: 'Vis Parkeringszoner',
    addressType: 'Adressetype',
    'Show street name in app': 'Vis gadenavn i app',
    'Clean Fine Reasons': 'Afbrydelsesårsag',
    'Create Clean Fine Reasons': 'Opret Afbrydelsesårsag',
    'Permit Limits': 'Maks. Tilladelser',
    'Wrong Doings': 'Forseelser',
    'Create Wrong Doing': 'Opret Forseelse',
    'Wrong Doing Details': 'Forseelses Detaljer',
    Translations: 'Oversættelser',
    Actions: 'Handlinger',
    'Add translation...': 'Tilføj oversættelse...',
    'Removal Reason': 'Fjernelsesårsag',
    'Cleaning Fine Reason Details': 'Detaljer for frafaldsårsag',
    'Add Key-Value': 'Tilføj Nøglepar',
    Key: 'Nøgle',
    Value: 'Værdi',
    'Remove Key-Value': 'Fjern Nøglepar',
    'Add New Value': 'Tilføj ny værdi',
    'Print Template': 'Print Skabelon',
    Parking_status: 'Parkeringsstatus',
    Applies_to: 'Gælder for',
    Show_in_app: 'Vis i app fine listen',
    Can_cancel: 'Muligt at annulere i platform',
    Can_pay: 'Muligt at betale',
    Can_see_documentation: 'Kan se dokumentation',
    Public_message: 'Offentlig besked',
    Public_message_placeholder: 'Besked til borgeren (valgfri)',
    Alias_of: 'Alias af',
    Show_in_app_graph: 'Vis i app grafer',
    Graph_type_fee: 'Afgift',
    Graph_type_cancelled: 'Annulleret',
    Graph_type_hidden: 'Skjult',
    'Print Templates': 'Print Skabeloner',
    'Create Template': 'Opret Skabelon',
    'Fine Print Templates': 'Print Skabeloner',
    'Last Updated': 'Senest Opdateret',
    'Filter organsisations by name or id':
        'Filter organisationer efter navn eller id',
    'Select own organisation': 'Vælg egen organisation',
    userShiftTitle: 'Vagter',
    userShiftActiveUsersInPeriod: 'Aktive brugere i perioden',
    userShiftSelectDateRangePrompt:
        'Vælg en datoperiode og klik på Søg for at se vagtaktivitet.',
    userShiftLoadFailedMessage: 'Kunne ikke indlæse vagtaktivitet. Prøv igen.',
    userShiftModeTooltip:
        'Oversigt viser aktivitet for hele organisationen. P-vagter viser heatmaps per bruger.',
    userShiftReportDownloadedSuccessfully: 'Rapport downloadet.',
    userShiftReportTruncatedMaxRows:
        'Rapporten blev afkortet, fordi den overskred den maksimale rækkegrænse.',
    userShiftActiveDays: 'Aktive dage',
    userShiftEventsInPeriod: 'Hændelser for den valgte periode',
    userShiftAvgPerDay: 'Hændelser pr. dag',
    userShiftAvgEventsPerDay: 'Gennemsnitlige pr. dag',
    userShiftMostLeastActive: 'Mest / mindst aktiv',
    userShiftPeakActiveWardens: 'Flest aktive vagter',
    events: 'hændelser',
    Less: 'Mindre',
    userShiftMoreEvents: 'Flere hændelser',
    userShiftPatrolEvents: 'Patruljehændelser',
    userShiftPatrolEventsHint: 'Afgifter, tilladelser og scanninger på vagt',
    userShiftTotalPatrolEvents: 'Patruljehændelser i alt',
    userShiftActiveTime: 'Aktiv tid',
    userShiftActiveTimeHint: 'Tid mellem første og sidste patruljehændelse',
    userShiftActiveLessThanMinute: '< 1 min',
    userShiftWardensOnShift: 'P-vagter på vagt',
    userShiftUserDaysActive: 'Aktive dage',
    userShiftLastActive: 'Sidst aktiv',
    userShiftNoActivityDash: '—',
    userShiftTopActiveUsersNote:
        'Bemærk: Uden brugervalg vises de 10 mest aktive brugere som standard.',
    Shift: 'Vagter',
    userShiftNoActivityFoundForPeriod: 'Ingen aktivitet fundet',
    userShiftShowPWardens: 'Vis P-vagter',
    userShiftShowPWardensCount: 'Vis {{count}} P-vagter',
    userShiftShowingPWardens: 'Viser {{shown}} ud af {{total}} P-vagter',
    userShiftPwardensDescription:
        'P-vagter er parkeringskontrollanter. Slå til for at se individuelle heatmaps pr. betjent i stedet for organisationsoversigten.',
    userShiftPwardensModeActive: 'Brugervisning',
    userShiftSortBy: 'Sortér efter',
    userShiftSortByEvents: 'Antal hændelser',
    userShiftSortByName: 'Navn',
    userShiftSortByLastActive: 'Sidst aktiv',
    'Notification Templates': 'Notifikation Skabeloner',
    'Notification Template': 'Notifikation Skabelon',
    Resource: 'Ressource',
    'Enter body content': 'Indtast besked',
    'Enter title': 'Indtast titel',
    'Mobile Preview': 'Mobil Visning',
    'Economic Invoice Period': 'Economic Fakura Periode',
    '% to Customer': '% til kunde',
    '% to Oparko': '% til Oparko',
    'Cancellations of fines': 'Annullering af afgifter',
    'Total subscription': 'Total',
    Summary: 'Oversigt',
    'OPARKO cut': 'OPARKOs andel',
    'Customer cut': 'Kundens andel',
    Org: 'Org',
    ORG: 'ORG',
    'Org mail': 'Org mail',
    'Org account info': 'Org kontooplysninger',
    'Org ecn': 'Org ecn',
    'Economic department ID': 'Økonomi afdeling ID',
    'Grouped addresses': 'Grupperede adresser',
    'Invoice created by': 'Faktura oprettet af',
    'Invoice sent date': 'Faktura afsendelsesdato',
    'Due date (Days added to sent date)':
        'Forfaldsdato (dage tilføjet til afsendelsesdato)',
    Reject: 'Afvis',
    'Park Time': 'Park. Tid',
    'Create Settings': 'Opret Indstillinger',
    number: 'nummer',
    'Camera Count': 'Antal Kamera',
    'General Information': 'General Info',
    'Gateway Address Id': 'Adresse Forbindelse ID',
    'Multiple Addresses': 'Flere Adresser',
    'Pause Start': 'Pause Start',
    'Pause End': 'Pause Slut',
    'Pause Camera': 'Pause Kamera',
    'Gateway Control': 'Port kontrol',
    'Check on Exit Only': 'Tjek kun ved udkørsel',
    'Stream and scans': 'Stream og scanninger',
    'Start Preview': 'Start forhåndsvisning',
    'Detection Zone': 'Detektionszone',
    'Entrance Overlay': 'Indkørsels overlay',
    'Exit Overlay': 'Udkørsels overlay',
    'Detection & Placement Settings':
        'Registrering- og placeringsindstillinger',
    'Shared Settings': 'Delte Indstillinger',
    'Update Camera Setting': 'Opdater Kameraindstillinger',
    'New Camera Setting': 'Nye Kameraindstillinger',
    'Generates Camerafines': 'Opretter Kameraafgifter',
    'EasyPark Auto Enabled': 'EasyPark Auto Aktiveret',
    'Enable "Park now, pay later"': 'Aktiver "Park now, pay later"',
    'Skip Fine for Reception Permits': 'Spring over Reception Tilladelser',
    '(if permit valid between entry and exit)':
        '(hvis tilladelsen er aktiv imellem ind- og udkørsel',
    'Minimum Park Time (s)': 'Minimum Park. Tid (s)',
    'Oparko Go Minimum Park Time (s)': 'Oparko Go Min. Parkeringstid (s)',
    'Max Park Time': 'Maksimum Park. Tid (s)',
    'Buffer Percentage': 'Buffer Procent',
    'Buffer Time (s)': 'Buffer tid (s)',
    'Entrance Angle': 'Vinkel for indkørsel',
    'Entrance Tolerance': 'Indkørsels tolerance',
    'Exit Angle': 'Vinkel for udkørsel',
    'Exit Tolerance': 'Udkørsels tolerance',
    Apply: 'Anvend',
    'Connection Information': 'Forbindelsesinfo',
    'Last Sync Date': 'Sidste Sync. Dato',
    'Camera Scan List': 'Kamerascanningsliste',
    'Camera Fine ID': 'Kameraafgift Id',
    'Camera Name': 'Kameranavn',
    'Other Reg. No. List': 'Andre Reg. Nr. Liste',
    'Handle Camera Scan': 'Håndter Kamerascan',
    'Registration Number': 'Registreringsnummer',
    'Other Registration Numbers': 'Andre Registreringsnummer',
    'No other registration numbers': 'Ingen andre Registreringsnumre',
    'Scan Time': 'Scan Tid',
    'Scan Direction': 'Retning',
    'Address Details': 'Adressedetaljer',
    'Camera Details': 'Kameradetaljer',
    'Camera ID': 'Kamera ID',
    'External Camera ID': 'Ekstern Kamera ID',
    'Using the API': 'Brug af API',
    Groups: 'Grupper',
    'User Settings': 'Brugerindstillinger',

    // Validation
    'Issues: ': `Problemer: `,

    'no Name chosen, ': 'ingen Navn valgt, ',
    'no Organization chosen, ': 'ingen Organisation valgt, ',
    'no Street Name chosen, ': 'ingen Vej Navn valgt, ',
    'no Street Number chosen, ': 'ingen Vej Nummer valgt, ',
    'no Postal Code chosen, ': 'ingen By Nummer valgt, ',
    'no City chosen, ': 'ingen By valgt, ',
    'no Latitude chosen, ': 'Ingen Breddegrad valgt, ',
    'Latitude must be above -90, ': 'Breddegrad skal være over -90, ',
    'Latitude must be below 90, ': 'Breddegrad skal være under 90, ',
    'no Longitude chosen, ': 'ingen Længdegrad valgt, ',
    'Longitude must be above -90, ': 'Længdegrad skal være over -90, ',
    'Longitude must be below 90, ': 'Længdegrad skal være under 90, ',
    'no type chosen, ': 'ingen Type valgt, ',
    'parking terms do not accept more than 255 character':
        'parkeringsbetingelser accepterer ikke mere end 255 tegn',

    Reset: 'Nulstil',
    'Accept our terms': 'Accepter vores vilkår',
    'Enter your registration no.': 'Indtast dit registreringsnr.',
    'Indtast dit fulde navn': 'Indtast dit fulde navn',
    'phone number': 'telefonnummer',
    email: 'e-mail',
    'Enter e-mail': 'Indtast e-mail',
    'then press ok': 'og tryk derefter på opret',
    'Your permit ends': 'Din tilladelse gælder',
    'by today 23:59': 'til i dag 23:59',
    'by the chosen date 23:59': 'for den valgte dato indtil 23:59',
    after: 'efter ',
    'after the creation': 'efter oprettelse',
    minutes: 'minutter',
    and: 'og',
    until: 'indtil',
    'ends in': 'i ',
    "Not Found Error: It's not allowed to buy a ticket with the time unit provided":
        'Det er ikke muligt at købe en billet med den angivne tidsenhed. Tjek venligst de gældende regler og prøv igen.',
    'An error occurred, please try again':
        'Der opstod en fejl, prøv venligst igen',

    'Reg. no.': 'Reg. nr.',
    'Phone number': 'Telefonnummer',
    Subscription_percentage_not_within_range: `Abonnement '% til OPARKO' skal være i intervallet 0% til 100%`,
    Permit_percentage_not_within_range: `Tilladelse '% til OPARKO' skal være i intervallet 0% til 100%`,
    Camera_control_percentage_not_within_range: `Kamerakontrol '% til OPARKO' skal være i intervallet 0% til 100%`,
    Selfticketing_percentage_not_within_range: `Selvbilletering '% til OPARKO' skal være i intervallet 0% til 100%`,
    Guard_control_percentage_not_within_range: `P-vagtskontrol '% til OPARKO' skal være i intervallet 0% til 100%`,
    authenticationFailed: 'Login fejlede. Prøv venligst igen.',
    'validation.statusMissing': 'Vælg venligst en status.',
    'validation.belongsToMissing': 'Vælg venligst den bruger, det tilhører.',
    'validation.typeMissing': 'Vælg venligst en tilladelsestype.',
    'validation.noVehicles': 'Tilføj venligst mindst ét køretøj.',
    'validation.missingCountryCode': 'Vælg venligst en landekode.',
    'validation.invalidRegNo':
        'Indtast venligst et gyldigt registreringsnummer.',
    'validation.noParkingLot': 'Vælg venligst en parkeringsplads.',
    'validation.noEmail': 'Indtast venligst en e-mailadresse.',
    'validation.endDateRequired':
        'Angiv venligst en slutdato, eller markér tilladelsen som permanent.',
    'validation.endDateTooOld': 'Indtast venligst en slutdato efter 1970.',
    'validation.endBeforeStart': 'Slutdato skal være på eller efter startdato.',
    'validation.startDateTooOld': 'Vælg venligst en startdato.',
    'validation.invalidTimeRule': 'Indtast venligst en startdato efter 1970.',
    'validation.startDateEmpty': 'Vælg venligst en startdato.',
    'validation.endDateEmpty': 'Vælg venligst en slutdato.',
    'validation.endAfterStart': 'Slutdato skal være efter startdato.',
    'validation.missingAddress': 'Vælg venligst en adresse.',
    'validation.missingOffence': 'Vælg venligst en årsag.',
    'validation.minImages': 'Upload venligst mindst 2 billeder.',
    'validation.noFineOrigin': 'Vælg venligst en afgiftstype.',
    'validation.missingPayment': 'Udfyld venligst betalingsfeltet.',
    'validation.regNoEmpty': 'Indtast venligst et registreringsnummer.',
    'validation.dateEmpty': 'Vælg venligst en dato.',
    'validation.noAddress': 'Vælg venligst en adresse.',
    'validation.updateAtLeastOne': 'Opdater venligst mindst én værdi.',
    'validation.cancelReasonMinLength':
        'Angiv venligst en annulleringsårsag på mindst 20 tegn.',
    'validation.noNameChosen': 'Indtast venligst et navn.',
    'validation.noEmailChosen': 'Indtast venligst en e-mailadresse.',
    'validation.noOrganisationTypeChosen':
        'Vælg venligst en organisationstype.',
    'validation.noStreetNameChosen': 'Indtast venligst et gadenavn.',
    'validation.noStreetNumberChosen': 'Indtast venligst et husnummer.',
    'validation.missingZipcode': 'Indtast venligst et postnummer.',
    'validation.missingCity': 'Indtast venligst en by.',
    'validation.startDateBeforeToday': 'Startdato kan ikke være i fortiden.',
    'validation.noUsernameChosen': 'Indtast venligst et brugernavn.',
    'validation.organisationNotChosen': 'Vælg venligst en organisation.',
    'validation.startDateNotChosen': 'Vælg venligst en startdato.',
    'validation.endDateNotChosen': 'Vælg venligst en slutdato.',
    'validation.parkinglotNotChosen': 'Vælg venligst en parkeringsplads.',
    'validation.apiUserOnly':
        'Giv venligst brugeren adgang til mindst én af API, App eller Hjemmeside.',
    'validation.rulesNotChosen': 'Vælg venligst regler og indstillinger.',
    'validation.permitRegNoNotChosen': 'Vælg venligst en tilladelsestype.',
    'validation.selectAtLeastOnePermission':
        'Vælg venligst mindst én tilladelse, før du fortsætter.',
    Rule: 'Regel',
    'validation.nameRequired': 'Indtast venligst et navn.',
    'validation.maxPermitsNegative':
        'Maksimalt antal aktive tilladelser kan ikke være negativt.',
    'validation.durationNegative': 'Varighed kan ikke være negativ.',
    'validation.parkingLotRequired': 'Vælg venligst mindst én parkeringsplads.',
    'validation.requiredFields': 'Udfyld venligst alle påkrævede felter.',
    'validation.invalidAddress': 'Vælg venligst en gyldig adresse.',
    'validation.pauseTimesMissing':
        'Angiv venligst både start- og sluttidspunkt for pausen.',
    'validation.pauseStartAfterEnd':
        'Pausens starttidspunkt skal være før sluttidspunktet.',
    'validation.failedSave':
        'Kameraindstillingerne kunne ikke gemmes. Prøv venligst igen.',
    'validation.updated': 'Kameraindstillinger opdateret.',
    'validation.failedCreate':
        'Kameraindstillingen kunne ikke oprettes. Prøv venligst igen.',
    'validation.created': 'Kameraindstillinger oprettet.',
    'validation.invalidUrl':
        'Indtast venligst en gyldig URL (f.eks. https://example.com).',

    // Ticket Service validation
    'must be a positive integer': 'skal være et positivt heltal',
    'Reg. no. have not been specified': 'Reg. nr. er ikke angivet',
    'E-mail has not been specified': 'E-mail er ikke angivet',
    'Terms and conditions must be accepted':
        'Vilkår og betingelser er ikke accepteret',
    Issues: 'Problemer',

    // Status page
    'Status Overview': 'Status Oversigt',
    'Could not load status data.': 'Statusdata kunne ikke hentes.',
    'Open status page': 'Åbn statusside',
    'All Systems Operational': 'Alle systemer kører',
    'Service Disruption': 'Serviceforstyrrelser',
    'Active Services': 'Aktive tjenester',
    'Inactive Services': 'Inaktive tjenester',
    'uptime over 30 days': 'oppetid over 30 dage',
    Statuspage: 'Status',

    // Act as user
    'Take Over': 'Overtag bruger',

    // ### UPDATED TERMS ###
    'Privacy policy': 'Persondatapolitik',
    'Trade policy': 'Handelspolitik',
    'Company info': 'Virksomhedsoplysninger',
    'Terms and conditions': 'Vilkår og betingelser',
    '"Parking provider" - Will refer to the company above throughout the policy.':
        '"parking provider" - Vil henvise til virksomheden ovenfor i hele politikken.',
    Last_updated: 'Opdateringsdato',
    updated_at_description:
        'Denne politik er gældende fra ovenstående dato. Ved ændringer vil den nye version blive offentliggjort på denne side, og relevante registrerede vil modtage meddelelse om opdateringen',
    // ### Persondatapolitik indhold ###
    // --- 1. Indledning
    Terms_main_point_1: {
        main_title: 'Indledning ',
        sub_point_1:
            ' I denne privatlivspolitik (”Politikken”) beskrives, hvordan parking provider (”os”, ”vi” eller ”vores”) indsamler og behandler personoplysninger, når du parkerer via vores parkeringsarealer, herunder vores ANPR-pladser, køb af vores services og produkter, generel brug af vores hjemmesider eller anden serviceapplikation samt andre medier kontrolleret af os.  ',
        sub_point_2:
            'Politikken er formuleret og gjort tilgængelig for at overholde databeskyttelsesforordningen (2016/679 of 27. april 2016) (”GDPR”) og reglerne heri om oplysningspligt.',
    },
    // --- 2. Typer af personoplysninger som behandles
    Terms_main_point_2: {
        main_title: 'Typer af personoplysninger som behandles',
        sub_point_1: {
            sub_point_1_title:
                'Vi behandler personoplysninger om dig, når dette er relevant og i overensstemmelse med gældende lovgivning. Alt efter de konkrete omstændigheder kan de behandlede personoplysninger omfatte følgende typer af personoplysninger:',
            sub_point_1_1: 'a) navn  ',
            sub_point_1_2: 'b) adresse  ',
            sub_point_1_3: 'c) telefonnummer  ',
            sub_point_1_4: 'd) e-mail  ',
            sub_point_1_5: 'e) brugernavn  ',
            sub_point_1_6: 'f) adgangskode  ',
            sub_point_1_7: 'g) købshistorik  ',
            sub_point_1_8: 'h) fakturerings- og bogføringsbilag  ',
            sub_point_1_9: 'i) regning status (saldo, kundepoint el.)  ',
            sub_point_1_10: 'j) kreditkortoplysninger  ',
            sub_point_1_11:
                'k) bankoplysninger (kortoplysninger eller kontooplysninger)  ',
        },
        sub_point_2: {
            sub_point_2_title: 'Registreringsnummer ',
            sub_point_2_1:
                'Vi behandler derudover oplysninger i forbindelse med udførelsen af vores parkeringskontrol, eller når du indtaster disse oplysninger ved registrering og parkering via vores sites og apps, når du tilmelder dig som ”fast bruger” eller i øvrigt bruger vores ANPR-pladser, samt når du henvender dig vedrørende et eventuelt pålagt kontrolgebyr.',
            sub_point_2_2:
                'Derudover foretages der TV-overvågning på visse af vores parkeringsanlæg. Såfremt, der foretages TV-overvågning vil der være skiltet med dette ved indkørsel til pladsen.',
        },
        sub_point_3: {
            sub_point_3_1:
                'Vi indsamler personoplysninger direkte fra dig og, hvor det er relevant, fra eksterne kilder. ',
            sub_point_3_2:
                'Vi indsamler som udgangspunkt personoplysningerne direkte hos dig, men vi kan også indsamle oplysninger fra blandt andet offentlige myndigheder, uddannelsessteder, arbejdsgivere, og indsamlingskilden varierer derfor.',
        },
        sub_point_4:
            'Hvis vi får brug for at indsamle og behandle yderligere personoplysninger end angivet ovenfor, vil vi orientere herom ved indsamlingen. Sådan oplysning kan også ske ved opdatering af denne Politik.',
    },
    // --- 3. Særligt for brugere
    Terms_main_point_3: {
        main_title: 'Særligt for brugere',
        sub_point_1: {
            sub_point_1_title: 'Indsamling af oplysninger',
            sub_point_1_1:
                'Ved Brugerens anvendelse af parking provider tjenester, samtykker Brugeren samtidigt i, at parking provider indsamler og behandler de af Brugeren opgivne personoplysninger og persondata i overensstemmelse med parking provider gældende datapolitik.',
            sub_point_1_2:
                'Personlige data opbevares kun, hvis de er frivilligt oplyst, og kun så længe, som de er relevante for parking provider. De pågældende data opbevares på parking provider interne netværk og kan kun tilgås med specielle rettigheder.',
        },
        sub_point_2: {
            sub_point_2_title: 'Brugerens pligter',
            sub_point_2_1:
                'Ved brugerens opgivelse af oplysninger om en anden, indestår Brugeren for, at denne har retten til at give oplysningerne til parking provider.',
        },
        sub_point_3: {
            sub_point_3_title: 'Flytning af data',
            sub_point_3_1:
                'Brugeren accepterer, at såfremt parking provider finder det nødvendigt at flytte brugerens oplysninger til en anden platform, oprettet med samme formål som indeholdt i nærværende aftale, sker dette uden forudgående meddelelse og i overensstemmelse med gældende databeskyttelsesretlige regler.',
        },
        sub_point_4:
            'BEMÆRK, at Brugeren har pligt til at holde de i parking provider registrerede oplysninger ajourført. Dvs. Brugeren skal give parking provider besked om, hvis der sker ændring i adresse, e-mail mv. eller evt. registreringsnummer på det køretøj, der skal benyttes i parking provider. Såfremt dette ikke efterkommes, er parking provider berettiget til at slette de allerede registrerede oplysninger og ophæve abonnementsparkeringsaftale for at overholde den gældende persondatalovgivning. ',
    },
    // --- 4. Formål med behandlingen af personoplysninger
    Terms_main_point_4: {
        main_title: 'Typer af personoplysninger som behandles',
        sub_point_1: {
            sub_point_1_title:
                'Vi behandler kun dine personoplysninger, såfremt vi har et legitimt formål og i så fald i overensstemmelse med reglerne i GDPR. Personoplysningerne kan alt efter omstændighederne behandles til følgende formål:',
            sub_point_1_1:
                'a) At kommunikere med og udveksle oplysninger med offentlige myndigheder, hvor loven kræver dette.  ',
            sub_point_1_2:
                'b) For at forhindre svindel og bedrageri eller uretmæssig brug af vores produkter, ydelser og hjemmeside, herunder behandling af personoplysninger til brug i forbindelse med søgsmål.  ',
            sub_point_1_3: 'c) At sende nyhedsbreve via e-mail.  ',
            sub_point_1_4:
                'd) For at forbedre vores produkter, ydelser eller hjemmeside.  ',
            sub_point_1_5:
                'e) For at opbevare personoplysninger i det omfang, det er et krav i henhold til gældende lovgivning, eksempelvis opbevaring af regnskabs- og bogholderibilag.  ',
            sub_point_1_6:
                'f) For at kunne levere eller tilbyde ydelser eller produkter brugere, kunder eller medlemmer.  ',
            sub_point_1_7:
                'g) At besvare forespørgsler og/eller klager fra brugere, kunder eller medlemmer.  ',
            sub_point_1_8:
                'h) At sende direkte markedsføring til brugere, kunder eller medlemmer (såsom e-mails, MMS, direkte meddelelser på sociale medier osv.).  ',
            sub_point_1_9:
                'i) At forhindre svindel og misbrug af it-system(er) og/eller produkter eller ydelser, som leveres via it-system(er).',
            sub_point_1_10:
                'j) At levere servicemeddelelser og information til brugere, kunder eller medlemmer.  ',
            sub_point_1_11:
                'k) At kunne yde support og give servicemeddelelser, herunder besvare spørgsmål eller klager og sende opdateringer om vores produkter og ydelser. ',
        },
        sub_point_2: {
            sub_point_2_title:
                'I tillæg til ovenstående behandler vi personoplysninger for følgende formål:',
            sub_point_2_1:
                'For at kunne opkræve og modtage betaling for din parkering',
            sub_point_2_2:
                'For at kunne besvare henvendelser/indsigelser fra parkanter',
            sub_point_2_3:
                'For at kunne udstede kontrolafgifter, efteropkrævninger og lign.',
            sub_point_2_4: 'For at kunne udføre vores parkeringskontrol',
            sub_point_2_5:
                'For at kunne administrere leje/reservation af P-plads, herunder ventelister til p-pladser',
            sub_point_2_6:
                'For at kunne sikre kriminalitetsbekæmpelse og generelt give parkanter en sikker oplevelse ved brug af parkeringsområderne',
            sub_point_2_7:
                'For at kunne registrere og udstede digital parkeringsregistrering/-tilladelse',
            sub_point_2_8:
                'For at du kan registrere dine oplysninger på vores sites eller app, som ”fast bruger” eller ved din øvrige brug af vores ANPR-pladser, eller når du benytter parking providers hjemmeside.',
        },
    },
    // --- 5. Retsgrundlag for behandlingen af personoplysninger
    Terms_main_point_5: {
        main_title: 'Retsgrundlag for behandlingen af personoplysninger',
        sub_point_1: {
            sub_point_1_title:
                'Vi behandler kun dine personoplysninger, når vi har et lovligt behandlingsgrundlag i overensstemmelse med GDPR. Behandlingen af personoplysninger sker alt efter de konkrete omstændigheder på baggrund af følgende behandlingshjemmel:',
            sub_point_1_1:
                'a) Behandlingen er nødvendig for at overholde gældende lovgivning, jf. GDPR, artikel 6, stk. 1, litra c.',
            sub_point_1_2:
                'b) Behandlingen er nødvendig for opfyldelsen af en kontrakt med den registrerede person, jf. GDPR, artikel 6, stk. 1, litra b, første led.',
            sub_point_1_3:
                'c) Behandlingen er nødvendig for at forfølge en legitim interesse, hvor den registreredes interesser eller grundlæggende rettigheder og frihedsrettigheder, der kræver beskyttelse af personoplysninger, ikke går forud herfor, jf. GDPR, artikel 6, stk. 1, litra f.',
            sub_point_1_4:
                'd) Grundlaget for behandlingen af de konkrete personoplysninger er dit samtykke, jf. GDPR, artikel 6, stk. 1, litra a. Du kan trække dit samtykke tilbage når som helst ved at kontakte os via de kontaktoplysninger angivet øverst på siden. Hvis du trækker dit samtykke tilbage, slettes personoplysningerne, der behandles på grundlag af samtykket, medmindre de kan eller skal behandles eksempelvis for at overholde en retlig forpligtelse.',
        },

        sub_point_2: {
            sub_point_2_title:
                'Vores legitime interesser efter GDPR, artikel 6, stk. 1, litra f, består i at kunne forfølge et krav mod dig som parkant, hvis du eksempelvis har parkeret i strid med bestemmelserne på en P-plads og er blevet pålagt et kontrolgebyr.',
            sub_point_2_1:
                'I den forbindelse kan vi indsamle navn- og adresseoplysninger om dig hos Motorregisteret (SKAT), hvilket vi efter databeskyttelsesforordningens artikel 6, stk. 1, litra f er berettiget til, da vi har en legitim interesse i at kunne rette vores krav overfor vedkommende, som har foretaget en parkering i strid med reglerne på parkeringsområdet.',
            sub_point_2_2:
                'I den forbindelse oplyses det, at vi har terminaladgang som en af de i lov om registrering af køretøjer § 17, stk. 2, nævnte virksomhedstyper m.v., der har adgang til oplysninger om navn og adresse på den registrerede primære ejer og primære bruger af køretøjet, jf. BEK nr. 1643 af 17/12/2018 § 102, stk. 1.',
            sub_point_2_3:
                'Behandlingen af de personoplysninger, der indsamles om dig via TV-overvågning, sker med hjemmel i GDPR, artikel 6, stk. 1, litra f, med baggrund i kriminalitetsforebyggelse. Denne interesse overstiges ikke af dine interesser eller grundlæggende rettigheder og frihedsrettigheder.',
        },
    },
    // --- 6. Videregivelse og overførsel af personoplysninger
    Terms_main_point_6: {
        main_title: 'Videregivelse og overførsel af personoplysninger',
        sub_point_1:
            'Vi videregiver kun personoplysninger til andre, når lovgivningen tillader eller kræver det. Vores organisation er en del af en koncern, hvor der deles personoplysninger mellem koncernselskaberne afhængigt af de konkrete omstændigheder.',
        sub_point_2: {
            sub_point_2_title:
                'Vi videregiver personoplysninger til følgende modtagere fra EU/EØS:',
            sub_point_2_1:
                'a) Banker (i forbindelse med udbetalinger, modtagelse af betalinger mv.)',
            sub_point_2_2: 'b) Databehandlere',
            sub_point_2_3: 'c) Leverandører',
            sub_point_2_4: 'd) Samarbejdspartnere ',
        },
        sub_point_3: {
            sub_point_3_title:
                'konkrete situationer kan vi videregive dine personoplysninger til følgende modtagere:',
            sub_point_3_1:
                'Politiet til brug for en eventuel politiefterforskning',
            sub_point_3_2: 'Offentlige myndigheder',
            sub_point_3_3: 'Inkassoselskaber',
            sub_point_3_4: 'Parkeringsklagenævnet',
            sub_point_3_5:
                'Parkeringsapps, som kan anvendes på parkeringsområder administreret af parking provider, herunder men ikke begrænset til EasyPark',
            sub_point_3_6:
                'Et andet parkeringsselskab, såfremt dette parkeringsselskab skal overtage driften, så du ikke bebyrdes af et administratorskifte',
            sub_point_3_7:
                'Ejere/virksomhedslejere af parkeringspladserne i forbindelse med parkeringskontrol. Dine oplysninger kan ud fra en interesseafvejning og/eller kontraktlige forpligtelser blive videregivet til pladsejer og/eller pladsejers ejendomsadministrator, virksomhedspladslejere, herunder, men ikke begrænset til overholdelse af ejendomsforeningers forpligtelser, kontraktuelle forhold mellem Selskabet og pladsejer/pladsejers ejendomsadministrator/virksomhedspladslejere samt ved ændringer i parkeringspladsens fysiske foranstaltninger.',
            sub_point_3_8:
                'I tilfælde af, at du gennem dit arbejde kan opnå ret til parkering, kan din henvendelse i forbindelse med et udstedt kontrolgebyr og de tilhørende personoplysninger, på baggrund af en interesseafvejning videregives til pladsejer/arbejdsgiver med henblik på at bekræfte din ansættelse og ret til parkering og for at sikre korrekt sagsbehandling.',
        },
        sub_point_4:
            'Vi bruger generelt forskellige eksterne og professionelle organisationer som leverandører og samarbejdspartnere til at levere eller assistere os med at levere vores services og produkter. De eksterne organisationer vil ikke modtage eller behandle personoplysninger, medmindre lovgivningen tillader overførsel og behandling heraf. Hvis de eksterne organisationer eller samarbejdspartnere er databehandlere for os, sker deres behandling af personoplysninger altid i henhold til en databehandleraftale, som opfylder lovgivningens krav hertil. Hvis de eksterne organisationer eller samarbejdspartnere er selvstændige dataansvarlige, sker deres behandling af personoplysninger i overensstemmelse med deres egen privatlivs-, databeskyttelses- eller persondatapolitik, som de eksterne organisationer vil gøre opmærksom på, medmindre lovgivningen foreskriver andet.',
        sub_point_5:
            'Vi kan kontaktes for mere information, herunder ved spørgsmål om vores brug af databehandlere, samarbejde med andre dataansvarlige, herunder datterselskaber, eller videregivelse af personoplysninger til tredjelande, samt for at modtage kopi af dokumentation for overførselsgrundlaget.',
    },
    // --- 7. Sletning og opbevaring af personoplysninger
    Terms_main_point_7: {
        main_title: 'Sletning og opbevaring af personoplysninger',
        sub_point_1:
            'Vi sørger for, at personoplysninger slettes, når de ikke længere er relevante for vores behandlingsformål som beskrevet ovenfor. Vi opbevarer altid personoplysninger i det tidsrum, som gældende lovgivning forpligter os til, herunder til brug for dokumentation af overholdelse af blandt andet bogføringslovens bestemmelser. Ved spørgsmål angående opbevaringen og behandlingen af personoplysninger, er du velkommen til at kontakte os på den e-mailadresse, du finder under parking provider øverst på siden.',
    },
    // --- 8. Dine rettigheder
    Terms_main_point_8: {
        main_title: 'Dine rettigheder',
        sub_point_1: {
            sub_point_1_title:
                'Som registreret person har du en række rettigheder:',
            sub_point_1_1:
                'Du har ret til at anmode om indsigt i, hvilke personoplysninger vi behandler om dig, formålet med behandlingen, og om vi videregiver personoplysningerne til andre.',
            sub_point_1_2:
                'Du har ret til at få berigtiget urigtige personoplysninger om dig.',
            sub_point_1_3:
                'Du har i visse tilfælde ret til at få slettet visse af dine personoplysninger.',
            sub_point_1_4:
                'Du har i visse tilfælde ret til at få begrænset behandlingen af dine personoplysninger, sådan at vi kun opbevarer dine personoplysninger i en given periode.',
            sub_point_1_5:
                'Du har i visse tilfælde ret til at gøre indsigelse imod vores behandling af dine personoplysninger på baggrund af årsager og forhold, der vedrører din særlige situation. En indsigelse kan være begrundet i behandling af personoplysninger med henblik på direkte markedsføring.',
            sub_point_1_6:
                'Du har ret til ikke at være genstand for en automatisk afgørelse uden menneskelig indblanding, medmindre afgørelsen er nødvendig for din ansættelse hos os, eller foretagelsen af afgørelsen er hjemlet ved lov eller dit udtrykkelige samtykke.',
            sub_point_1_7:
                'Såfremt vi har indhentet dit samtykke til en del af vores behandling af dine personoplysninger, har du til enhver tid ret til at tilbagekalde dit samtykke. Hvis du vælger at trække dit samtykke tilbage, påvirker det ikke lovligheden af den behandling, der er baseret på samtykket, inden tilbagekaldelsen.',
            sub_point_1_8:
                'Du har i visse tilfælde ret til såkaldt dataportabilitet af de personoplysninger, du har afgivet til os.',
            sub_point_1_9: 'Du kan altid klage til Datatilsynet.',
        },
        sub_point_2:
            'Der kan være betingelser eller begrænsninger til disse rettigheder. Det er derfor ikke sikkert, at du eksempelvis har ret til dataportabilitet i det konkrete tilfælde - dette afhænger af de konkrete omstændigheder i forbindelse med behandlingsaktiviteterne.',
        sub_point_3:
            'Du kan finde mere information om dine rettigheder som registreret på Datatilsynets hjemmeside.',
        sub_point_4:
            'Venligst brug kontaktoplysningerne nedenfor, hvis du vil gøre brug af dine rettigheder.',
        sub_point_5:
            'Vi bestræber os på at møde dine ønsker omkring vores behandling af personoplysninger, men du kan altid indsende en klage til Datatilsynet.',
    },
    // --- 9. Ændringer til denne politik
    Terms_main_point_9: {
        main_title: 'Ændringer til denne politik',
        sub_point_1:
            'Vi forbeholder os retten til at ajourføre og ændre denne Politik. Hvis vi ændrer Politikken, ændrer vi datoen og versionen øverst i dokumentet. I tilfælde af væsentlige ændringer, vil vi meddele dette i form af en synlig meddelelse på vores hjemmeside, e-mail eller ved brug af andre kommunikationsmidler.',
    },
    // --- 10. Kontaktinformation
    Terms_main_point_10: {
        main_title: 'Kontaktinformation',
        sub_point_1: {
            sub_point_1_title:
                'Du er velkommen til at kontakte os på de kontaktoplysninger, der fremgår øverst af siden, hvis du:',
            sub_point_1_1:
                'a) er uenig i vores behandling eller mener, at vores behandling af dine personoplysninger overtræder lovgivningen',
            sub_point_1_2:
                'b) har spørgsmål eller i øvrigt har kommentarer til denne Politik, eller',
            sub_point_1_3:
                'c) ønsker at udøve én eller flere af dine rettigheder som registreret person.',
        },
        sub_point_2:
            'Ved spørgsmål eller kommentarer til denne politik, eller ved påberåbelse af en eller flere rettigheder, kan vi kontaktes via kontaktoplysningerne øverst på siden.',
    },

    // ### Handelspolitik indhold ###
    trade_policy_description:
        'Vi opbevarer og transmitterer brugeroplysninger krypteret. Indtastede personoplysninger registreres som beskrevet i vores datapolitik (se afsnit 4). Ved at acceptere nærværende betingelser, accepterer Brugeren samtidig at være bekendt med og at have accepteret nærværende vilkår og betingelser for brug af parking provider produkter.',
    trade_policy_description_2:
        'For særlige regler om parking provider abonnementsparkering se herunder under ”parking provider Abonnementsparkering”.',
    trade_policy_description_3:
        'Parking provider kan indsamle information og udarbejde statistikker og rapporter med henblik på at forbedre og levere det bedste produkt samt service til Brugeren.',

    // --- 1. Anvendelse
    Trade_Terms_main_point_1: {
        main_title: 'Anvendelse',
        sub_point_1: {
            sub_point_1_title:
                'Disse Almindelige Vilkår og Betingelser (de ”Almindelige Vilkår og Betingelser”) gælder for leveringen af Tjenester fra parking provider. Mere information om parking provider findes øverst på siden.',
        },
        sub_point_2:
            'BEMÆRK! Brug af parking provider tjenester kræver, at du er registreret ejer eller bruger af køretøjet eller at du på anden vis har tilladelse til brug og registrering af køretøjet.',
        sub_point_3: {
            sub_point_3_title:
                'Alle Tjenester leveres i henhold til gældende lovgivning og i henhold til:',
            sub_point_3_1:
                'eventuelle individuelt aftalte betingelser og vilkår, og',
            sub_point_3_2: 'disse Almindelige Vilkår og Betingelser.',
            sub_point_3_3:
                'I tilfælde af uoverensstemmelser mellem ovenstående bestemmelser, har de prioritet i ovenstående rækkefølge.',
        },
        sub_point_4:
            'Punkt 4.1.4, 5.4 og 6.7 indeholder særlige bestemmelser om korrekt og gyldig indtastning af registreringsnummer og områdekode.',
        sub_point_5:
            'Punkt 4.3. indeholder særlige bestemmelser om anvendelsen af parking provider-charge.',
        sub_point_6:
            'Ved registrering hos parking provider (se punkt 4), accepterer Brugeren at være underlagt disse Almindelige Vilkår og Betingelser. Der bliver indgået en bindende aftale (”Aftalen”), når parking provider har bekræftet Brugerens registrering, og Brugeren får adgang til parking provider Tjenester.',
        sub_point_7:
            'Disse Almindelige Vilkår og Betingelser udgør Aftalen mellem parking provider og Brugeren.',
        sub_point_8:
            'Disse Almindelige Vilkår og Betingelser er gældende for alle transaktioner og registreringer via parking provider, herunder også parking provider og parking provider Abonnementsparkering.',
    },
    // --- 2. Definitioner
    Trade_Terms_main_point_2: {
        main_title: 'Definitioner',
        sub_point_1: {
            sub_point_1_title:
                'I disse Almindelige Vilkår og Betingelser og i forbindelse med Tjenesterne gælder følgende definitioner:',
            sub_point_1_1:
                'Ved ”parking provider” forstås den digitale parkeringstjeneste som kan benyttes i forbindelse med betaling for parkering, via App og hjemmesiden;',
            sub_point_1_2:
                'Som ”App” forstås parking provider mobiltelefonapplikation;',
            sub_point_1_3:
                '”parking provider-System” er parking provider digitale system for tidssvarende parkering, som Brugeren opnår adgang til via Appen og/eller via Hjemmesiden;',
            sub_point_1_4:
                'Ved ”Hjemmeside” henvises til parking provider hjemmeside.',
            sub_point_1_5:
                '”Parkeringstjeneste” er Brugerens mulighed for at forvalte parkeringer i Appen;',
            sub_point_1_6:
                'En ”Parkeringsplads” er et fysisk område som matcher med et parkeringsområde markeret på oversigtskortet (ved parkeringsplads er ikke at forstå en afmærket parkeringsbås);',
            sub_point_1_7:
                '”Parterne” og ”Part” betyder parking provider og/eller Brugeren;',
            sub_point_1_8:
                '”Bruger” anvendes i disse Almindelige Vilkår og Betingelser om parkanten som benytter parking provider i forbindelse med betaling for parkering.',
            sub_point_1_9:
                '”Partner” betyder partnere, som parking provider samarbejder med;',
            sub_point_1_10:
                '”Tjeneste(r)” har den betydning der er angivet i punkt 3.1.1.',
            sub_point_1_11:
                '”Parkeringsafgiften” er prisen for den foretagne parkering.',
            sub_point_1_12:
                '”Aktive køretøj” betegner et køretøj som Brugeren har valgt, at der automatisk sker betaling for i forbindelse med parkering på såkaldte ANPR-parkeringspladser. Betaling sker via den betalingsmetode som Brugeren har angivet som foretrukket.',
            sub_point_1_13:
                '”ANPR” står for Automatisk NummerPlade Registrering, hvorved forstås at køretøjets nummerplade aflæses automatisk og registreringsnummeret registreres i parkeringssystemet. Parkeringspladser med ANPR-systemer er markeret med et kamera i parking provider, og det fremgår af skiltningen på parkeringspladsen, at nummerpladen aflæses.',
            sub_point_1_14:
                'Ved ”parking provider-Charge” menes der parking provider egne og tilknyttede systemer og apps fra 3. part, som kan benyttes i forbindelse med opladning af el- og hybridbil. Dette er både ladestandere, betalingssystemer og –apps.',
        },
        sub_point_2:
            'Der kan være angivet definitioner andre steder i disse Almindelige Vilkår og Betingelser.',
    },
    // --- 3. Almindelige Vilkår og Betingelser for Tjenesterne
    Trade_Terms_main_point_3: {
        main_title: 'Almindelige Vilkår og Betingelser for Tjenesterne',
        sub_point_1: {
            sub_point_1_title: 'Generelt',
            sub_point_1_1:
                'parking provider tilbyder et digitalt system for parkering (”parking provider”), hvorved parking provider (i samarbejde med andre Partnere) giver Brugeren mulighed for at administrere parkering af køretøjer (”Parkeringstjenesten”) og opladning af el-køretøjer. Parkeringstjenesten og de til enhver tid øvrige tjenester leveret af parking provider kaldes samlet for ”Tjenesterne”.',
        },
        sub_point_2:
            'For en detaljeret beskrivelse af Tjenesterne henvises til de til enhver tid angivne informationer på hjemmesiden.',
    },
    // --- 4. Særlige betingelser og vilkår for brug af parking provider
    Trade_Terms_main_point_4: {
        main_title:
            'Særlige betingelser og vilkår for brug af parking provider',

        sub_point_1: {
            sub_point_title: 'Betingelser for anvendelse',

            sub_point_1_1:
                'Parkeringstjenesten kan alene anvendes på parkeringspladser og i parkeringsområder/-zoner (hver for sig en ”Parkeringsplads”), som:',
            sub_point_1_1_1: 'der er opsat parking provider skiltning på,',
            sub_point_1_1_2:
                'og har automater med parking provider mærkater, eller på anden vis bærer parking provider mærker, der angiver, at parking provider kan anvendes.',

            sub_point_1_2:
                'Når Parkeringstjenesten anvendes, skal Brugeren påbegynde en parkering ved at aktivere enten; Appen; eller et tilknyttet og godkendt betalingssystem',

            sub_point_1_3:
                'For at sikre, at parkering er påbegyndt på korrekt vis, skal Brugeren undersøge, at en bekræftelse på korrekt og gyldig påbegyndt parkering er modtaget via',
            sub_point_1_3_1: 'Appen, såfremt Appen anvendes; eller',
            sub_point_1_3_2: 'Email-bekræftelse',

            sub_point_1_4:
                'En parkering er kun gyldig, hvis App har bekræftet parkeringen, og viser en igangværende korrekt registreret parkering/betaling.',

            sub_point_1_5:
                'Ved anvendelsen af Parkeringstjenesten, skal Brugeren i forbindelse hermed korrekt angive det parkerede køretøjs registreringsnummer samt områdekode på den pågældende Parkeringsplads.',

            sub_point_1_6:
                'Det er Brugerens ansvar, at køretøjets registreringsnummer og områdekoden er indtastet korrekt. Fejl i registrering og indtastning vil medføre en kontrolafgift.',

            sub_point_1_7:
                'Brugeren skal sikre sig, at områdekoden svarer til områdekoden på den pågældende Parkeringsplads eller E-charge stander, som fremgår af parking provider skiltningen på parkeringspladsen eller i nærheden af Parkeringspladsens automater/E- charge standere. Brugeren er ansvarlig for angivelse af korrekt områdekode og registreringsnummer. Parking provider påtager sig intet ansvar i forbindelse med forkert angivne registreringsnumre og/eller områdekoder.',

            sub_point_1_8:
                'Ved parkering på parkeringspladser hvor køretøjets nummerplade aflæses, skal områdekode ikke indtastes. Registreringsnummeret der parkeres med, skal være korrekt indtastet.',

            sub_point_1_9:
                'Det er en gyldighedsbetingelse for parkeringens registrering, at registreringsnummeret og områdekoden er indtastet korrekt.',

            sub_point_1_10:
                'Registrering af parkering i parking provider kan ske på en af følgende måder:',
            sub_point_1_10_1:
                'Ved manuel registrering skal Brugeren angive den ønskede parkeringstid, og bliver i denne forbindelse oplyst om prisen for den ønskede parkering. Ved Brugerens bekræftelse af den indtastede registrering, reserveres det oplyste beløb. Ved Brugerens stop af parkeringen, modificeres det reserverede beløb, således at der kun betales for den registrerede parkeringstid.',
            sub_point_1_10_2:
                'Ved automatisk registrering (ved parkering på ANPR-pladser) skal Brugeren forud for parkeringen have aktiveret køretøjet under ”køretøjer”. Ved parkering på ANPR-parkeringsplads, da igangsættes parkeringen ved indkørslen og afsluttes samt afregnes ved udkørslen. Det betales for den benyttede parkeringstid.',
            sub_point_1_10_2_1:
                'Ved Brugerens aktivering af køretøj accepterer Brugeren at der sker automatisk betaling via den foretrukne betalingsmetode når parkering sker på ANPR-parkeringsplads.',

            sub_point_1_11:
                'parking provider kan ikke gøres ansvarlig for præcisionen af Brugerens telefons GPS-position, ej heller kan parking provider gøres ansvarlig for mobildækning/signal i/på parkeringsområdet. Brugeren er ansvarlig for, at den angivne position modsvarer brugerens parkerede køretøjs position.',

            sub_point_1_12:
                'Oplysninger om parkeringer foretaget af Brugeren, vil være tilgængelige for Brugeren via ”Parkeringer”, og sådanne oplysninger vil som udgangspunkt være tilgængelige i mindst 12 måneder.',
        },

        sub_point_2: {
            sub_point_title: 'Generelt',

            sub_point_2_1:
                'Parkeringstjenesten gør det muligt for Brugeren at påbegynde en parkering, og ved manuel påbegyndelse angive foreløbig parkeringstid, stoppe og afslutte den påbegyndte parkering. Yderligere er det muligt for Brugeren at forlænge den foreløbig angivet parkeringstid.',
            sub_point_2_1_1:
                'Påmindelse: Det er muligt at få en påmindelse før den manuelle igangsatte parkering udløber, forudsat at der i Appen er givet tilladelser til push-meddelelser. Det er brugerens ansvar at sikre, at korrekt afslutning af parkering sker, uanset om påmindelsen udebliver.',
            sub_point_2_1_2:
                'Stop parkering: Forlades parkeringspladsen før den valgte parkerings tid udløber, er det muligt aktivt at stoppe den igangværende parkering, hvorved der kun betales for den periode, hvor parkeringen har været aktiv. Brugeren henvises til altid at forholde sig til parkeringsprisen, som fremgår af skiltningen og/eller betalingsautomaten. Afhængigt af prisstrukturen på parkeringspladsen, da vil det på de fleste parkeringspladser være muligt at stoppe parkeringen, så der ikke betales for ”ubrugt tid”. NB! Nogle parkeringspladser kræver betaling pr. påbegyndt tidsperiode og evt. forud, hvilket betyder, at i tilfælde af, at en sådan parkering stoppes, da opkræves det forud godkendte beløb uanset stopningen. Stoppes parkeringen ikke, vil der ikke kunne ske refusion af betaling for ”overskydende tid”.',
            sub_point_2_1_2_1:
                'Ved overskydende tid skal forstås, den periode, hvor der er en gyldig registrering af parkering på parkeringspladsen, men hvor køretøjet ikke har befundet sig på parkeringspladsen.',
            sub_point_2_1_3:
                'Forlængelse: Forlængelse af en parkering foretages ved at trykke på ”forlæng” og derpå anføre det nye sluttidspunkt for parkeringen, derefter godkendes beløbet. Herefter vil nedtællingen af parkeringsperioden for køretøjet blive opdateret ud fra det forlængede parkeringstidspunkt. Forlængelse medfører, at der igangsættes en ny parkering ved udløb af den oprindelige parkering.',
            sub_point_2_1_4:
                'Hvis det ikke er muligt at udføre et køb på et givet tidspunkt ved hjælp af parking provider softwaren, er Brugeren ansvarlig for at betale for parkeringen på anden vis f.eks. ved at købe en gyldig P-billet i betalingsautomat og i øvrigt iagttage de skiltede regler og vilkår for parkering. Årsager til at parking provider ikke kan benyttes omfatter, men er ikke begrænset til f.eks.: dårlig/ingen internetadgang, server-nedetid pga. vedligeholdelse, opdateringer m.m.',

            sub_point_2_2:
                'Var Brugeren ikke fører af køretøjet på tidspunktet for parkeringen, men har brugeren angivet køretøjet som aktivt, da har brugeren accepteret at betaling automatisk sker via den foretrukne betalingsmetode. Det interne forhold mellem Brugeren og eventuel tredjemand er parking provider uvedkommende.',

            sub_point_2_3:
                'Pålægges det parkerede køretøj et kontrolgebyr, for en parkering uoverensstemmende med de regler og vilkår som fremgår af skiltningen på parkeringspladsen, hæfter føreren for betaling af et sådant kontrolgebyr, uanset hvem der har foretaget betalingen for parkeringen.',
            sub_point_2_3_1:
                '”Kontrolgebyr” anvendes i denne sammenhæng som samlebetegnelse for hhv. kontrolgebyr, kontrolafgift osv.',

            sub_point_2_4:
                'I det tilfælde, at parkeringen er foretaget med et køretøj, hvor registreret ejer/bruger er et selskab, og køretøjet er pålagt et kontrolgebyr, er det Brugerens ansvar på tilstrækkeligvis, at dokumentere, at den foretagne parkering ikke er sket i erhvervsøjemed. Kan Brugeren ikke løfte denne bevisbyrde anses den registrerede ejer/bruger, for at være rette debitor og der vil i dette tilfælde, ved forsinket betaling, udover eventuelle rykkere blive opkrævet et kompensationsbeløb på kr. 310,00 i overensstemmelse med bek. nr. 105 af 31/01/2013 § 2, stk. 1.',

            sub_point_2_5:
                'Var Brugeren ikke fører af køretøjet på tidspunktet for parkeringen, accepterer Brugeren herved at skulle oplyse hvem føreren var. Ved mangelfulde eller urigtige oplysninger vil kontrolgebyret, samt evt. rykkergebyrer, i deres helhed blive fastholdt overfor Brugeren.',

            sub_point_2_6:
                'Brugerens betaling af den pågældende parkeringsafgift (inklusiv moms) er fastsat på baggrund af de gældende takster (”Parkeringsafgiften”) i forbindelse med, at Brugeren afslutter en parkering, eller alternativt starter en fast parkeringstid gennem Parkeringstjenesten.',

            sub_point_2_7:
                'Brugeren kan ikke fremsætte krav om reduktion af kontrolgebyret, på baggrund af gennemført betaling i parking provider. Dette vilkår er gældende uanset, hvorvidt kontrolgebyret er pålagt på baggrund af Brugerens fejlregistrering i parking provider ellers Brugerens parkering i strid med de øvrige skiltede regler og vilkår på parkeringspladsen.',

            sub_point_2_8:
                'Brugeren har desuden ikke krav på tilbagebetaling af betaling foretaget via parking provider, medmindre opkrævningen skyldes en fejl hos parking provider, som Brugeren ikke har haft eller kunne have indflydelse på.',
        },

        sub_point_3: {
            sub_point_title: 'Parking provider charge vilkår',

            sub_point_3_1:
                'Betaling for opladning af køretøj kan ske gennem apps i relation til de på pladsen opstillede ladestandere. Betaling for parkering skal ske særskilt gennem parking provider (se punkt 4).',

            sub_point_3_2:
                'BEMÆRK: Ved parkering i parkeringsbåse reserveret til el-køretøjer under opladning, skal opladningen være registreret i den benyttede app, inden parkering og opladning påbegyndes. Desuden skal parkering være registreret i parking provider-appen, som angivet i punkt 4.',

            sub_point_3_3:
                'Den benyttede app skal anvendes til betaling for opladning via opstillede ladestandere.',

            sub_point_3_4:
                'Ved brug af parking provider i forbindelse med benyttelse af opstillet ladestander, giver Brugeren meddelelse til parking provider om, at opladning af parkeret køretøj påbegyndes, den foreløbige ladetid, afslutning af opladning og hvis nødvendigt, om forlænget ladetid.',

            sub_point_3_5:
                'Ved betaling og brug af opstillet ladestander betales for en ladeafgift.',
            sub_point_3_5_1: 'Ladeafgiften er variabel.',
            sub_point_3_5_2:
                'Betaling for ladeafgift sker særskilt og kravet fremgår i den benyttede appen forinden registrering og betaling gennemføres.',

            sub_point_3_6:
                'Ved registrering er de øvrige betingelser og vilkår for brug af parking provider ppen ligeledes gældende, herunder at korrekt og gyldig registrering samt betaling forudsætter korrekt indtastning af områdekode samt det parkerede køretøjs registreringsnummer. Det er brugerens ansvar, at de indtastede oplysninger er korrekte og kontrollerbare samt at betaling kan gennemføres.',

            sub_point_3_7:
                'Områdekoden som skal benyttes i forbindelse med betaling for opladning samt parkering fremgår af skiltningen opsat ud for båsene, som er reserveret til el-køretøjer. Det er brugerens ansvar, at korrekt områdekoden indtastes.',
            sub_point_3_7_1:
                'Ved betaling til områdekode tilknyttet parking provider-charge ladestander, men uden at en parkeringsbås reserveret til parking provider-charge benyttes, da vil der ikke ske refusion af indbetaling.',

            sub_point_3_8:
                'Det er til hver en tid brugerens ansvar, at de skiltede regler og vilkår som fremgår af parkeringspladsen iagttages. Ved uoverensstemmelser mellem skiltningen og disse betingelser og vilkår, da har skiltningens ordlyd forrang. Såfremt parkering ikke er foretaget i overensstemmelse med de skiltede regler og vilkår vil et kontrolgebyr kunne pålægges, som ikke efterfølgende vil kunne blive annulleret.',
            sub_point_3_8_1:
                'Parkering i båse reserveret til El-køretøjer kan kun ske mod betaling og køretøjet skal være under opladning i hele perioden, som parkeringsbåsen benyttes. Er køretøjet ikke under opladning og/eller er parkeringen ikke registreret i parking provider, da vil et kontrolgebyr som ikke kan annulleres, blive pålagt.',
            sub_point_3_8_2:
                'Opstår der problemer i forbindelse med brug af parking provider-charge ladestander skal brugeren kontakte parking provider på det på ladestanderen oplyste telefonnummer.',

            sub_point_3_9:
                'Oplysninger som Brugeren har registreret i forbindelse med registrering og betaling sker på samme måde som nævnt i pkt. 4.',
        },
    },
    // --- 5. Adgang til Tjenesterne, registrering af oplysninger, osv.
    Trade_Terms_main_point_5: {
        main_title: 'Adgang til Tjenesterne, registrering af oplysninger, osv.',
        sub_point_1:
            'Adgang til Tjenesterne, oprettelse samt betaling for parkering via parking provider kan ske ved, at Brugeren oprettes som bruger. Brug af parking provider kræver, at der er tilknyttet et gyldigt betalingsmiddel i Brugerens parking provider App. De betalingsmidler som Brugeren gyldigt kan tilknytte som betalingsmiddel er; Bankkort. Det er en gyldighedsbetingelse, at der er dækning på det tilknyttede og valgte betalingsmiddel.',

        sub_point_2: {
            sub_point_2_title:
                'Ved oprettelsen og senere brug af parking provider er det en forudsætning, at Brugeren oplyser korrekt og gyldigt:',
            sub_point_2_1: 'Navn',
            sub_point_2_2: 'Mailadresse',
            sub_point_2_3: 'Mobilnummer',
            sub_point_2_4: 'Adgangskode',
            sub_point_2_5: 'Registreringsnummer, på mindst ét køretøj',
            sub_point_2_6: 'Betalingsmiddel',

            sub_point_2_6_1:
                'Grupper af medarbejdere med adgang til de registrerede oplysninger:',
            sub_point_2_6_1_1: 'Underleverandører (under udøvelse af support)',
            sub_point_2_6_1_2:
                'parking provider Medarbejdere (under udøvelse af support i forbindelse med Brugers henvendelser)',
        },

        sub_point_3: 'En parkering igangsættes via App eller hjemmesiden.',

        sub_point_4: {
            sub_point_4_title:
                'For at anvende parking provider skal der forud for parkeringens registrering være tilknyttet og valgt et gyldigt betalingsmiddel i Appen eller på hjemmesiden.',
            sub_point_4_1:
                'BEMÆRK: Det er ikke muligt at ændre betalingsmiddel i forbindelse med en igangværende parkering, hvorfor det er Brugerens ansvar, at det korrekte og gyldige betalingsmiddel vælges forud for parkeringen.',
        },

        sub_point_5: {
            sub_point_5_title:
                'Instrukserne som fremgår af skærmen skal følges:',
            sub_point_5_1:
                'For at Brugeren kan benytte parking provider til betaling for parkeringer, er det en gyldighedsbetingelse, at Brugeren registrerer korrekt og gyldigt registreringsnummer (nummerplade), områdekode, betalingsmiddel og parkeringstid.',
            sub_point_5_2:
                'Det skal eftertjekkes, at det/den registrerede registreringsnummer og områdekode er korrekt angivet, af Brugeren.',
            sub_point_5_3:
                'parking provider forbeholder sig ret til at afvise en ansøgning om oprettelse og betaling for parkering.',
            sub_point_5_4:
                'Det præciseres, at der kun er sket gyldig betaling for parkeringen, hvis der er foretaget korrekt angivelse af registreringsnummeret på det køretøj, der parkeres samt, at den indtastede områdekode er overensstemmende med områdekoden som fremgår af parking provider skiltningen gældende for den pågældende parkeringsbås, hvor køretøjet befinder sig.',
        },

        sub_point_6:
            'Ved manglende gyldig registrering af parkeringen risikerer køretøjet at blive pålagt et kontrolgebyr.',
        sub_point_7:
            'Ved gennemført køb/reservation, sendes en bekræftelse via e-mail til den af Brugeren oplyste e-mailadresse.',
        sub_point_8:
            'Ved køb gennem parking provider stilles der en uspecificeret parkeringsbås til rådighed på den/det valgte parkeringsplads/parkeringssted og i den valgte periode. parking provider kan ikke gøres ansvarlig, hvis der ikke er ledige parkeringsbåse (da der ikke er tale om booking). Parkering bør derfor ikke købes før køretøjet er behørigt parkeret på parkeringspladsen.',
        sub_point_9:
            'Bruger har ikke krav på tilbagebetaling af ubenyttet parkering. Se punkt 4.2.1.2.',
    },
    // --- 6. Brugerens forpligtelser og ansvar
    Trade_Terms_main_point_6: {
        main_title: 'Brugerens forpligtelser og ansvar',

        sub_point_1:
            'Brugeren er til hver en tid ansvarlig for at afgive korrekte oplysninger om Brugeren, og at relevante køretøjer er korrekt registrerede hos parking provider. Brugeren skal umiddelbart efter oprettelsen/registreringen, logge på ”Min Konto” for at sikre, at de registrerede oplysninger er korrekte. Parking provider kan aldrig være eller blive ansvarlig for fejlregistreringer/-indtastninger, uanset registreringsmetode.',

        sub_point_2:
            'Brugeren er ansvarlig for løbende at sikre, at betalingsmidlet som er registreret, og som anvendes via parking provider, ikke er blokeret, er gyldig og at der er tilstrækkelig dækning på det registrerede betalingsmiddel. Ved udløb af et registreret betalingsmiddel skal Brugeren give parking provider oplysninger (ved en opdatering i Appen under ”betalingsmetoder”) om et nyt betalingsmiddel. Oplysningen om nyt betalingsmiddel skal gives senest ved udgangen af den kalendermåned, der går forud for den kalendermåned, hvor det registrerede betalingsmiddel ikke længere er anvendeligt.',

        sub_point_3:
            'Sikker og forsvarlig opbevaring af login-oplysningerne, er Brugerens ansvar.',

        sub_point_4:
            'Yderligere er det Brugerens ansvar at login-oplysningerne ikke videregives eller på anden måde gøres tilgængelig for uautoriserede personer.',

        sub_point_5: {
            sub_point_5_title:
                'Det er udelukkende Brugerens ansvar, at Brugerens parking provider konto kun anvendes og bliver anvendt af rette personer.',

            sub_point_5_1_title:
                'Brugeren skal straks informere parking provider (f.eks. ved henvendelse til parking provider Kundeservice eller ved en opdatering af oplysningerne i ”Min Konto”), såfremt:',

            sub_point_5_1_1:
                'Brugeren har grund til at tro, at en uautoriseret person har fået adgang eller kendskab til Login-oplysningerne;',
            sub_point_5_1_2:
                'registrerede oplysninger om Brugeren er blevet ændret og/eller bør opdateres; eller',
            sub_point_5_1_3:
                'Brugeren ikke længere råder over et registreret køretøj eller ikke længere skal betale for parkeringer foretaget med et registreret køretøj,',

            sub_point_5_2:
                'Informationen skal i første omgang ske ved, at Brugeren selv opdaterer oplysningerne i parking provider. Det er Brugerens ansvar, at der ikke er registreret køretøjer, som brugeren ikke skal betale for. Parking provider kan herved tage de nødvendige forholdsregler, eksempelvis at ændre/blokere Login-oplysningerne og/eller Brugerens konto eller bede Brugeren opdatere Brugerens registrerede oplysninger. Brugeren er ligeledes forpligtet til at orientere parking provider om øvrige forhold af betydning for Aftalen og/eller leveringen af Tjenesterne.',

            sub_point_5_3:
                'Brugeren er ansvarlig for at sikre, at Appen til enhver tid er opdateret. Mobiltelefon eller andet teknisk udstyrs korrekte funktionalitet, er til hver en tid Brugerens ansvar. Det er Brugerens ansvar at det benyttede medie er kompatibelt med Tjenesterne og Appen. De til enhver tid gældende funktionskrav til Tjenesterne og Appen kan indhentes ved henvendelse til Kundeservice.',
        },

        sub_point_6:
            'Brugeren er til enhver tid forpligtet til at overholde gældende love og regler samt de regler og vilkår, som fremgår af skiltningen på den pågældende parkeringsplads, hvor Brugeren parkerer sit køretøj.',

        sub_point_7:
            'Brugeren er ansvarlig for, at parkering påbegyndes korrekt ved angivelse af det parkerede køretøjs registreringsnummer og områdekode gældende for den benyttede parkeringsplads. Brugeren er ansvarlig for at sikre, at områdekoden angivet af Brugeren er korrekt, også selvom områdekoden foreslås i Appens lokalitetsfunktion. BEMÆRK: Såfremt der ikke indtastes korrekt registreringsnummer og/eller områdekode, er der ikke foretaget gyldig betaling for parkeringen, hvorfor det parkerede køretøj risikerer at blive pålagt et kontrolgebyr.',

        sub_point_8:
            'Brugeren er ansvarlig for at sikre, at en påbegyndt parkering afsluttes. Såfremt Brugeren ikke angiver en foreløbig sluttid eller en total parkeringstid, når parkering påbegyndes, er Brugeren ansvarlig for at afslutte parkeringen manuelt. Afslutning af parkeringen kan ske via Appen eller ved henvendelse til parking provider vha. de kontaktoplysninger som fremgår af Appen, hjemmesiden og parking provider skiltene.',

        sub_point_9:
            'Såfremt Parkeringstjenesten ikke er tilgængelig eller er ude af drift, når Brugeren skal parkere, eller mens Brugeren parkerer (f.eks. af grunde der kan henføres til telefonen, mobiltelefonen eller andet teknisk udstyr anvendt af Brugeren, eller på grund af fejl, afbrydelse eller forsinkelse af telefon, internet eller andre kommunikationsnetværk), er Brugeren ansvarlig for, at der foretages betaling på anden vis og som angivet af den opslåede skiltning på parkeringspladsen (eksempelvis ved betaling i den pågældende automat).',

        sub_point_9_1:
            'Brugeren er ansvarlig for betaling af eventuelle kontrolgebyrer eller afgifter for ukorrekt parkering (som meddeles eller indkræves i forbindelse med parkeringsrestriktionsovertrædelser).',

        sub_point_9_2:
            'Såfremt det parkerede køretøj er registreret til et selskab, anses parkeringen for foretaget i arbejdsmæssig sammenhæng, hvorfor Selskabet i denne situation vil blive anset for rette debitor.',

        sub_point_10:
            'Brugeren har mulighed for at se parkeringshistorikken for de parkeringer Brugeren har betalt for via parking provider.',

        sub_point_11:
            'Al parkering købt/reserveret via parking provider sker på eget ansvar, medmindre andet specifikt fremgår af disse vilkår og betingelser.',

        sub_point_12:
            'Parking provider påtager sig intet ansvar i forbindelse med ulykker, tyveri, skader på personer, køretøjer, udstyr og effekter, i forbindelse med at køretøjet holder parkeret på en parkeringsplads. Parking provider kan ikke gøres ansvarlig for nogen form for indirekte tab eller følgeskader.',
    },
    // --- 7. Klageadgang
    Trade_Terms_main_point_7: {
        main_title: 'Klageadgang',
        sub_point_1:
            'Ved at indsende en klage accepterer du, at den angivne e-mailadresse må anvendes som kontaktoplysning i forbindelse med sagens behandling, herunder i forbindelse med eventuel inddrivelse af den pågældende parkeringsafgift.',
        sub_point_2:
            'I tilfælde af mangelfuld Tjeneste eller forkert opkrævning, skal Brugeren straks og senest 30 dage efter ydelsen af den pågældende Tjeneste blev leveret eller efter, at Brugeren konstaterede eller burde have konstateret den pågældende forkerte opkrævning, indsende en skriftlig klage til parking provider kundeservice. Klagen skal klart angive manglen eller fejlen. Brugeren skal yde rimelig assistance til parking provider i forbindelse med eventuelle undersøgelser i forbindelse med klagen.',
        sub_point_3:
            'Klager over pålagte kontrolgebyrer skal ske til udstederen af det/de pålagte kontrolgebyr(er).',
    },

    // --- 8. Vilkår og Priser
    Trade_Terms_main_point_8: {
        main_title: 'Vilkår og Priser',
        sub_point_1:
            'Brugeren hæfter til hver en tid for alle betalinger foretaget via parking provider.',
        sub_point_2:
            'Betalinger foretages ved, at Brugeren registrer et gyldigt betalingsmiddel i Appen. Betaling vil blive opkrævet via det af Brugeren registrerede betalingsmiddel. Når et køretøj er markeret som aktivt, da har Brugeren accepteret, at betaling automatisk sker via det angivne foretrukne betalingsmiddel. Administrator vil blive faktureret ved betalinger hvor Erhvervsparkering er registreret som betalingsmiddel. Brugeren vælger og godkender betalingsmetoden i forbindelse med ansøgning om registrering. Det er Brugerens ansvar, at korrekt og gyldigt betalingsmiddel angives inden parkeringen igangsættes. Fejlagtig anvendelse af Erhvervsparkering er alene et anliggende mellem Administrator og Brugeren.',
        sub_point_3:
            'Ved forsinket betaling vil der blive opkrævet eventuelle rykkere i overensstemmelse med gældende lovgivning.',
        sub_point_4:
            'Alle priser angives i danske kroner og inklusive moms. Prisen som skal betales for den foretagne parkering, afhænger af den valgte parkeringsplads, den valgte parkeringsperiode, samt om en igangværende parkering forlænges.',
        sub_point_5:
            'Ved oprettelse af en parkering samt ved forlængelse oplyses det, hvor meget den pågældende parkering eller forlængelse koster, og dette beløb skal godkendes, før parkeringen bliver oprettet og/eller forlænget.',
        sub_point_6:
            'I nogle tilfælde vil der ud over timeprisen for parkering blive opkrævet et driftsgebyr. Dette vil altid fremgå af App’en eller Hjemmesiden ved køb af tilladelse.',
        sub_point_7:
            'parking provider forbeholder sig retten til at ændre afgifter og priser.',
        sub_point_8:
            'BEMÆRK: parking provider forbeholder sig retten til at opdatere og ændre Appens såvel som hjemmesidens indhold uden forudgående varsel.',
    },

    // --- 9. Fortrydelsesret
    Trade_Terms_main_point_9: {
        main_title: 'Fortrydelsesret',
        sub_point_1:
            'I henhold til den danske forbrugeraftalelov (lov nr. 1457 af 17. december 2013), har Brugeren ret til at fortryde indgåelsen af Aftalen ved meddelelse herom til parking provider kundeservice inden for 14 dage efter godkendelse af registreringen.',
        sub_point_2:
            'Brugeren er indforstået med at købelovens (lov nr. 1853 af 24/09/2021) normale fortrydelsesret på 14 dage kun gælder parkering, som endnu ikke er trådt i kraft (gyldige) på fortrydelsestidspunktet. Bestiller Brugeren således parkering med gyldighedsperiode fra samme dag (straks) ophører fortrydelsesretten ligeledes samme dag (straks) og de ellers gældende 14 dages fortrydelsesret fraskrives dermed af Brugeren. Ved Brugerens køb af parkering med gyldighedsperiodes begyndelse senere end 14 dage fra indgåelse af abonnementsaftale har Brugeren 14 dages fortrydelsesret.',
        sub_point_3: {
            sub_point_3_title:
                'For at kunne benytte fortrydelsesretten, skal fortrydelsesmeddelelsen være indleveret til parking provider senest på 14. dagen for den dag, hvor indbetalingen er registreret hos parking provider.',
            sub_point_3_1:
                'Udløber fristen på en helligdag, lørdag, grundlovsdag, juleaftensdag eller nytårsaftensdag forlænges fristen til den følgende hverdag.',
            sub_point_3_2:
                'For at udøve fortrydelsesretten skal Brugeren sende parking provider en e-mail, hvor Brugeren skriver, at køb/reservation fortrydes (se punkt 11.2.8.).',
        },
        sub_point_4:
            'Vær opmærksom på, at indkørsel på parkeringspladsen/godkendelse af købet i app eller hjemmesiden., anses for accept af, at parkering påbegyndes. Fortryder du herefter dit køb i app eller hjemmesiden, reduceres din tilbagebetaling med en forholdsmæssig del af den samlede pris for parkeringen i den købte periode, baseret på det antal dage/timer/minutter, køretøjet har holdt parkeret, indtil parking provider modtog registreringen om udøvelse af fortrydelsesretten.',
    },

    // --- 10. Vilkår for afmelding
    Trade_Terms_main_point_10: {
        main_title: 'Vilkår for afmelding',
        sub_point_1:
            'Brugeren kan vælge at lukke Brugerens konto i Appen, eller ved at lukke Brugerens konto via hjemmesiden, hvorved Brugerens parking provider konto ugyldiggøres, således at Brugeren ikke længere har mulighed for at betale for parkering via parking provider.',
        sub_point_2:
            'Ubetalte forhold vil blive opkrævet i overensstemmelse med indgået aftale, selvom Brugeren lukker parking provider kontoen.',
    },
    // --- 11. Løbetid, førtidig opsigelse mv.
    Trade_Terms_main_point_11: {
        main_title: 'Løbetid, førtidig opsigelse mv.',

        sub_point_1:
            'Denne Aftale er gyldig fra parking provider godkendelse af Brugeren og indtil den opsiges i overensstemmelse med vilkårene i Aftalen eller indtil andet skriftligt aftales.',

        sub_point_2: {
            sub_point_title:
                'parking provider er berettiget til straks at suspendere Brugers adgang til Tjenesterne, annullere Brugerens konto og/eller opsige Aftalen med øjeblikkelig virkning, såfremt:',
            sub_point_2_1:
                'Brugeren væsentligt misligholder sine forpligtelser i henhold til denne Aftale;',
            sub_point_2_2:
                'Brugeren ikke opfylder, eller der er rimelig grund til at antage, at Brugeren ikke vil opfylde sine betalingsforpligtelser i forhold til parking provider,',
            sub_point_2_3:
                'Brugeren, efter parking provider rimelige vurdering, kan forventes at blive betalings udygtig;',
            sub_point_2_4:
                'Brugeren anvender parking provider Tjenester i strid med Aftalen eller som på anden vis er til skade for eller påvirker parking provider eller eventuelle tredjeparter negativt;',
            sub_point_2_5:
                'Brugeren gentagne gange har parkeret et køretøj i strid med gældende love, regler og/eller regler angivet af den pågældende parking provider;',
            sub_point_2_6:
                'Brugeren har afgivet forkerte, mangelfulde eller vildledende oplysninger, eller',
            sub_point_2_7:
                'parking provider, på baggrund af en overordnet vurdering, finder det sandsynligt, at Brugeren kan være involveret i eller indblandet i kriminelle aktiviteter.',
            sub_point_2_8:
                'Opsigelse af Aftalen skal ske skriftligt til parking provider kontaktmail eller via formularen på hjemmesiden',
        },

        sub_point_3:
            'Opsigelse af Aftalen (uanset grund) påvirker ikke de rettigheder og/eller forpligtelser, som en Part har pådraget sig overfor den anden Part forud for datoen for opsigelsen af Aftalen.',
    },

    // --- 12. Parking provider erstatningsansvar
    Trade_Terms_main_point_12: {
        main_title: 'Parking provider erstatningsansvar',

        sub_point_1:
            'Parking provider samlede erstatningsansvar kan under ingen omstændigheder overstige et beløb svarende til Kr. 38.000,00, med mindre parking provider har handlet forsætligt eller har udvist grov uagtsomhed.',

        sub_point_2:
            'parking provider er ikke ansvarlig for ulykker, tyveri, personskader, skader på køretøjer, udstyr eller andre effekter monteret på eller i køretøjet.',

        sub_point_3:
            'parking provider er ikke ansvarlig for hverken indirekte tab eller følgeskader. parking provider er ikke erstatningsansvarlig i relation til Brugerens forhold til evt. tredjemand',

        sub_point_4: {
            sub_point_4_title:
                'parking provider er ikke erstatningsansvarlig for skader eller tab, som Administrator og/eller Brugeren har pådraget sig som følge af:',
            sub_point_4_1: 'Parkering på en parkeringsplads;',
            sub_point_4_2:
                'Brugerens fejl eller uagtsomhed, herunder hvis Brugeren ikke på korrekt vis har påbegyndt eller afsluttet en parkering (uanset om der er valgt at modtage en påmindelse eller en push-meddelelse fra parking provider), eller hvis Brugeren har angivet en forkert områdekode i forhold til en Parkeringsplads og/eller registreringsnummer, ved påbegyndelsen af en parkering (uanset om Brugeren har angivet en sådan områdekode manuelt, eller denne er foreslået via lokalitetsfunktionen i Appen);',
            sub_point_4_3:
                'at Brugeren ikke har overholdt sine forpligtelser i henhold til denne Aftale og vilkår for brug af parking provider eller at Brugeren på anden vis ikke har fulgt parking provider instrukser;',
            sub_point_4_4:
                'at Brugeren har parkeret køretøjet i strid med gældende love, regler og/eller regler angivet på den opslåede skiltning på pågældende parkeringsplads, hvor Brugeren parkerer køretøjet;',
            sub_point_4_5:
                'fejl eller utilstrækkelig funktionalitet på Brugerens mobiltelefon eller andet teknisk udstyr (såsom at udstyret er slukket eller batteriet er løbet tør for strøm);',
            sub_point_4_6:
                'sammenbrud, afbrydelse eller forsinkelser på telefon, internet eller andre kommunikationsnetværk, eller telekommunikationsoperatørens handlinger eller udeladelser, som påvirker Tjenestens funktionalitet eller tilgængelighed;',
            sub_point_4_7:
                'fejl eller defekt i en teknisk funktion, som angiver prisen for den pågældende Parkeringsafgift;',
            sub_point_4_8:
                'at Tjenesten er blevet afbrudt af parking provider på grund af forhold, der viser sig at være forkerte, men som parking provider havde grund til at tro var korrekte på tidspunktet for afbrydelsen, og som retfærdiggjorde afbrydelsen;',
            sub_point_4_9:
                'afbrydelser eller utilstrækkelig adgang til en eller flere Tjenester, som parking provider ikke med rimelighed havde kunnet forudse;',
            sub_point_4_10:
                'at en Parkeringsplads foreslået af parking provider ikke er ledig, når Brugeren ankommer dertil;',
            sub_point_4_11:
                'uautoriseret brug af Login-oplysninger og/eller Tjenester; eller',
            sub_point_4_12: 'force majeure (se punkt 15).',
        },

        sub_point_5:
            'parking provider er under ingen omstændigheder erstatningsansvarlig for indirekte skader såsom eksempelvis driftstab og tab af data. Parking provider er ikke erstatningsansvarlig i relation til Administrators og/eller Brugerens forhold til eventuelle tredjeparter.',
    },

    // --- 13. Brugerens erstatningsansvar
    Trade_Terms_main_point_13: {
        main_title: 'Brugerens erstatningsansvar',
        sub_point_1:
            'Brugeren skal holde parking provider skadesløs for erstatningskrav eller tab som følge af Brugerens fejl eller uagtsomhed, Brugerens manglende opfyldelse af sine forpligtelser i henhold til denne Aftale eller på anden vis manglende overholdelse af parking provider instrukser. Brugeren skal ligeledes holde parking provider skadesløs for krav fra tredjeparter, som er en direkte eller indirekte følge af Brugerens anvendelse af en Tjeneste.',
    },

    // --- 14. Immaterielle rettigheder
    Trade_Terms_main_point_14: {
        main_title: 'Immaterielle rettigheder',

        sub_point_1:
            'Brugeren accepterer, at software aldrig kan testes i alle mulige situationer, og at afvigelser fra den aftalte funktionalitet samt at uforudsete fejl og afbrydelser kan opstå. Parking provider er generelt tilgængeligt 24 timer i døgnet, dog med undtagelse af planlagte afbrydelser til opgraderinger, ændringer og vedligeholdelse. Retten til at opdatere parking provider med nye funktioner eller på anden vis foretage ændringer, eksempelvis for at tilpasse systemet til ny teknologi, nye sikkerhedsstandarder eller nye administrative procedurer etc. forbeholdes af parking provider. Parking provider påtager sig intet ansvar for eventuelle skader eller tab i forbindelse med manglende adgang til parking provider, at parking provider er ude af drift eller indeholder fejl.',

        sub_point_2:
            'Alle ophavsrettigheder (herunder rettigheder til kildekoder, computerprogrammer, algoritmer og objektkoder) og øvrige immaterielle rettigheder (heriblandt patentrettigheder og varemærker) vedrørende parking provider og dets indhold, ejes eller licenseres af parking provider eller dets leverandører og partnere. Administrator eller Brugeren får ikke i medfør af denne Aftale overdraget nogen af disse rettigheder. Det er ikke tilladt at anvende parking provider eller dets indhold til kommercielle formål. Brugeren har ikke ret til at kopiere, distribuere, sælge, offentliggøre, overdrage, udlåne, underlicensere, ændre eller på anden vis råde over softwaren indeholdt i parking provider. Brugeren har ikke ret til at foretage, demontering, reverse engineering, dekompilering eller på anden vis forsøge at få adgang til software kildekoden.',

        sub_point_3:
            'At alle oplysninger og al data, som overføres til parking provider, er fri for skadelige elementer, kildekoder eller malware (såsom virus, orm og trojanske heste) skal sikres og garanteres af Brugeren. Oplysninger, som Brugeren uploader til Mine Sider eller gør tilgængelig via Appen, må ikke krænke tredjemands immaterielle rettigheder eller på anden vis strider mod love, regler eller andres rettigheder. Det er Brugerens ansvar tredjemands eller andres immaterielle rettigheder ikke krænkes.',

        sub_point_4:
            'Medmindre parking provider har handlet groft uagtsomt eller forsætligt, er parking provider ikke ansvarlig for, at eventuelle data bliver gjort tilgængelige for tredjemand. parking provider anvender sædvanlige sikkerhedsforanstaltninger til beskyttelse af data',
    },

    // --- 15. Force majeure
    Trade_Terms_main_point_15: {
        main_title: 'Force majeure',
        sub_point_1:
            'parking provider er ikke erstatningsansvarlig eller ansvarlig for nedbrud eller forsinkelser i gennemførelsen af betingelserne i denne Aftale som følge af forhold, som er uden for parking provider rimelige kontrol.',
    },

    // --- 16. Fortrolighed
    Trade_Terms_main_point_16: {
        main_title: 'Fortrolighed',
        sub_point_1:
            'Brugeren accepterer, at parking provider rapporterer eventuelt misbrug af Tjenesterne, ulovlige aktiviteter, ulovlig eller upassende adfærd og/eller mistanke herom til politiet eller andre kompetente myndigheder.',
    },

    // --- 17. Lovvalg og tvister
    Trade_Terms_main_point_17: {
        main_title: 'Lovvalg og tvister',

        sub_point_1:
            'Denne Aftale er underlagt og skal fortolkes i henhold til dansk ret. Enhver tvist, uenighed eller ethvert krav opstået på grundlag af eller i forbindelse med denne Aftale, eller enhver misligholdelse, opsigelse eller ugyldighed heraf, skal som udgangspunkt løses ved frivillig aftale mellem Parterne. Hvis enighed ikke kan opnås i første omgang, afholdes en drøftelse mellem en repræsentant valgt af Brugeren og parking provider. Såfremt Parterne ikke kan nå til en aftale, kan tvisten, blive behandlet af de danske domstole med byretten i Aarhus som første instans. Dette punkt 17.1 er gældende efter ophøret eller udløbet af denne Aftale.',

        sub_point_2:
            'Hvis en bestemmelse i denne aftale tilsidesættes som ugyldig, skal Aftalen i øvrigt opretholdes, og den ugyldige bestemmelse erstattes med en gyldig bestemmelse, som det er muligt.',

        sub_point_3:
            'parking provider forbeholder sig ret til at ændre disse almindelige betingelser og vilkår for brug af parking provider. Såfremt dette sker, skal parking provider straks oplyse herom, og gøre en ny version af de almindelige betingelser og vilkår for brug af parking provider tilgængelig. Såfremt Brugeren herefter fortsætter med at anvende tjenesterne, anses dette for en accept af disse ændringer. Uanset dette forbeholder parking provider sig ret til at ændre priser og gebyrer/afgifter som følge af stigning i driftsomkostninger, øvrige omkostninger samt afgifts- og gebyrstigninger mv. De til enhver tid gældende almindelige vilkår og betingelser findes i App eller på hjemmeside.',
    },

    // --- 18. Abonnementsbetingelser
    Trade_Terms_main_point_18: {
        main_title: 'Abonnementsbetingelser',

        sub_point_1:
            'Ved oprettelse og benyttelse af parking provider Abonnementsparkering, accepteres, udover nedenstående, også de almindelige vilkår og betingelser for brug af parking provider. Disse betingelser fremgår af parking provider appen og på hjemmeside.',
        sub_point_1_1:
            'Ved indgåelse af aftale om abonnementsparkering opnår Brugeren en tidsbegrænset digital p-tilladelse.',

        sub_point_2:
            'Abonnementsparkeringsaftalen gælder for det valgte antal abonnementsparkeringsaftaler, som berettiger til parkering i samme antal parkeringsbåse på den valgte parkeringsplads. For Abonnementsparkering er det en gyldighedsbetingelse, at køretøjet registreres korrekt i parking provider. Korrekt og gyldig registrering kræver, at registreringsnummeret er registreret korrekt, samt at køretøjet er korrekt registreret på abonnementsparkeringsproduktet. Det registrerede køretøj må parkere i parkeringsbåse, som ikke på anden måde er reserveret. Dette gælder døgnet rundt alle ugens dage.',
        sub_point_2_1:
            'Abonnementsparkeringen vil fremgå under aktive parkeringer, lejede P-pladser.',
        sub_point_2_2:
            'Det er en gyldighedsbetingelse for korrekt og gyldig registrering, at det registrerede køretøj er valgt som favoritbil, og fremgår korrekt registreret på abonnementsparkeringsproduktet under lejede P-pladser.',

        sub_point_3:
            'Abonnementsparkeringsaftalen gælder for benyttelse af, en afmærket parkeringsbås efter ”først til mølle-princippet’. Dvs. Brugeren opnår med Abonnementsparkeringsaftalen alene en ”flydende ret” til en afmærket parkeringsbås, som ikke på anden vis er reserveret. I tilfælde af, at der ikke forefindes en ledig afmærket parkeringsbås, kan parking provider ikke gøres ansvarlig herfor, ligesom brugeren ikke har krav på reduktion af vederlaget.',
        sub_point_3_1:
            'Den omstændighed, at Brugeren ikke benytter abonnementsparkering, i den fulde valgte periode, medfører ikke at Brugeren er berettiget til en reduktion af vederlaget.',

        sub_point_4:
            'Abonnementsparkeringsaftalen træder i kraft fra og med den af Brugeren valgte dato, og løber i den anførte periode. Abonnementsparkeringsaftalen kan uden nærmere begrundelse opsiges straks af parking provider. Brugeren kan tidligst opsige til udgangen af en købt periode. Opsigelse sker ved, at Brugeren ikke fornyer eller forlænger Abonnementsparkeringsaftalen. I tilfælde af, at Brugeren har valgt automatisk fornyelse, skal brugeren stoppe automatisk fornyelse for at opsige abonnementsparkeringsaftalen.',
        sub_point_4_1:
            'Brugeren kan til enhver tid kun opsige Abonnementsparkeringsaftalen til udløb af den valgte periode. I så fald vil der ikke blive hævet penge fra Brugerens betalingskort før der oprettes en ny Abonnementsparkeringsaftale.',
        sub_point_4_2:
            'Abonnementsparkeringen er gældende fra den valgte dato og i den valgte periode. En abonnementsparkeringsaftale er således ikke nødvendigvis gældende fra den 1. til den 1. i en måned, medmindre Brugeren har valgt dette.',

        sub_point_5:
            'Brugeren er til enhver tid selv ansvarlig for, at der er en gyldig abonnementsaftale på det køretøj, som parkeres på parkeringspladsen. Det er ligeledes Brugerens eget ansvar, at tilknyttede køretøjer er registreret korrekt og fyldestgørende på profilen. Der kan pålægges kontrolafgift, såfremt der ikke er sket korrekt og fyldestgørende registrering af et parkeret køretøj. Kontrolafgiften kan ikke efterfølgende eftergives.',

        sub_point_6:
            'Abonnementsparkeringsaftalens indhold, priser og eventuelle særlige betingelser for Produktpakkerne vil til enhver tid være angivet på Hjemmesiden og i Appen. Vederlaget betales forud. Første gang ved Abonnementsparkeringsaftalens indgåelse.',
        sub_point_6_1:
            'Brugeren vil i nogle tilfælde få udleveret en unik produktkode, som skal anvendes ved registreringen. I forbindelse med modtagelse af den unikke produktkode orienteres Brugeren om, hvorledes brugeren skal forholde sig i forbindelse med betalingsforpligtelsen samt hvorledes registrering af den unikke produktkode skal ske.',
        sub_point_6_2:
            'I tilfælde af at abonnementsparkeringsaftalen enten opsiges, ophæves, fortrydes eller at den udleverede unikke produktkode annulleres eller spærres, er parking provider berettiget til at benytte de registrerede oplysninger, herunder brugers e-mailadresse mv. til at afgive meddelelse herom.',

        sub_point_7:
            'Vederlaget pristalsreguleres hvert år den 1. januar uden yderligere varsel, hvor det reguleres med nettoprisindekset for oktober md. i det foregående år, dog med minimum 3% (afrundet til nærmeste hele kroner) i forhold til vederlagsbetalingen året før. Indeksregulering af vederlaget sker på grundlag af det umiddelbart før reguleringen gældende vederlag, uanset om dette vederlag måtte være fremkommet ved regulering på anden måde end ved indeksregulering.',
        sub_point_7_1:
            'Udover ovenstående indeksregulering forbeholder parking provider sig ret til at ændre priser og gebyrer/afgifter som følge af stigning i driftsomkostninger, øvrige omkostninger samt afgifts- og gebyrstigninger mv. Sådanne ændringer træder tidligst i kraft ved udgangen af løbende måned + 1 måned efter, at brugeren er blevet informeret om sådanne ændringer.',

        sub_point_8:
            'Parking provider tager forbehold for prisfejl, prisændringer og opdateringsfejl.',

        sub_point_9:
            'Såfremt Brugeren har valgt automatisk fornyelse, er det brugerens eget ansvar at ”stoppe” den automatiske fornyelse, ved at opsige Abonnementsparkeringsaftalen. Det forhold at betaling stoppes, er ikke at anse for en opsigelse. Betaling opkræves indtil opsigelse af Abonnementsparkeringsaftalen.',

        sub_point_10:
            'Al færdsel og parkering foregår på brugers eget ansvar. Parking provider er ikke ansvarlig for tyveri eller skader, som måtte blive påført brugerens køretøj, uanset årsagen hertil.',

        sub_point_11:
            'Abonnementsparkeringsaftalen må ikke uden skriftligt samtykke fra parking provider, bruges til andet end parkering af det korrekt registrerede køretøj, med en registreret totalvægt på max. 3.500 kg.',

        sub_point_12:
            'Brugeren er ved denne Abonnementsparkeringsaftale gjort udtrykkeligt opmærksom på, at indgåelse af denne Abonnementsparkeringsaftale ikke berettiger brugeren til at annullere pålagte kontrolgebyrer. Abonnementsparkeringsaftalen er først gyldig fra det tidspunkt, hvor registreringsnummeret er registreret korrekt. Abonnementsparkeringsaftalen er kun gyldig for det køretøj, som er registreret korrekt.',
        sub_point_12_1:
            'Abonnementsparkeringsaftalen berettiger kun til parkering på det område, som fremgår af abonnementsparkeringsaftalen, i de afmærkede parkeringsbåse hvor det ikke fremgår, at der er særlige regler gældende for parkering i disse parkeringsbåse. Der gøres opmærksom på, at Abonnementsparkeringsaftalen ikke er en gyldig parkeringstilladelse til parkering i parkeringsbåse, som er reserveret.',

        sub_point_13:
            'Ved brugerens væsentlige misligholdelse af aftalen kan parking provider ophæve Abonnementsparkeringsaftalen med øjeblikkelig virkning. Som væsentlig misligholdelse betragtes blandt andet, men er ikke begrænset til, manglende betaling af det aftalte vederlag, misligholdelse af denne aftales bestemmelser samt enhver overtrædelse af parkeringsbestemmelserne. Ved væsentlig misligholdelse er parking provider berettiget til at pålægge kontrolgebyr og eventuelt fjerne eller tage brugerens køretøj i forvaring indtil, de skyldige gebyrer og omkostninger er betalt. Brugeren har ikke adgang til modregning, selvom der måtte være/ er uenighed om kravet',
        sub_point_13_1:
            'parking provider kan opsige Abonnementsparkeringsaftalen skriftligt med 1 måneds varsel i tilfælde af, at der skal udføres vedligehold, ombygning, renovation o.lign. forhold, der medfører, at parking provider permanent ikke kan benytte parkeringsbåsen længere.',

        sub_point_14:
            'I henhold til den danske forbrugeraftalelov (Lov nr. 1457 af 17. december 2013), har Brugeren ret til at fortryde indgåelsen af Aftalen ved meddelelse herom til parking provider kundeservice inden for 14 dage efter godkendelse af registreringen. For at kunne benytte fortrydelsesretten, skal fortrydelsesmeddelelsen være indleveret til parking provider senest på 14. dagen for den dag, hvor indbetalingen er registreret hos parking provider.',
        sub_point_14_1:
            'Udløber fristen på en helligdag, lørdag, grundlovsdag, juleaftensdag eller nytårsaftensdag forlænges fristen til den følgende hverdag',
        sub_point_14_2:
            'For at udøve fortrydelsesretten skal Brugeren sende os en e-mail eller et brev, hvor Brugeren skriver, at køb/reservation fortrydes. Vær opmærksom på, at indkørsel på parkeringspladsen/godkendelse af købet i app eller hjemmesiden, anses for accept af, at parkering påbegyndes og en accept af at 14 dages fortrydelsesret frasiges. Fortryder du herefter dit køb i app eller hjemmesiden, reduceres din tilbagebetaling med en forholdsmæssig del af den samlede pris for parkeringen i den købte periode, baseret på det antal dage/timer/minutter, køretøjet har holdt parkeret, indtil parking provider modtog registreringen om udøvelse af fortrydelsesretten',

        sub_point_15:
            'Eventuelle tvister mellem parking provider og Brugeren vedrørende forståelsen af denne aftale skal afgøres ved de almindelige domstole med anvendelse af dansk ret. Som værneting er aftalt Retten i Aarhus.',

        sub_point_16:
            'Brugeren er ikke berettiget til at fremleje parkeringsbåsen. Overtrædelse heraf anses som misligholdelse, jf. punkt 13.',

        sub_point_17:
            'parking provider er parkeringsadministrator på vegne af pladsejer/pladsejers ejendomsadministrator. Al henvendelse vedr. nærværende kontrakt skal ske til parking provider. Ophører parking provider som parkeringsadministrator, vil aftalen blive overdraget til ny parkeringsadministrator.',

        sub_point_18:
            'I forhold til opbevaring og behandling af personoplysninger, da henvises til den til enhver tid gældende datapolitik som fremgår ovenfor. Hvis oplysningerne ønskes slettet, betragtes dette som opsigelse af abonnementsparkeringsaftalen. Det skyldes, at parking provider i disse tilfælde ikke kan opretholde aftalen uden de nævnte oplysninger.',
    },

    // ### UPDATED TERMS END ###

    Footer_contact_info: {
        updatedAt: `Revideret den 16.11.2022`,
    },

    Terms_title: 'Vilkår og betingelser',
    Terms_heading: 'DATAPOLITIK OG COOKIES',
    Terms_last:
        'Parkanten bærer det fulde ansvar for, at de afgivne oplysninger er korrekte. Udbyderen fraskriver sig samtidig ethvert ansvar for eventuelle fejl, der måtte opstå i forbindelse med oprettelsen.',

    Terms_1: {
        para_1: 'Disse retningslinjer gælder for de informationer, vi indsamler på folk, som afgiver dem via hjemmesiden, mail og telefonisk henvendelse. Når du giver Parkeringskompagniet personoplysninger, samtykker du samtidig i, at vi behandler dine persondata i overensstemmelse med vores datapolitik. Personlige oplysninger omfatter enhver form for information om en identificerbar person. Vi forbeholder os retten til løbende at opdatere vores datapolitik i overensstemmelse med gældende lovgivning på området og vil i videst muligt omfang opdatere vores kunder herom.',
        para_2: 'Databehandler er Parkeringskompagniet ApS',
        para_3: 'Ryesgade 7b, 8000 Aarhus',
        para_4: 'CVR-nr: 37127485',
        link_1: 'Telefon: <a href="tel:+ 45 88 77 31 50" class="text-pk-blue">+ 45 88 77 31 50</a>',
        link_2: 'Mail: <a href="mailto:service@oparko.com" class="text-pk-blue">service@oparko.com</a>',
    },

    Terms_2: {
        heading: 'Persondatapolitik',
        para_1: 'Personlige data gemmes kun, hvis de er frivilligt oplyst, og vi gemmer dem kun så længe, de er relevante for os.',
        para_2: 'Hvis du giver os oplysninger om en anden, er det dit ansvar at sikre, at du har retten til at give os disse oplysninger.',
        para_3: 'Vi videregiver kun dine personoplysninger, hvis det er nødvendigt for den service, vi leverer.',
        link_1: 'Du har til hver en tid ret til at få indsigt i de personoplysninger, vi har på dig, og hvis de ikke er korrekte, har du ret til at få rettet de pågældende oplysninger. Herudover har du altid ret til at blive slettet af vores systemer. Desuden har du også altid de rettigheder, som Den Europæiske Unions generelle databeskyttelsesforordning giver enkeltpersoner. Hvis du har nogle henvendelser angående dine personlige oplysninger, bedes du henvende dig på <a href="mailto:service@oparko.com" class="text-pk-blue">service@oparko.com</a>.',
    },

    Terms_3: {
        heading: 'Indsamling og behandling af dine personoplysninger',
        para_1: 'Afhængigt af de tjenester, du bruger, registrerer og gemmer vi dine personoplysninger. Hvis du f.eks. skriver en klage til os eller bliver oprettet som kunde, gemmer vi typisk dit navn, email-adresse og telefonnummer. Vi gemmer oplysningerne for at kunne betjene dig bedst muligt. Du vil til hver en tid blive informeret i forbindelse med indsamling af oplysninger.',
        ul: {
            heading:
                'Indsamling af personlige oplysninger sker oftest i forbindelse med:',
            list: [
                'Betaling af parkeringsafgift',
                'Henvendelse ved klage eller interesse i en aftale',
                'Udstedelse af parkeringsafgift',
                'Parkeringskontrol',
                'Ved leje eller reservation af en parkeringsplads',
                'Ved indtastning i vores app',
                'Ved tjenester, som kræver betaling, gemmer vi nødvendige kreditkortdata og faktureringsoplysninger',
                'Til nyhedsbreve og månedsrapporter, hvis du er eksisterende kunde i Parkeringskompagniet',
            ],
        },
    },

    Terms_4: {
        heading: 'Videregivelse af personoplysninger',
        para_1: 'Vi deler ikke dine personlige oplysninger med andre, medmindre du har givet os tilladelse til det, eller hvis det er påkrævet i henhold til gældende lovgivning om persondatapolitik.',
        row_1: {
            heading: 'Retsgrundlaget for behandling',
            para_1: 'Databeskyttelsesforordningens artikel 6, stk. 1, litra b, når der er indgået en kontrakt mellem dig som parkant og Parkeringskompagniet ApS',
            para_2: 'Databeskyttelsesforordningens artikel 6, stk. 1, litra f, når Parkeringskompagniet ApS har en legitim interesse i at forfølge et krav mod dig som parkant, f.eks. hvis du har holdt i strid med bestemmelserne på en P-plads og er blevet pålagt en parkeringsafgift.',
            para_3: 'Databeskyttelsesforordningens artikel 6 stk.1, litra a, når Parkeringskompagniet ApS har fået dit samtykke til at sende nyhedsbreve ud til dig.',
        },

        row_2: {
            heading: 'Kilde',
            para_1: 'Parkeringskompagniet indsamler personoplysninger direkte hos dig og/eller tredjemand, f.eks. hos vores kunde eller hos vores underleverandører.',
        },

        row_3: {
            heading: 'Hvor lagres dine personlige oplysninger?',
            para_1: 'Dine personlige oplysninger gemmes på vores interne netværk og kan kun tilgås med specielle rettigheder. Vi har ikke adgang til betalingsoplysninger, da disse håndteres krypteret af vores betalingspartnere.',
            para_2: 'Cookies er en tekstfil, som lægges på den maskine, du bruger til at besøge vores hjemmeside, og som gør det muligt at genkende maskinen og samle information om, hvilke sider og funktioner, der besøges. Cookies indeholder oplysninger i anonymiseret form.',
            para_3: 'Du er anonym i vores cookie-data, indtil du selv melder dig til en af vores services eller sender os en henvendelse, hvori du selv angiver personlige informationer.',
            link: 'Vores hjemmeside bruger Google Analytics, som er en hjemmeside, der hjælper os med webanalyseservice - de anvender cookies. Det gør de udelukkende, for at vi kan forbedre oplevelsen for vores brugere. Vi opsamler udelukkende information om din brug af Parkeringskompagniets hjemmeside. Google Analytics indsamler oplysninger om dit operativsystem, browser, IP-adresse, den tidligere besøgte hjemmeside og dato og tidspunkt for, hvornår du har besøgt vores hjemmeside. Vi benytter ikke data fra cookies til at indsamle personlige oplysninger om dig, og ingen af de informationer, vi får fra cookies, sendes videre eller sælges. For flere oplysninger om Google Analytics’ brug af cookies, kan du besøge følgende hjemmeside: <a href="https://policies.google.com/privacy?hl=da" class="text-pk-blue">HTTPS://POLICIES.GOOGLE.COM/PRIVACY?HL=DA</a>',
        },

        row_4: {
            heading: 'Fravalg af cookies',
            link: 'Hvis du på et tidspunkt ønsker at fravælge cookies, kan du gøre det via dine browser-indstillinger. Du kan læse om, hvordan du fravælger cookies via din browser, på <a href="http://www.minecookies.org/" class="text-pk-blue">WWW.MINECOOKIES.ORG</a>',
        },

        row_5: {
            heading: 'Hvad sker der, hvis jeg fravælger cookies?',
            para_1: 'Hvis du fravælger cookies, vil det ikke blive registreret, når du browser. Du skal være opmærksom på, at når du fravælger cookies, så fravælger du også en del af hjemmesidens funktioner, og det kan gøre, at hjemmesiden måske ikke vil fungere korrekt.',
        },

        row_6: {
            heading: 'Hvorfor informerer vi om cookies?',
            para_1: 'Vi informerer om cookies, fordi alle danske websites er forpligtet til at informere om dem jf. bekendtgørelse om krav til information og samtykke ved lagring af eller adgang til oplysninger i slutbrugerens terminaludstyr.',
        },

        row_7: {
            heading: 'Ønsker du at kontakte os?',
            link: 'Har du uforløste spørgsmål eller ønske om at kontakte os yderligere, henviser vi til <a href="https://parkeringskompagniet.dk/kontakt/" class="text-pk-blue">kontakt siden</a>',
        },
    },
    ReceptionUser: {
        countryError: 'Landekode er ikke valgt',
        registrationError: 'Udfyld Registreringsnummer',
        emailError: 'Udfyld E-mail',
        customEndDateError: 'Vælg sluttidspunkt (mindst 30 min fra aktuel tid)',
        phoneNumberError: 'Telefonnummer er ikke valgt',
        acceptError: 'Vilkår er ikke accepteret',
        countryCodeError: 'Landekode er ikke valgt',
    },
    'Select the Date of Parking': 'Vælg parkeringsdatoen',
    'Enter your Full Name': 'Indtast dit fulde navn',

    Phonenumber: 'Telefonnummer',
    'Enter your Email': 'Udfyld din email',
    'Choose your enddate': 'Vælg sluttidspunkt',
    'Choose your startdate': 'Vælg starttidspunkt',
    'Custom end date': 'Vælg selv sluttidspunkt',
    'Max time in min (0 is no limit)': 'Max tid i minutter (0 = ubegrænset)',

    'Valid from': 'Gyldig fra',
    'Valid until': 'Gyldig indtil',
    'Create new guest parking': 'Opret ny gæsteparkering',
    ERR_TIME_RULE_HOUR: 'Tilladelser må kun oprettes indenfor:',
    ERR_TIME_RULE_DAY_Monday: 'Tilladelser må ikke oprettes om mandagen',
    ERR_TIME_RULE_DAY_Tuesday: 'Tilladelser må ikke oprettes om tirsdagen',
    ERR_TIME_RULE_DAY_Wednesday: 'Tilladelser må ikke oprettes om onsdagen',
    ERR_TIME_RULE_DAY_Thursday: 'Tilladelser må ikke oprettes om torsdagen',
    ERR_TIME_RULE_DAY_Friday: 'Tilladelser må ikke oprettes om fredagen',
    ERR_TIME_RULE_DAY_Saturday: 'Tilladelser må ikke oprettes om lørdagen',
    ERR_TIME_RULE_DAY_Sunday: 'Tilladelser må ikke oprettes om søndagen',
    'Please enter your registration number':
        '* Udfyld venligst dit registreringsnummer',
    'Please enter your E-mail address': '* Udfyld venligst din E-mail adresse',
    fillField: '* Udfyld venligst dette felt',
    'Please choose a date/time':
        '* Sluttidspunktet skal være mindst 30 minutter efter den aktuelle tid',
    'Start time before end time':
        'Starttidspunktet skal være før sluttidspunktet.',
    'Please enter your phone number': '* Udfyld venligst dit telefonnummer',
    'Please accept our terms to continue': '* Påkrævet',

    ConfirmPermit: {
        lineOne: 'Der er nu opsat en gæsteparkering kl',
        for: 'til',
        on: 'på',
        at: 'på',
        lineTwo: 'som er gældende til og med',
    },
    'Receive SMS?': 'Modtag SMS?',
    'Guest Parking has been created!': 'Gæsteparkering er blevet oprettet!',
    'A Guest parking permit has now been created':
        'Der er nu oprettet en gæsteparkeringstilladelse',

    ReceptionPermitSuccessPopup: {
        created: 'En ny tilladelse er blevet oprettet!',
        subtitle: 'Du kan se detaljerne nedenfor.',
        createAnother: 'Klik her for at oprette en ny tilladelse.',
        notValid: 'Ikke gyldig',
        onePermitAllowedPerDay:
            'Der er allerede givet en tilladelse til denne bil i dag. Kun 1 tilladelse pr. bil pr. dag tilladt.',
        erroPermitLimit: 'FEJL - Tilladelsesgrænse',
    },
    // Entities

    Reception: 'Reception',
    HotelReception: 'Hotel Reception',
    EmployeeReception: 'Medarbejder reception',
    TimesReception: 'Times Reception',
    HotelAdmin: 'Hotel Admin',
    ConfirmationReception: 'Konfirmationsmodtagelse',
    HotelReceptionConfirmation: 'Hotel receptionsbekræftelse',
    StayNTouchReception: 'Stay-N-Touch-modtagelse',
    APIPartner: 'API-partner',
    SMSConfirmationReception: 'SMS bekræftelse modtagelse',
    Guest_parking_created:
        'Oprettet gæsteparkering for {{regNo}} der er gyldig til og med {{date}}',
    'Something went wrong. Please try again.':
        'Noget gik galt. Prøv venligst igen.',
    Enter_registration_number: 'Indtast registreringsnummer',
    Confirm: 'Bekræft',
    Clear_all: 'Ryd alt',

    View: 'Se',
    Edit: 'Rediger',
    AppFines: 'AppFines',
    AppPermits: 'AppPermits',
    NOT_DEFINED: 'NOT_DEFINED',
    SELF_TICKETING: 'SELF_TICKETING',
    COMBI: 'COMBI',
    P_WARDEN: 'P_WARDEN',
    CAMERA_CONTROL: 'CAMERA_CONTROL',
    Partner: 'Partner',
    Private: 'Privat',
    Company: 'Selskab',
    'Not Handled': 'Ikke håndteret',
    'Not handled': 'Ikke håndteret',
    Approved: 'Godkendt',
    Rejected: 'Afvist',
    'Other - write a comment in the note':
        'Andet - skriv en kommentar i notatet',
    'Outside Booth': 'Udenfor Booth',
    'No permission to the area': 'Ingen tilladelse til området',
    'Parking disc exceeded': 'Parkeringsskive overskredet',
    'Parking or full stop on prohibited area':
        'Parkering eller punktum på forbudt område',
    'Parking on fire access road': 'Parkering på brandadgangsvej',
    'Handicapped parking without permission':
        'Handicapparkering uden tilladelse',
    Deleted: 'Slettet',
    'Guest Parking': 'Gæsteparkering',
    'Oprettelse af medarbejderparkering': 'Oprettelse af medarbejderparkering',
    'Employee Parking Creation': 'Oprettelse af medarbejderparkering',
    'Employee parking creation': 'Oprettelse af medarbejderparkering',
    Resident: 'Beboer',
    'Paid ticket': 'Betalt billet',
    'Employee paid ticket': 'Medarbejder betalt billet',
    'Employee upper basement': 'Medarbejder øverste kælder',
    'Employee lower basement': 'Medarbejder nederste kælder',
    Permanent: 'Permanent',
    License: 'Licens',
    Reminder: 'Påmindelse',
    'Active - Foreign': 'Aktiv - Udenlandsk',
    'Debt collection - Paragraph': 'Inkasso - Stk',
    Ended: 'Afsluttet',
    Foreign: 'Udenlandsk',
    Paused: 'Pause',
    'Debt collection - Paragraph - installment agreement with demand':
        'Inkasso - Stykke - afdragsaftale med påkrav',
    'Debt collection - Paragraph - with demand':
        'Inkasso - Paragraf - med påkrav',
    'Debt collection - Liquidation': 'Inkasso - Likvidation',
    'Debt collection - Liquidation - installment agreement with demand':
        'Inkasso - Likvidation - afdragsaftale med påkrav',
    'Complaint Council': 'Klagerådet',
    All: 'Alle',
    'Occupancy in': 'Belægning i procent',

    // Subscription
    Next: 'Næste',
    Previous: 'Forrige',
    Subscription: 'Abonnement',
    license: 'Månedlig betaling',
    Submit: 'Indsend',
    Subscribers: 'Abonnenter',
    'Already subscribed': 'Allerede abonnent',
    'E.g.': 'F.eks.',
    '12th Star Avenue': 'Stjernevej 12',
    'Step 1: Which parking lot do you want to park at?':
        'Step 1: Hvilken parkeringsplads vil du parkere på?',
    'Step 2: Which license plate does your car have?':
        'Step 2: Hvilken nummerplade har din bil?',
    'Step 3: When should your subscription start?':
        'Step 3: Hvornår skal dit abonnement starte?',
    'Step 4: Your monthly price is based on the selected parking lot, and will be:':
        'Step 4: Din månedlige pris er baseret på den valgte parkeringsplads og er:',
    'Step 5: To be allowed to create a subscription for this private parking lot, you must enter a pin code below. Next, click on Create to go to the payment site. Once you are done, you will be redirected back to our page, where you can find your subscription in the table.':
        'Step 5: For at få lov til at oprette et abonnement til denne private parkeringsplads skal du indtaste en pinkode nedenfor. Klik derefter på knappen Opret, og du vil blive ført til en betalingsside. Når betalingen er gennemført vil du blive sendt tilbage her til vores side, hvor du kan finde dit abonnement i tabellen.',
    'Step 5:  Click on Create to go to the payment site. Once you are done, you will be redirected back to our page, where you can find your subscription in the table.':
        'Step 5:  Klik på Opret for at gå til betalingssiden. Når du er færdig, bliver du sendt tilbage til vores side, hvor du kan finde dit abonnement i tabellen.',
    'Below you can below see the available days, times and prices':
        'Du kan nedenfor se ledige dage, tider og priser',
    pay_at_exit_button: 'Ønsker du at betale for din parkering?',
    'Available days, times and prices': 'Ledige dage, tider og priser',
    pay_at_exit_prompt:
        'Ønsker du at betale for din parkering når du forlader pladsen?',
    'Transaction fee': 'Transaktionsgebyr',
    'Subscription Info': 'Abonnement Info',
    'Monthly price': 'Månedlig pris',
    'Last recurring payment date': 'Sidste tilbagevendende betalingsdato',
    'Car Info': 'Bil Info',
    'Enter registration number': 'Indtast nummerplade',
    'Buy monthly subscription': 'Køb månedligt abonnement',
    'Buy short ticket': 'Køb enkelt billet',
    'Short ticket': 'Enkelt billet',
    'The price is': 'Prisen er',
    'kr pr. month, but the price on specific parking spots may vary':
        'kr pr. måned, men kan variere fra specifikke parkeringsbåse',
    'Registration number': 'Registreringsnummer',
    'PIN code': 'PIN kode',
    'Email id is already registered with us':
        'E-mail adressen er allerede registeret hos os',
    'Buy ticket': 'Køb billet',
    'Get ticket': 'Få billet',
    'Permit id': 'Tilladelse id',
    'Last payment': 'Sidste betaling',
    'Price per period': 'Pris pr. periode',
    'Stop subscription': 'Stop abonnement',
    'Price: 500 kr. per month (normal price is 625 kr. per month - The discount is active for the rest of 2023)':
        'Pris: 500 kr. pr. måned (Normalpris er 625 kr. pr. måned - Rabatten gælder resten af 2023)',
    'Payment Options': 'Betalingsmuligheder',
    'Create Subscription Rule': 'Opret abonnement regel',

    // FAQs
    'How do I see and create a permit?':
        'Hvordan ser og opretter man tilladelser?',
    'How do I see the fines that has been made at my parking space?':
        'Hvordan ser jeg afgifter som er lavet på min parkeringsplads?',
    'How do I cancel a fine?': 'Hvordan annullerer jeg en afgift?',
    'How do I create a user?': 'Hvordan opretter man en bruger?',
    'How do I change the numberplate on an existing permit?':
        'Hvordan ændrer jeg nummerplade på en tilladelse?',
    'How do I extend a permit?': 'Hvordan forlænger jeg en tilladelse?',
    "What to do if something doesn't work?": `Hvad gør jeg hvis noget ikke virker?`,
    'How often do you pay out customer shares?': `Hvor ofte afregner I?`,
    'Why am I being paid for a parking fee that is several years old now?':
        'Hvorfor afregnes jeg for en flere år gammel afgift nu?',
    'Status and their meanings': 'Status og deres betydninger',

    // FAQ
    Introduction: 'Introduktion',
    'Usage of platform': 'Brug af platform',
    'Platform features': 'Platform funktioner',
    'Usage of app': 'Brug af app',
    Settlements: 'Afregninger',
    Danish: 'Dansk',
    English: 'Engelsk',

    // Introduction
    'Hvor kan jeg se en præsentationsvideo af OPARKO?': `Hvor kan jeg se en præsentationsvideo af OPARKO?`,
    'Hvad gør jeg hvis noget ikke virker?': `Hvad gør jeg hvis noget ikke virker?`,

    // answerIntro_1: {
    //     paragraph1: `Her er en præsentationsvideo af OPARKO`,
    // },

    answerIntro_2: {
        paragraph: `Det hjælper ofte at logge ud og ind igen, så det anbefaler vi dig altid at du gør først. Virker det stadig ikke er du altid velkommen til at skrive en mail til os på service@oparko.com . For at vi hurtigere kan hjælpe dig, må du meget gerne medsende skærmbilleder af problemet (hvis der er sådan ét). Har du brug for hjælp her og nu, så er vores telefon åben mandag, tirsdag og torsdag 11-15 og fredag 11-13. Ring på telefon 8874 3194.`,
    },

    // Usage of platform
    'Hvordan ser og opretter man tilladelser?': `Hvordan ser og opretter man tilladelser?`,
    'Hvordan ser jeg afgifter som er lavet på min parkeringsplads?': `Hvordan ser jeg afgifter som er lavet på min parkeringsplads?`,
    'Hvordan opretter man en bruger?': `Hvordan opretter man en bruger?`,
    'Hvordan annullerer jeg en afgift?': `Hvordan annullerer jeg en afgift?`,
    'Hvordan ændrer jeg nummerplade på en tilladelse?': `Hvordan ændrer jeg nummerplade på en tilladelse?`,
    'Hvordan forlænger jeg en tilladelse?': `Hvordan forlænger jeg en tilladelse?`,
    'Status og deres betydninger': `Status og deres betydninger`,

    answerParkOparko_1: {
        paragraph: `Tryk på “Dashboard” i venstre side, og vælg derefter “Tilladelser”. På denne side kan man se de nyeste tilladelser. Hvis man vil søge efter en specifik tilladelse kan dette gøres ved at søge på et reg. nr. eller ID i søgefeltet øverst. Hvis man vil oprette en ny tilladelse trykker man på knappen “Opret tilladelse”. Udfyld felterne med oplysningerne om bilen. Reg. nr. Parkeringsplads og Type er obligatoriske. Noter kan bruges til at give flere oplysninger om tilladelsen. “Note” kan kun ses af administratoren. “Ekstern note” kan ses af vagterne, når de laver P-kontrol. Hvis en bil kun må holde på en bestemt plads, kan man fx skrive i ekstern note; “Plads 22”. Husk at sætte en “Slut dato” for tilladelsen. Skal bilen have en permanent tilladelse, så trykker man på boksen “Permanent tilladelse” Til sidst trykker man på “Opret”.`,
    },

    answerParkOparko_2: {
        paragraph: `Tryk på “Dashboard” og derefter på “Afgifter”. På denne side kan man se de nyeste oprettede afgifter. Ønsker man at søge efter en specifik afgift, kan man gøre det ved at søge efter bilens reg. nr. eller afgiftens ID i søgefeltet øverst. For at se mere info omkring en specifik afgift skal man trykke på den. “Status” viser hvor langt afgiften er i inddrivelsesprocessen. “Aktiv” betyder at afgiften er oprettet. “Inddrivelse” betyder at der er sendt brev til afgiftsmodtager. “Betalt” betyder at vi har modtaget betaling for afgiften. “Afregnet” betyder at vi har udbetalt jeres andel af afgiften til jer. “Annulleret” betyder at afgiften er annulleret.`,
    },

    answerParkOparko_3: {
        paragraph: `Tryk på “Dashboard” og derefter på “Brugere”. Her kan man se en liste med alle de brugere, som er tilknyttet jeres organisation. For at oprette en ny bruger trykker man på “Opret bruger”. Indtast oplysningerne på brugeren. For nemhedens skyld anbefaler vi at man bruger Email til brugernavnet også. Vælg hvilke P-pladser, som brugeren skal have adgang til, samt om brugeren skal have adgang til platformen og/eller appen. Vælg en slut dato for brugeren. Skal brugeren være permanent trykker man på boksen “Permanent bruger”. Til sidst trykker man på “Opret”. En Email sendes derefter til brugeren, med deres login info.`,
    },

    answerParkOparko_4: {
        paragraph: `Åben afgiften, som skal annulleres, ved at trykke på den. Et vindue med flere informationer åbner derefter op. Tryk derefter på feltet “Status” og vælg “Annulleret”. Scroll ned på siden og skriv en kommentar om hvorfor afgiften skulle annulleres. Tryk på “Gem” for at gemme kommentaren, og til sidst trykker man på “Opdater”. Afgiften er nu annulleret.`,
    },

    answerParkOparko_5: {
        paragraph: `På siden 'Tilladelser' indtaster du nummerpladen på bilen i søgefeltet og trykker enter/Søg. På listen nedenfor klikker du på den relevante tilladelse. I feltet ‘Reg.nr.’ ændrer du til det nye registreringsnummer. Herefter tjekker du at parkeringspladsen, slutdato og det øvrige ser korrekt ud og trykker derefter på 'Opdater'.`,
    },

    answerParkOparko_6: {
        paragraph: `På siden 'Tilladelser' indtaster du nummerpladen på bilen i søgefeltet og trykker enter/Søg. På listen nedenfor klikker du på den relevante tilladelse. I feltet "slutdato" vælger du i stedet den nye ønskede slutdato. Verificer at det øvrige ser korrekt ud og tryk derefter på 'Opdater'.`,
    },

    answerParkOparko_7: {
        paragraph1: `Aktiv: Afgiften er oprettet i vores system.`,
        paragraph2: `Inddrivelse: Afgiften er sendt til inddrivelse ved vores samarbejdspartner og der er sendt brev af sted til parkanten.`,
        paragraph3: `Betalt: Når afgiften er betalt, så skifter afgiften status til betalt.`,
        paragraph4: `Afregnet: Afgiftsandelen er udbetalt til afgiftsskriveren.`,
        paragraph5: `Annulleret: Afgiften er annulleret i vores system.`,
        paragraph6: `Beskyttet: Udenlandsk sag.`,
    },

    // Usage of platform
    platformFeatures_1: {
        paragraph1: `Dette afsnit giver dig et visuelt overblik over nøgletal og udvikling i organisationens aktivitet over tid. Graferne viser trends og sammenhænge baseret på udvalgte parametre som periode, lokation og type. Du kan bruge visningen til at identificere mønstre og vurdere performance. Under hver graf findes ofte en tabel med relaterede data for yderligere indsigt.`,
    },

    platformFeatures_2: {
        paragraph1: `Her får du et samlet overblik over alle tilladelser, du har adgang til. Du kan nemt oprette nye, redigere eksisterende og administrere deres informationer. Tabellen markeret med rød viser listen over tilladelser – klik på en tilladelse for at se detaljer eller foretage ændringer. Øverst finder du en søgefunktion, som gør det nemt at finde specifikke tilladelser via Reg. nr, ID eller lignende. Her kan avanceret filter også benyttes, hvor der kan filtreres på parkeringsplads, status, type, organisation og datoer.`,
        paragraph2: `Når du klikker på "Opret Tilladelse", åbnes et vindue, hvor du indtaster landekode, registreringsnummer, vælger tilladelsestype samt gyldighedsperiode – altså fra og til. Herefter vælger du den eller de parkeringspladser, tilladelsen skal gælde for, samt hvilken bruger den skal oprettes for. Felterne Note og Regler er valgfrie; noter bruges til interne bemærkninger, og regler angiver evt. særlige aktive tidsrum. Klik på "Opret" nederst, når alle oplysninger er udfyldt.`,
        paragraph3: `Når du klikker på en tilladelse i listen, åbnes et vindue, hvor du kan se og opdatere tilladelsens oplysninger. Du har mulighed for at ændre reg. nr., gyldighedsperiode, parkeringsplads og øvrige relevante informationer. Husk at gemme dine ændringer ved at klikke på "Opdater" nederst i højre hjørne, når du er færdig.`,
    },

    platformFeatures_3: {
        paragraph1: `Her får du et samlet overblik over alle afgifter oprettet i din organisation. Du kan nemt oprette nye afgifter samt se og redigere eksisterende. Klik på en afgift for at se detaljer eller foretage ændringer. Øverst på siden finder du en søgefunktion, der gør det let at finde specifikke afgifter ved hjælp af registreringsnummer, ID eller andre nøgleoplysninger. Du har også adgang til avanceret søgning, hvor du kan filtrere afgifter baseret på parkeringsplads, status, organisation og oprettelsesdato.`,
        paragraph2: `Når du klikker på knappen "Opret Afgift", åbnes et nyt vindue, hvor du kan indtaste alle relevante oplysninger for afgiften – herunder landekode, registreringsnummer og "Fine Origin" (angiver, hvor afgiften er genereret – f.eks. via app, kameraplatform mv. Hvis du er i tvivl, vælg blot "fine"). Du skal også vælge en adresse og angive både start- og slutdato for forseelsen. Derefter vælger du typen af forseelse. Afslutningsvis, skal der minimum uploades 2 billeder. Når alle nødvendige oplysninger er indtastet, afslutter du ved at klikke på "Opret" nederst i højre hjørne.`,
        paragraph3: `Når du klikker på en afgift i listen, åbnes et vindue, hvor du kan gennemse afgiftens oplysninger. Du har her mulighed for at tilføje kommentarer, interne noter eller helt at annullere afgiften ved at trykke på "Annuller afgift". Husk at gemme eventuelle ændringer ved at klikke på "Opdater" nederst i højre hjørne, når du er færdig.`,
    },

    platformFeatures_4: {
        paragraph1: `Her får du et samlet overblik over alle parkeringspladser, du har adgang til. Du kan oprette en ny parkeringsplads ved at klikke på knappen "Opret Parkeringsplads", eller vælge en eksisterende fra listen for at se og redigere dens oplysninger. Øverst på siden finder du en søgefunktion, som gør det nemt at finde bestemte parkeringspladser ved at søge på f.eks. ID, navn, adresse eller anden relevant information.`,
        paragraph2: `Når du klikker på knappen "Opret Parkeringsplads", åbnes et nyt vindue, hvor du kan indtaste oplysninger for den nye parkeringsplads. Formularen i venstre side indeholder de generelle informationer. Start med at vælge den organisation, parkeringspladsen skal tilknyttes. Vælg herefter tilladelsesdeling (typisk "Area"), og indtast navn, adresse, postnummer og by. Tilføj koordinater for placeringen – disse kan f.eks. findes via Google maps. Parkeringsspots er valgfri og bruges til at angive antallet af individuelle pladser på området.`,
        paragraph3: `Tilføj herefter et "profilbillede" til parkeringspladsen og eventuel note (valgfri).`,
        paragraph4: `Herefter vælger du den ønskede kontroltype og udfylder de tilhørende felter. Dernæst angives relevante tilladelsesregler, hvor du kan aktivere P-billetter, månedlig betaling og gæsteparkeringsregler. Du har også mulighed for at tilknytte eksterne organisationer og give dem adgang til den pågældende plads.`,
        paragraph5: `Afslutningsvis kan du konfigurere abonnementet ved at angive, om der skal være månedlig betaling for denne parkeringsplads, samt vælge den ønskede betalingsfrekvens. Til sidst defineres fordelingsnøglen baseret på den valgte kontroltype, hvor du kan angive procentvis fordeling. Når alle nødvendige oplysninger er udfyldt, afsluttes oprettelsen ved at klikke på "Opret" nederst i højre hjørne.`,
    },

    platformFeatures_5: {
        paragraph1: `Her får du et samlet overblik over alle brugere, du har adgang til. Du kan nemt oprette nye brugere, redigere eksisterende og administrere deres informationer og adgangsindstillinger. Tabellen viser listen over brugere – klik på en bruger for at se detaljer eller foretage ændringer. Øverst på siden finder du en søgefunktion, som gør det let at finde specifikke brugere baseret på navn, brugernavn, e-mail eller ID. Du har desuden adgang til avanceret søgning, hvor du kan filtrere brugere ud fra organisation og andre relevante kriterier.`,
        paragraph2: `Når du klikker på knappen "Opret Bruger", åbnes et nyt vindue, hvor du kan indtaste brugerens oplysninger. Du skal angive navn, e-mail, brugernavn samt start- og slutdato. Dernæst vælger du, hvilken organisation brugeren skal tilknyttes, samt hvilke parkeringspladser inden for organisationen brugeren skal have adgang til. Til sidst tildeler du de relevante rettigheder (permissions), der definerer brugerens rettigheder og funktioner i systemet. Når alle nødvendige oplysninger er udfyldt, afslutter du processen ved at klikke på "Opret" nederst i højre hjørne.`,
        paragraph3: `Når du opretter eller redigerer en bruger, er det vigtigt nøje at overveje, hvilke rettigheder der tildeles. Brugere kan have forskellige roller og adgangsniveauer afhængigt af deres funktion og ansvar. Du kan tildele specifikke rettigheder, der giver adgang til at se, oprette, redigere eller slette data samt udføre bestemte handlinger i systemet. For at sikre både effektivitet og datasikkerhed bør brugere kun have de rettigheder, der er nødvendige for deres arbejdsopgaver – nogle funktioner kræver specifikke tilladelser, fx login kræver en aktiv “platform”-tilladelse.`,
        paragraph4: `Når du klikker på en bruger i listen, åbnes et vindue, hvor du kan se og redigere brugerens oplysninger – herunder navn, e-mail, brugernavn, adgangsperiode, tilknytning til organisationer og parkeringspladser samt rettigheder. Klik på "Opdater" for at gemme ændringerne, eller luk vinduet for at annullere. Du kan også nulstille eller sende en ny adgangskode med "Send adgangskode", eller vælge "Overtag bruger" for at logge ind som brugeren – nyttigt ved support og fejlsøgning.`,
    },

    platformFeatures_6: {
        paragraph1: `Her får du et samlet overblik over alle brugere med abonnement i organisationer du administrerer. Du kan ikke oprette nye direkte herfra, men du kan se de eksisterende og se tilhørende oplysninger. Tabellen viser listen over abonnenter – klik på en abonnent for at se detaljer eller foretage ændringer. Øverst kan du via. søgefunktionen finde specifikke abonnenter via navn, ID, email eller lignende. Du finder også en avanceret søgefunktion, der giver dig mulighed for at filtrere abonnenter baseret på organisationer og parkeringspladser.`,
        paragraph2: `Når du klikker på en abonnent i listen, åbnes et vindue, hvor du kan se vedkommendes oplysninger. Redigering er ikke mulig her, men visningen giver et samlet overblik over abonnentens data. Du kan derfra klikke dig videre ind på deres abonnementer, tilladelser og betalinger for at få adgang til mere detaljeret information.`,
        paragraph3: `Når du klikker på et abonnement under en abonnent, åbnes et vindue, hvor du kan se og opdatere abonnementsoplysningerne. Her kan du ændre registreringsnummer, tilføje eller fjerne tilladelser, afhængigt af abonnementsreglerne. Du har også mulighed for at sende en kvitteringskopi, opdatere kortoplysninger eller stoppe abonnementet. Husk at gemme dine ændringer ved at klikke på "Opdater" nederst i højre hjørne, når du er færdig.`,
        paragraph4: `Når du klikker på en tilladelse under en abonnent, åbnes et vindue med oplysninger om den valgte tilladelse. Her kan du redigere noten, mens øvrige oplysninger håndteres gennem selve abonnementet. For at vende tilbage til abonnentens detaljer, klik på "Åbn abonnement" eller luk vinduet via knappen nederst til venstre.`,
    },

    platformFeatures_7: {
        paragraph1: `Her får du et samlet overblik over alle abonnementsvilkår, du har adgang til. Du kan nemt oprette nye, redigere eksisterende og administrere deres oplysninger. Tabellen viser en oversigt over vilkårene – klik på et vilkår for at se detaljer eller foretage ændringer. Øverst på siden finder du en søgefunktion, som gør det let at finde specifikke abonnementsvilkår via adresse eller ID. Du har også adgang til avanceret søgning, hvor du kan filtrere vilkår baseret på organisation eller parkeringsplads.`,
        paragraph2: `Når du klikker på knappen "Opret Abonnementsvilkår", åbnes et vindue, hvor du kan indtaste de nødvendige oplysninger for vilkåret. Du udfylder navn/beskrivelse, beløb samt angiver, om det er et offentligt eller privat vilkår. Derefter vælger du, hvilken parkeringsplads vilkåret skal gælde for, og definerer eventuelle regler. Tidsregler er valgfri og kan anvendes, hvis vilkåret kun skal gælde på bestemte tidspunkter. Som udgangspunkt gælder vilkåret hele tiden. Når alle nødvendige oplysninger er angivet, afslutter du ved at klikke på "Opret" nederst i højre hjørne.`,
        paragraph3: `Når du klikker på et abonnementsvilkår i listen, åbnes et vindue, hvor du kan se og opdatere abonnementsvilkårets oplysninger. Du har mulighed for at ændre alle informationer som beskrevet i "Oprettelse af nyt abonnementsvilkår" og kan også efterfølgende tilføje eller fjerne tidsregler. Husk at gemme dine ændringer ved at klikke på "Opdater" nederst i højre hjørne, når du er færdig.`,
    },

    platformFeatures_8: {
        paragraph1: `Her får du et samlet overblik over alle korttidsvilkår, du har adgang til. Du kan nemt oprette nye, redigere eksisterende og administrere oplysningerne. Tabellen viser listen over korttidsvilkår – klik på et vilkår for at se detaljer eller foretage ændringer. Øverst på siden finder du en søgefunktion, som gør det nemt at finde specifikke vilkår via adresse eller ID. Du kan også benytte avanceret søgning til at filtrere efter organisation eller parkeringsplads.`,
        paragraph2: `Når du klikker på knappen “Opret tilladelsesregel”, åbnes et nyt vindue, hvor du kan indtaste oplysninger for korttidsvilkåret. Start med at angive navn og vælge, om vilkåret skal være offentligt eller privat. Tilknyt en parkeringsplads og eventuelt et billede. Herefter definerer du regler for, hvornår tilladelser oprettet med denne regel skal gælde – herunder dage, tidsrum, pris og varighed. Når alle nødvendige oplysninger er udfyldt, afsluttes oprettelsen ved at klikke på “Opret” nederst i højre hjørne.`,
        paragraph3: `Når du klikker på et Korttidsvilkår i listen, åbnes et vindue, hvor du kan se og redigere vilkårets oplysninger. Du har mulighed for at ændre navn, type, tilknyttet parkeringsplads, billede, pris og øvrige detaljer – på samme måde som ved oprettelse. Derudover kan du tilføje, redigere eller fjerne eksisterende tidsregler efter behov. Når dine ændringer er foretaget, skal du huske at klikke på "Opdater" nederst i højre hjørne for at gemme.`,
    },

    platformFeatures_9: {
        paragraph1: `Her får du et samlet overblik over organisationens finansielle data. Modulet dækker indtægter fra abonnementer, tilladelser, afgifter og andre transaktioner. Du har adgang til detaljerede grafer og tabeller, der giver dig indsigt i økonomiske nøgletal og udvikling over tid.`,
        paragraph2: `Første diagram viser organisationens samlede indtægter fordelt på p-billetter, abonnementer, efteropkrævninger og eventuelle afgifter. Du får overblik over udviklingen måned for måned, med mulighed for at se præcise beløb ved at holde musen over søjlerne. Diagrammet giver værdifuld indsigt i indtægtsfordelingen og hjælper dig med at identificere mønstre og tendenser i organisationens økonomi.`,
        paragraph3: `Tabellen under, giver dig et detaljeret økonomisk overblik over organisationens afgifter, fordelt på kundeandel, P-vagtens andel og organisationen’s andel. Du kan se både totalbeløb og fordeling på statusser som åbne, betalte, afgjorte og annullerede afgifter. Derudover vises samlet beløb og antal udstedte afgifter i perioden. Tabeldata kan bruges til økonomisk opfølgning og performanceanalyse.`,
        paragraph4: `De fire cirkeldiagrammer giver dig et visuelt overblik over nøgleområder, herunder p-billetter pr. parkeringsoperatør, omsætningsfordeling, antal afgifter efter status og fordeling af abonnementer. Diagrammerne gør det nemt at identificere tendenser og afvigelser i data og hjælper dig med at træffe informerede beslutninger på baggrund af realtidsindsigt.`,
    },

    platformFeatures_10: {
        paragraph1: `Her får du et samlet overblik over alle organisationer, du har adgang til. Du kan nemt oprette nye, redigere eksisterende og administrere deres informationer. Tabellen viser listen over organisationer – klik på en organisation for at se detaljer eller foretage ændringer. Øverst finder du en søgefunktion, som gør det nemt at finde specifikke organisationer via navn eller ID.`,
        paragraph2: `Når du klikker på knappen "Opret Organisation", åbnes et nyt vindue, hvor du kan indtaste organisationens oplysninger. Felterne i venstre side af modalen er obligatoriske og skal udfyldes for at oprettelsen kan gennemføres. Når alle nødvendige oplysninger er angivet, afslutter du ved at klikke på "Opret" nederst i højre hjørne.`,
        paragraph3: `Når du klikker på en organisation i listen, åbnes et vindue, hvor du kan se og opdatere organisationens oplysninger. Du har mulighed for at ændre navn, e-mail og øvrige relevante informationer. Husk at gemme dine ændringer ved at klikke på "Opdater" nederst i højre hjørne, når du er færdig.`,
    },

    // Usage of app
    'Hvordan laver man tilladelser i appen?': `Hvordan laver man tilladelser i appen?`,
    'Hvordan opretter man afgift i appen?':
        'Hvordan opretter man afgift i appen?',

    answerApp_1: {
        paragraph: `For at oprette en tilladelse i appen skal du først vælge den parkeringsplads, hvor tilladelsen skal gælde. Herefter indtaster du bilens nummerplade og angiver, hvilke datoer tilladelsen skal gælde fra og til. Hvis du ønsker, kan du også tilføje yderligere oplysninger i notefeltet, såsom specifikke instrukser. Du skal dernæst indtaste en emailadresse, så brugeren kan modtage en bekræftelse. Når du har udfyldt alle nødvendige oplysninger, trykker du på "Opret tilladelse". Hvis der allerede findes en tilladelse for den indtastede nummerplade, vil appen informere dig og give dig mulighed for at redigere den eksisterende tilladelse i stedet for at oprette en ny.`,
    },
    answerApp_2: {
        paragraph: `For at oprette en afgift i appen starter du med at vælge den relevante parkeringsplads. Derefter indtaster du bilens nummerplade manuelt eller bruger appens live-scan-funktion til automatisk at registrere nummerpladen. Når nummerpladen er registreret, vælger du "Opret afgift" og følger processen for at tilknytte en gyldig afgiftsseddel med QR-kode. Du scanner QR-koden på den gule afgiftsseddel for at forbinde den med afgiften. Herefter tager du de fire nødvendige billeder, som appen guider dig igennem.  Når billederne er taget korrekt og i henhold til appens instruktioner, afslutter du oprettelsen af afgiften i appen. Til sidst placerer du den gule seddel i bilens forrude som synlig dokumentation. Afgiften er nu korrekt registreret i systemet.`,
    },

    // Settlements
    'Hvor ofte afregner I?': `Hvor ofte afregner I?`,
    'Hvorfor afregnes jeg for en flere år gammel afgift nu?':
        'Hvorfor afregnes jeg for en flere år gammel afgift nu?',

    answerSettlements_1: {
        paragraph: `I den samarbejdsaftale vi har indgået/kontrakt finder du svar på, hvor ofte der afregnes. Standarden er én gang hver tredje måned.`,
    },
    answerSettlements_2: {
        paragraph: `Hvor hurtigt en afgift betales efter udstedelse kan variere fra 'med det samme' til 'aldrig'. Det betyder, at afgifter der er udstedt for måneder eller år siden kan fremgå på jeres dags dato afregning, fordi den er blevet betalt siden vi sidst afregnede med jer.`,
    },

    // weekdays
    weekdaysOnly: 'Kun hverdage',
    Mon: 'Man',
    Tue: 'Tir',
    Wed: 'Ons',
    Thur: 'Tor',
    Thu: 'Tor',
    Fri: 'Fre',
    Sat: 'Lør',
    Sun: 'Søn',
    Monday: 'Mandag',
    Tuesday: 'Tirsdag',
    Wednesday: 'Onsdag',
    Thursday: 'Torsdag',
    Friday: 'Fredag',
    Saturday: 'Lørdag',
    Sunday: 'Søndag',
    Hourly: 'Timer',
    Weekly: 'Uger',
    Hour: 'Time',
    hour: 'time',
    hours: 'timer',
    Day: 'Dag',
    day: 'dag',
    'half-hour': 'halve time',
    'half-hours': 'halve timer',
    days: 'dage',
    week: 'uge',
    Week: 'Uge',
    weeks: 'uger',
    Month: 'Måned',
    months: 'måneder',
    'Number of': 'Antal',
    First: 'Første',
    to: 'til',
    Free: 'Gratis',
    Percentage: 'Procent',
    'Subscription per month': 'Abonnement pr. måned',
    'Price per month': 'Pris pr. måned',
    'No limit on': 'Ingen begrænsning på',
    After: 'Efter',
    Count: 'Antal',
    Organisations: 'Organisationer',

    January: 'Januar',
    February: 'Februar',
    March: 'Marts',
    April: 'April',
    June: 'Juni',
    July: 'Juli',
    August: 'August',
    September: 'September',
    October: 'Oktober',
    November: 'November',
    December: 'December',
    'All days': 'Alle dage',
    'All day': 'Hele døgnet',
    Valid: 'Gælder',
    month: 'måned',
    Per: 'Pr.',

    // popup box - accepted
    accepted_title: 'Køb accepteret',
    accepted_description1: 'Køb af p-billet gennemført',
    accepted_description2:
        'Såfremt der er angivet e-mail i forrige mailfelt, vil der blive sendt en bekræftelsesmail til den angivne e-mailadresse.',
    accepted_description3: 'Som bekræftelse på tilladelsen kan De anvende:',
    accepted_description4: 'Udklip af debiteret bankoverførsel',
    accepted_description5: 'Udklip af MobilePay-betaling',
    accepted_description6: 'Tilsendte bekræftelsesmail.',
    accepted_description7:
        'Såfremt der er yderligere spørgsmål og/eller tvivl vedrørende betaling, kontakt os på:',
    accepted_description8: 'Vinduet kan nu lukkes.',

    Ok: 'Okay',
    // popup box - successfull
    successfull_title: 'Velkommen til Oparko!',
    successfull_description: 'Dit abonnement er nu aktivt.',
    successfull_description1:
        'Du har modtaget alle oplysninger om dit abonnement på din e-mail. Du kan se og opdatere detaljer om dit abonnement direkte på platformen ved at logge ind.',
    successfull_description2:
        'Du kan nu lukke dette vindue for at få adgang til din konto.',
    // popup box - declined
    declined_title: 'Desværre opstod der en fejl med din betaling.',
    declined_description:
        'Din abonnementskonto blev stadig oprettet, men den er ikke aktiv. Dette betyder, at vi ikke vil tage nogen betalinger fra dig, og du vil heller ikke have en aktiv tilladelse til at parkere din bil.',
    declined_description1:
        'Du har modtaget alle nødvendige oplysninger til at logge ind på vores platform via din e-mail, fra vores platform kan du finde betalings-linket til at forsøge endnu en betaling, hvis du ønsker det.',
    declined_description2:
        'Alternativt kan du bruge nedenstående link til at forsøge igen:',
    declined_description3: 'Eller kontakt Oparko Support her:',
    declined_description4:
        'Hvis du har spørgsmål vedrørende betalingen, kan du kontakte os på ',
    'Open Subscription': 'Åben abonnement',
    pay_subscription_heading: 'Betaling af abonnementet',
    pay_subscription_description:
        'Du forsøger at betale for din abonnements konto, bekræft venligst for at fortsætte med din betaling.',
    'Cancel Subscription': 'Annuller abonnement',
    cancel_sub_description:
        'Vi er kede af at se dig forlade Oparko. Hvis du er sikker på, at du vil annullere dit abonnement, skal du klikke på "Accepter" for at bekræfte din beslutning.',
    cancel_sub_description1:
        'Bemærk venligst, at dit abonnement vil forblive aktivt indtil udgangen af din nuværende betalingsperiode. Vi vil ikke opkræve dig yderligere, og dit abonnement vil blive inaktivt fra næste måned.',
    subscription_already_cancelled: 'Dette abonnement er allerede annulleret.',

    ticket_service_disclaimer_1:
        'Vi gør opmærksom på at det ikke er muligt at stoppe sin parkeringstilladelse før tid. Det er ikke muligt at forlænge sin parkeringstilladelse, ønsker man at blive holdende, skal man købe en ny tilladelse, når den første er udløbet. Det er endvidere ikke muligt at annullere en tilladelse, når denne først er oprettet.',
    ticket_service_disclaimer_2:
        'Vi gør særligt opmærksom på, at det er parkantens fulde ansvar, at de angivne oplysninger er korrekte. Samtidig fraskriver org_name sig ansvaret for enhver fejl ved oprettelsen. Når du køber en p-billet samtykker du samtidig til vores vilkår og betingelser. Du samtykker derfor også til vores persondatapolitik.',
    subscription_service_disclaimer:
        'Vi gør særligt opmærksom på, at det er parkantens fulde ansvar, at de angivne oplysninger er korrekte. Samtidig fraskriver org_name sig ansvaret for enhver fejl ved oprettelsen. Når du køber et abonnement, samtykker du samtidig til vores vilkår og betingelser. Du samtykker derfor også til vores persondatapolitik.',
    subscription_service_disclaimer_2: `Abonnementsparkeringsaftalen berettiger kun til parkering på det område, som fremgår af abonnementsparkeringsaftalen, i de afmærkede parkeringsbåse hvor det ikke fremgår, at der er særlige regler gældende for parkering i disse parkeringsbåse. Der gøres opmærksom på, at Abonnementsparkeringsaftalen ikke er en gyldig parkeringstilladelse til parkering i parkeringsbåse, som er reserveret.`,
    'Update Card': 'Opdater kort ',
    'Pay Subscription': 'Betal Abonnement',
    'Update payment card': 'Opdater betalingskort',
    update_card_description:
        'Du forsøger at opdatere dine kreditkortoplysninger. Bekræft venligst for at fortsætte med opdateringen.',
    update_card_cancel:
        'Desværre opstod der en fejl med opdateringen af dit kort. ',
    update_card_cancel_description:
        'Dit abonnementskonto er stadig aktiv, med en aktiv tilladelse. Hvis du ønsker at opdatere dine kortoplysninger, bedes du venligst forsøge igen.',
    update_card_cancel_description2:
        'Hvis du har spørgsmål vedrørende opdatering af dit kort, kan du kontakte os på ',
    update_card_accept: 'Opdateringen af dit kort var vellykket.',
    update_card_accept_description:
        'Dine kortoplysninger er blevet opdateret til din abonnementskonto. ',
    update_card_accept_description2:
        'Hvis du har spørgsmål vedrørende opdatering af dit kort, kan du kontakte os på ',
    'No Future payments': 'Ingen fremtidige betalinger',
    // Months
    Jan: 'Jan',
    Feb: 'Feb',
    Mar: 'Mar',
    Apr: 'Apr',
    May: 'Maj',
    Jun: 'Jun',
    Jul: 'Jul',
    Aug: 'Aug',
    Sep: 'Sep',
    Oct: 'Okt',
    Nov: 'Nov',
    Dec: 'Dec',

    // redirectFromPK
    'Important announcement': 'Vigtig opdatering',
    'Welcome! You have landed here because Parkeringskompagniet has now become':
        'Velkommen! Du er landet her, fordi Parkeringskompagniet nu er blevet til',
    'We have upgraded to a new management platform to offer you an even better user experience':
        'Vi har opgraderet til en ny administrationsplatform for at tilbyde dig en endnu bedre brugeroplevelse.',
    'What should you do now?': 'Hvad skal du gøre nu?',
    'Your existing information is automatically transferred. You just have to log in from the new platform now':
        'Dine eksisterende oplysninger er automatisk overført. Du skal blot fremover logge ind på den nye platform',
    'New Functions': 'Nye Funktioner',
    'The new platform can do everything you are used to, plus much more!':
        'Den nye platform kan alt det, du er vant til, plus meget mere!',
    'Do you have questions? Contact us at service@oparko.com':
        'Har du spørgsmål? Kontakt os på service@oparko.com',
    'E-mail at': 'E-mail til',
    'Call at': 'Ring til',
    'Phone hours:': 'Telefontider:',
    'Go to new admin platform': 'Gå til ny admin platform',

    // Pay fine
    'How to appeal': 'Klagevejledning',
    'Get documentation': 'Hent dokumentation',
    'Complaint form': 'Klageformular',
    'Select a reason': 'Vælg en årsag',
    'Select driver identity': 'Vælg din identitet',
    Appeal: 'Klage kommentar',
    GoBack: 'Tilbage',
    CloseCase: 'Luk sag',
    'Submit an appeal': 'Opret indsigelse',
    'Pay fine': 'Betal afgift',
    'Pay case': 'Betal sag',
    Case: 'Sag',
    'License plate': 'Nummerplade',
    'Fine id': 'Afgift-id',
    'Fine documentation': 'Afgiftdokumentation',
    retrieve_fine_documentation_text:
        'Bemærk, at ikke alle afgifter giver adgang til dokumentation. Løbenummeret er det id, der fulgte med din afgift.',
    Subject: 'Emne',
    'Valid permit': 'Gyldig parkeringstilladelse',
    'Type in complaint here': 'Skriv klage her',
    Attachments: 'Vedhæft filer',
    'Select files': 'Vælg filer',
    'Select file': 'Vælg fil',
    'Drop files here...': 'Træk filer hertil...',
    'No files selected': 'Ingen filer valgt',
    file_limit_info: 'Maks {{maxFiles}} filer, hver på op til {{maxSize}} MB',
    file_limit_error: 'Du kan kun uploade op til {{max}} filer.',
    file_size_error:
        'Hver fil skal være mindre end {{max}} MB. "{{name}}" er for stor.',
    complaint_form_text:
        'Vær opmærksom på, at alle henvendelser vedrørende parkeringsafgifter, herunder klager, betalinger, rykkere og lignende, skal indsendes skriftligt ved brug af nedenstående formular. Det er afgørende, at vi modtager alle nødvendige oplysninger skriftligt.',
    Offense: 'Vælg forseelse',
    selectReason2: 'Vælg forseelse 2',
    OffenseDocumentation: 'Forseelse',
    OffenseNote: 'Forseelse Note',
    DriverIdentity: {
        label: 'Identitet',
    },
    DRIVER_OPTIONS: {
        DRIVER_MYSELF: 'Jeg var føreren af køretøjet',
        DRIVER_NOT_MYSELF: 'En anden person var føreren af køretøjet',
        BEHALF_OF_OTHER: 'Jeg kontakter jer på vegne af en anden person',
    },
    'Driver Name': 'Førers navn',
    'Your e-mail': 'Din e-mail',
    'Submitted information': 'Tilsendt information',
    'Driver phonenumber': 'Førers telefonnummer',
    'Driver address': 'Førers adresse',
    'Driver postcode': 'Førers postnummer',
    'Driver city': 'Førers by',
    '01': 'Parkeret udenfor bås',
    '001': 'Afgiften er udstedt på grund af parkering udenfor afmærket bås. Der kan enten være tale om en parkering ud over stregerne eller helt uden for en bås. Som det fremgår af skiltningen på pladsen, er parkering kun tilladt i afmærket p-bås. Overtrædelse af dette vilkår medfører kontrolafgift. P-vagten har dokumenteret parkeringen med fotos.',
    '02': 'Parkeret uhensigtsmæssigt f.eks. foran varelevering eller køreareal',
    '002': 'Afgiften er udstedt, da parkeringen er uhensigtsmæssig i forhold til f.eks. varelevering, tilkørselsvej eller lignende. Dette er tilfældet hvis din bil f.eks. spærrer for tilkørsel til andre veje eller blokerer for trafikken i området.',
    '03': 'Ingen gyldig tilladelse til området',
    '003': 'Afgiften er udstedt grundet manglende tilladelse. Som det fremgår af skiltningen på pladsen, er der krav om tilladelse ved standsning og parkering på pladsen. Bilens ophold på pladsen overskrider den fastsatte observationstid. Derfor er der sket en overtrædelse af pladsens gældende vilkår, hvilket medfører en kontrolafgift.',
    '04': 'Tilladelse var ikke synlig eller udløbet',
    '004': 'Afgiften er udstedt, da tilladelsen ikke har været synlig eller er udløbet. Hvis p-vagten ikke har været i stand til at kontrollere tilladelsen tilstrækkeligt, eller hvis denne er udløbet, så er vilkårene overtrådt. En overtrædelse af vilkårene medfører en kontrolafgift.',
    '05': 'Ikke betalt for parkering på en betalingsplads',
    '005': 'Afgiften er udstedt på grund af manglende tilladelse. Som det fremgår af skiltningen på pladsen, er der krav om tilladelse ved standsning og parkering på pladsen. Vi har ikke registreret en købt tilladelse i vores system til den pågældende plads og vilkårene på pladsen er dermed overtrådt. En overtrædelse af vilkårene medfører en kontrolafgift.',
    '06': 'Tid på parkeringsskiven er overskredet',
    '006': 'Afgiften er udstedt, da bilens p-skive er overskredet. Det fremgår af skiltene, at parkering er tilladt i begrænset tid med korrekt indstillet p-skive. Bilens p-skive har været indstillet forkert, slet ikke indstillet eller bilen har parkeret længere tid, end hvad der er tilladt. P-vagten har dokumenteret parkeringen med fotos.',
    '07': 'Du har ændret tiden på p-skiven uden at flytte bilen',
    '007': 'Afgiften er udstedt, da p-skiven er ændret, hvorefter parkering er fortsat. Det er kun tilladt at parkere på området i begrænset tid og ved at ændre på p-skiven, så kan der parkeres længere tid end hvad reglerne tillader. Dette medfører en kontrolafgift.',
    '08': 'Parkering eller standsning i standsning forbudt område',
    '008': 'Afgiften er udstedt, da bilen har været parkeret et sted på området, hvor standsning og parkering er forbudt. Dette medfører en kontrolafgift. Parkeringen er dokumenteret med fotos.',
    '09': 'Parkering på brandvej',
    '009': 'Afgiften er udstedt, da bilen er parkeret på brand- eller redningsvej. Parkering på sådanne veje er ikke tilladt og dette medfører derfor en kontrolafgift. P-vagten har dokumenteret parkeringen med fotos.',
    '10': 'Parkering på handikapplads uden synligt handikapskilt',
    '010': 'Afgiften er udstedt, da bilen har været parkeret i en handicapbås uden synlig tilladelse hertil. Som det fremgår af skiltningen, er den pågældende bås en handicapbås. Dette betyder, at der er krav om handicap-parkeringskort. I denne forbindelse henvises der til bekendtgørelse om parkeringskort for personer med handicap og institutionskort (BEK nr 782 af 07/08/2019), se særligt § 13, stk. 1, som lyder: Når et parkeringskort eller institutionskort anvendes, skal det være anbragt inden for forruden med kortets forside klart synlig for kontrol.”.Her er et link til bekendtgørelsen: https://www.retsinformation.dk/eli/lta/2019/782. P-vagten har dokumenteret parkeringen med fotos.',
    '11': 'Parkeret på en plads reserveret til elbiler der lader, eller ikke flyttet bil efter endt ladning',
    '011': 'Afgiften er udstedt, da parkering på dette område kun er tilladt for el-biler under opladning. Hvis bilen ikke (længere) er under opladning, så er parkering ikke tilladt i dette område. Parkering er således i strid med vilkårene på pladsen, hvilket medfører en kontrolafgift. P-vagten har dokumenteret parkeringen med fotos.',
    '12': 'Du har ikke overholdt regler og vilkår, som er skiltet på pladsen',
    '012': 'Afgiften er udstedt, da de skiltede vilkår på pladsen ikke er overholdt. En overtrædelse af vilkårene medfører en kontrolafgift.',
    Disagree:
        'Hvis du mener, at din afgift er uberettiget, kan du indsende en skriftlig klage, udfyld venligst nedenstående felter',
    Price: 'Beløb',
    'Extra Charges': 'Ekstra gebyrer',
    'Pay your fine here.': 'Betal din afgift her.',
    'View your documentation here.': 'Se din dokumentation her.',
    'File a Complaint': 'Indsend en klage',
    'Fill in your information in the form below':
        'Udfyld dine oplysninger i formularen nedenfor',
    Location: 'Lokation',
    Continue: 'Fortsæt',
    Topic: 'Emne',
    Validpermit: 'Gyldig tilladelse',
    'Why you received a control fee': 'Årsag til at du modtog et kontrolgebyr',
    terms_acceptance_notice:
        'Ved at benytte denne tjeneste accepterer du vores persondatapolitik. Du kan læse mere her:',
    'Terms, conditions and privacy policy':
        'Vilkår, betingelser og persondatapolitik',
    complaint_for_ticket_notice: 'Hvornår kan det betale sig at klage?',
    complaint_for_ticket_details:
        'Hvis du allerede ved, at P-afgiften er givet, fordi der skete en fejl, da du parkerede, vil en klage desværre ikke ændre noget – hverken pr. telefon eller via klageformularen. Vi har nemlig ikke mulighed for at annullere afgifter, som er pålagt korrekt.',
    faq_message: 'Du kan læse svar på de mest almindelige spørgsmål her:',
    email_usage_payment_receipt:
        'Din e-mailadresse bruges udelukkende til at udstede en betalingskvittering. Den vil ikke blive brugt til markedsføringsformål eller delt med tredjeparter.',

    Cant_find_Fine_id: {
        HeaderText:
            'Vi kunne ikke finde en afgift med det indtastede referencenummer og registreringsnummer.',
        SubText:
            'Dobbelttjek venligst, at oplysningerne er korrekte. Hvis nødvendigt, gå tilbage og prøv igen, eller indsend en indsigelse under fanen “Opret indsigelse”.',
    },

    ticket_info_login_form: {
        errors: {
            reference_number: 'Indtast venligst et løbenummer',
            license_plate: 'Indtast venligst en nummerplade',
        },
    },

    fineId: 'Løbenummer / afgiftsid / fakturanummer',

    ComplaintFormErrors: {
        name: 'Indtast førerens navn.',
        phone_required: 'Indtast førerens telefonnummer.',
        phone_invalid: 'Indtast et gyldigt telefonnummer.',
        email_required: 'Indtast din e-mail.',
        email_invalid: 'Indtast en gyldig e-mailadresse.',
        address_required: 'Indtast førerens adresse.',
        zipCode_required: 'Indtast førerens postnummer.',
        city_required: 'Indtast førerens by.',
        subject: 'Indtast et emne.',
        complaintText: 'Skriv din klage.',
        offence: 'Vælg en årsag.',
        driverIdentity: 'Vælg din identitet.',
    },

    Fine_is_paid: 'Denne afgift er allerede betalt',
    Fine_Paid: {
        HeaderText: 'Denne afgift er allerede betalt og er nu lukket.',
        SubtextDocu:
            'Derfor er det ikke muligt at få adgang til dokumentationen. Hvis du mener, at dette er en fejl, bedes du bruge formularen under fanen "Opret indsigelse".',
        SubText:
            'Ingen yderligere betaling kan foretages. Hvis du mener, at dette er en fejl, bedes du bruge formularen under fanen "Opret indsigelse".',
    },

    case_closed: {
        HeaderText: 'Denne sag er afsluttet.',
        SubtextPay:
            'Der kan ikke foretages yderligere betaling. Hvis du mener, dette er en fejl, bedes du bruge formularen under fanen "Opret indsigelse".',
        SubtextDocu:
            'Sagen er afsluttet, og det er ikke muligt at få adgang til dokumentation om sagen her. Hvis du mener, dette er en fejl, bedes du bruge formularen under fanen "Opret indsigelse".',
    },

    Cant_get_documentation:
        'Det er ikke længere muligt at hente dokumentation til denne afgift.',
    Send_complain: 'Klagen er indsendt',
    Error_send_complain:
        'Der opstod en fejl, tjek venligst at alle felterne er udfyldt korrekt',
    // payment accepts
    payment_approve: 'Godkendt',
    payment_approve_1: 'Betaling af kontrolafgiften er gennemført',
    payment_approve_2:
        'Vi bekræfter, at din betaling af kontrolafgiften er blevet gennemført. Den tilsendte bekræftelsesmail fungerer som dokumentation for, at kontrolafgiften er betalt.',
    payment_approve_3:
        'Vi fremsender altid kontrolafgift med post, men som det fremgår af brevet, så kan der ses bort fra dette, såfremt der allerede er sket fyldestgørende betaling.',
    payment_approve_4:
        'Vilkår og betingelser for betaling af kontrolafgiften kan læses på følgende link:',
    payment_approve_5:
        'Har du yderligere spørgsmål eller tvivl vedrørende betalingen, er du velkommen til at kontakte os på: ',
    payment_approve_6: 'Vinduet kan nu lukkes.',
    // payment decline
    payment_decline: 'Fejl ved Betaling',
    payment_decline_l1: 'Beklager, men noget gik desværre galt.',
    payment_decline_l2:
        'Din betaling for kontrolafgiften kunne ikke gennemføres.',
    payment_decline_l3:
        'Vær venlig at dobbelttjekke, at de indtastede oplysninger er korrekte.',
    payment_decline_l4:
        'For mere information om betaling, se venligst vilkår og betingelser på følgende link: ',
    payment_decline_l5:
        'Har du yderligere spørgsmål eller tvivl vedrørende betalingen, er du velkommen til at kontakte os på:',
    payment_decline_l6: 'Vinduet kan nu lukkes.',
    // Complaint sent
    complaint_appeal_submit: 'Modtaget',
    complaint_appeal_submit_1: 'Vi bekræfter, at vi har modtaget din e-mail',
    complaint_appeal_submit_2:
        'Hvis informationerne i formularen er udfyldt korrekt med løbenummer er sagen sat i bero, og vi gennemgår den snarest muligt',
    complaint_appeal_submit_3:
        'Vi vender tilbage, når en afgørelse er truffet. ',
    complaint_appeal_submit_4: 'Forvent en behandlingstid på 10 arbejdsdage',
    complaint_appeal_no_repeat_please:
        'Yderligere indsendelser vedrørende samme sag vil ikke fremskynde behandlingen. Tværtimod kan gentagne henvendelser øge sagsmængden og dermed forlænge den samlede sagsbehandlingstid.',
    backToStart: 'Tilbage til start',
    'Back to start': 'Tilbage til start',

    // report pdf
    'The amount is paid to the account details below':
        'Eventuelt beløb overføres til nedenstående konto',
    'Parking reading - Subscription (ready)':
        'Parkeringsløsning - Abonnement (klar)',
    'The Address': 'Adressen',
    'CREDIT NOTE': 'KREDITNOTA',
    'Settlement documents': 'Afregningsbilag',
    'Camera fine': 'Kameraafgift',
    'Camera fines': 'Kamera afgifter',
    'Camera collection': 'Kamera efteropkrævning',
    'Guard fine': 'Vagtkontrolsafgift',
    'Camera collection by day': 'Efteropkrævninger, døgnparkering',
    Monthly: 'Månedlig',
    Quarterly: 'Kvartal',
    'Half-Yearly': 'Halvårlig',
    'Half yearly': 'Halvårlig',
    Yearly: 'Årlig',
    'Parking solution': 'Parkeringsløsning',
    'Payment of control fees': 'Udbetaling af kontrolafgifter',
    'Cancellation of control fee': 'Annullering af kontrolafgift',
    'Payment of parking permits': 'Udbetaling af P-billetter',
    'This settlement document is issued under a self-invoicing agreement between the parties.':
        'Dette afregningsbilag er udstedt under en\nselvfaktureringsaftale mellem parterne.',
    'Payment is made': ' Udbetaling sker',

    pay_for_parking: 'Betal for parkering',
    select_parking_lot: 'Vælg parkeringsplads',
    enter_license: 'Indtast nummerplade',
    fetching: 'Henter...',
    pay_for_parking_instruction:
        'Vælg en parkeringsplads, indtast nummerpladen og tryk på send for at hente dine parkeringssessioner inden for de sidste 48 timer.',
    no_parking_sessions_found:
        'Ingen parkeringssessioner fundet for denne nummerplade inden for de sidste 48 timer.',
    all_sessions_paid:
        'Alle parkeringssessioner inden for de seneste 48 timer er betalt for denne nummerplade.',
    parking_period: 'Parkerings periode ',
    total_time: 'Samlet tid',
    invalid_email: 'Ugyldig e-mail',
    price: 'Pris',
    transaction_fee: 'Transaktionsgebyr',
    total_price: 'Samlet pris',
    pay: 'Betal',

    payment_successful: '✅ Betaling gennemført',
    parking_payment_success_1:
        'Tak for din betaling. Transaktionen er gennemført, og der er nu oprettet en parkeringstilladelse til dit køretøj.',
    parking_payment_success_2:
        'En kvittering er sendt til den e-mailadresse, du oplyste under købet.',
    parking_payment_success_3:
        'Med denne tilladelse er dit køretøj nu registreret korrekt, og du vil derfor ikke modtage parkeringsafgifter, så længe tilladelsen er gyldig.',
    parking_payment_success_4:
        'Hvis du ikke har modtaget kvitteringen, eller hvis du har spørgsmål til betalingen eller din tilladelse, er du velkommen til at kontakte vores kundeservice:',
    payment_failed: '❌ Betaling mislykkedes',
    parking_payment_failed_1:
        'Betalingen kunne desværre ikke gennemføres, og der er derfor ikke oprettet nogen parkeringstilladelse til dit køretøj.',
    parking_payment_failed_2:
        'Det betyder, at køretøjet ikke er registreret med en gyldig tilladelse og derfor kan risikere at få parkeringsafgifter.',
    parking_payment_failed_3:
        'Hvis du har oplevet problemer med betalingen, eller har spørgsmål til processen, er du meget velkommen til at kontakte vores kundeservice for hjælp:',
    'Cancel subscription': 'Stop abonnement',
    Now: 'Nu',

    // api documentation
    'API Documentation': 'API Dokumentation',
    intro: 'Introduktion',
    gettingStarted: 'Kom godt i gang',
    coreConcepts: 'Kernebegreber',

    missingTime: 'Manglende tid',
    minParkingTime: 'Min parkeringstid',

    permittedTime: 'Tilladt tid',
    lastFine: 'Afgift',
    lastIssued: 'Seneste',
    now: 'Nu',
    bufferTime: 'Buffer tid',
    bufferPercent: 'Buffer %',
    shortDay: 'd',
    shortHour: 't',
    shortMinute: 'm',
    'Total Scan Events': 'Scanningshændelser i alt',
    'Missed Scan Events': 'Ubesvarede scanningshændelser',
    'Approved Camera Fines': 'Godkendte kameraafgifter',
    'Rejected Camera Fines': 'Afviste kameraafgifter',
    'Not Handled Camera Fines': 'Ikke behandlede kameraafgifter',
    'Daily Scan Events': 'Daglige scanningshændelser',
    'Daily Missed Scan Events': 'Daglige ubesvarede scanningshændelser',
    'Daily Approved Camera Fines': 'Daglige godkendte kameraafgifter',
    'Daily Rejected Camera Fines': 'Daglige afviste kameraafgifter',
    'Daily Not Handled Camera Fines': 'Daglige ikke behandlede kameraafgifter',
    'OPARKO Go Activity': 'OPARKO Go aktivitet',
    'Total Scans': 'Totale skanninger',
    'Missed Scans': 'Missede skanninger',
    'Approved Fines': 'Godkendte afgifter',
    'Rejected Fines': 'Afviste afgifter',
    'Not Handled Fines': 'Ikke håndterede afgifter',
    'Average Occupancy': 'Gennemsnitlig belægning',
    'There is an error in Registration Number:':
        'Der er en fejl i registreringsnummeret:',
    'Number Plate should be between 2 and 10 chars long.':
        'Nummerpladen skal være mellem 2 og 10 tegn lang.',
    'Spaces and special characters are not allowed.':
        'Mellemrum og specialtegn er ikke tilladt.',
    'Payout of licenses': 'Udbetaling af P-licenser',
    vat: 'Moms',
    'VAT exempt amount': 'Momsfrit beløb',
    'VAT taxable amount': 'Momspligtigt beløb',
    'Customer no.': 'Kunde nr.',
    Fee: 'Gebyrer',
    'Fee Activity': 'Gebyraktivitet',
    Origin: 'Afgifts type',
    'Fine Origin': 'Afgifts type',
    'Fee Origin': 'Afgifts type',
    'Fee Origin Filter': 'Gebyrtypefilter',
    "Cannot take over because user doesn't have platform permission":
        'Kan ikke overtage, fordi brugeren ikke har platformstilladelse.',
    'User information': 'Brugeroplysninger',
    'Total Users': 'Samlede brugere',
    'Active Users': 'Aktive brugere',
    'Web Users': 'Webbrugere',
    'App Users': 'App-brugere',
    'Subscription Users': 'Abonnementsbrugere',
    'Note: Detailed user information is accessible only when parking lots or organisations are fewer than {{count}}.':
        'Bemærk: Detaljerede brugeroplysninger er kun tilgængelige, når parkeringspladser eller organisationer er færre end {{count}}.',
    'All Organisations': 'Alle organisationer',
    'Incorrect creation': 'Fejloprettelse',
    'Customer request': 'Kundeønske',
    'Login with Entra ID': 'Log ind med Entra ID',
    normal: 'Normal',
    charging_station: 'Opladningsstation',
    handicap: 'Handicap',
    motor_cycle: 'Motorcykel',
    lærernes_pension: 'Lærernes Pension',
    fine_count: 'Afgifter oprettet',
    scan_count: 'Scans udført',
    parking_count: 'Parkerede biler',
    'Select View': 'Afgifter oprettet',
    'Show Marker': 'Vis markør',

    notifications: {
        header: {
            title: 'Notifikationer',
            mark_all_read: 'Markér alle som læst',
            empty: 'Ingen notifikationer.',
            empty_help: 'Når du får nye notifikationer, vises de her.',
        },

        error: {
            title: 'Kunne ikke hente notifikationer',
            body: 'Der opstod en fejl under indlæsning af notifikationerne.',
            retry: 'Prøv igen',
        },

        toasts: {
            mark_one_failed:
                'Kunne ikke markere notifikationen som læst. Prøv igen.',
            mark_all_failed: 'Kunne ikke markere alle som læst. Prøv igen.',
        },

        sections: {
            today: 'I dag',
            yesterday: 'I går',
            last7: 'Seneste 7 dage',
            earlier: 'Ældre',
        },

        permit_types: {
            '1': 'afgift',
            '2': 'gæsteparkering',
            '3': 'beboer',
            '4': 'p-billet',
            '5': 'medarbejder betalt billet',
            '6': 'medarbejder',
            '7': 'medarbejder øvre kælder',
            '8': 'medarbejder nedre kælder',
            '9': 'fast tilladelse',
            '10': 'licens',
            '11': 'håndværker',
            '12': 'kun for backoffice',
            '13': 'redigerbar tilladelse',
            '14': 'abonnement',
            '15': 'session-tilladelse',
            '16': 'kommentar',
        },

        fine_origins: {
            '2': 'app-afgift',
            '3': 'kameraafgift',
            '4': 'kameraopkrævning',
            '11': 'kameraopkrævning pr. dag',
        },

        permit: {
            created: {
                title: 'Tilladelse #{{permit_id}} oprettet',
                body: 'Der er oprettet en ({{permit_type_label}}) for nummerplade {{regno}} ({{country_code}}) på parkeringsplads {{parking_lot_id}}. Den er aktiv fra {{start_date}} til {{end_date}}.',
            },
        },

        fine: {
            created: {
                title: 'Afgift #{{fine_id}} oprettet',
                body: 'Nummerplade {{regno}} ({{country_code}}) har modtaget en ({{fine_origin_label}}) på parkeringsplads {{parking_lot_id}}.',
            },
        },

        title: {
            unknown: 'Notification',
            'permit.create': 'permit.create',
            'permit.expire': 'permit.expire',
            'user.signup': 'user.signup',
            'user.password': 'user.password',
            'order.confirmation': 'order.confirmation',
            'text.send': 'SMS sendt',
            'observation.timer_expired': 'Observationstid udløbet',
        },
    },

    notificationPreferences: {
        permits: {
            description: 'Få besked, når tilladelser oprettes eller ændres.',
        },
        fines: {
            description: 'Få besked, når der udstedes en ny afgift.',
        },

        channels: {
            PLATFORM: 'Notifikation',
            EMAIL: 'E-mail',
            APP_PUSH: 'App Push',
        },

        status: {
            customSchedule: 'Tilpasset tidsplan',
            alwaysOn: 'Altid aktiv',
        },

        parkingLots: {
            label: 'Parkeringszoner',
            count_one: '{{count}} parkeringszone',
            count_other: '{{count}} parkeringszoner',
            enableAll: 'Aktiver for alle parkeringszoner',
        },

        schedule: {
            custom: 'Modtagelsestider',
            helperText: 'Du modtager kun notifikationer i de valgte tidsrum.',
            interval: 'Interval',
            daysLabel: 'Dage',
            fromLabel: 'Fra',
            toLabel: 'Til',
            timeCaption: 'Tid',
            dayShort: {
                mon: 'M',
                tue: 'T',
                wed: 'O',
                thu: 'T',
                fri: 'F',
                sat: 'L',
                sun: 'S',
            },
        },
        errors: {
            parkingLotsRequired:
                'Vælg mindst én parkeringsplads, eller slå denne notifikationskanal fra.',
            invalidDays: 'Vælg mindst én dag til din tidsplan.',
            missingTimeRange: 'Vælg både et start- og sluttidspunkt.',
            invalidTimeRange: 'Starttidspunktet skal være før sluttidspunktet.',
            saveFailed:
                'Vi kunne ikke gemme dine notifikationsindstillinger. Prøv igen.',
            loadFailed:
                'Vi kunne ikke indlæse dine notifikationsindstillinger. Prøv igen.',
        },
    },
    'Send Notification': 'Send besked',
    'Send Notifications': 'Send beskeder',
    'Send via': 'Send via',
    'Select Template': 'Vælg skabelon',
    'he vehicle has a special exemption, which therefore exempts it from the parking regulation':
        'Køretøjet har en særlig dispensation, som derfor fritager det for parkeringsreguleringen',
    'The vehicle is cancelled in DMR': 'Køretøjet er afmeldt i DMR',
    'Platform Preview': 'Platform Visning',
    'App Preview': 'App Visning',
    Title: 'Titel',
    Body: 'Besked',
    Send: 'Send',
    rent: 'Leje',
    revenue: 'Indtægter',
    total: 'Total',
    'share in number of units (count)': 'Andel i antal enheder (antal)',
    'Monthly lease payment': 'Månedlig leje betaling',
    'Cancellation Reasons': 'Annulleringsårsager',
    'Create Cancellation Reason': 'Opret annulleringsårsag',
    'Cancellation Reason Details': 'Annulleringsårsag detaljer',
    'Fine Cancellation Reasons': 'Kontrolafgift annulleringsårsager',
    'No {{tableName}} now': 'Ingen {{tableName}}',
    'Name (Danish)': 'Navn (Dansk)',
    'Name (DA)': 'Navn (DA)',
    'Description (Danish)': 'Beskrivelse (Dansk)',
    CommentDetails: 'Kommentar Detajler',

    // Print templates
    'Edit print template': 'Rediger printskabelon',
    'Create print template': 'Opret printskabelon',
    'Template name': 'Skabelonnavn',
    'Template name is required': 'Skabelonnavn er påkrævet',
    'Live preview': 'Live forhåndsvisning',
    'Show preview': 'Vis forhåndsvisning',
    'Hide preview': 'Skjul forhåndsvisning',
    'Available variables': 'Tilgængelige variabler',
    'Use these in block content with double curly braces, e.g.':
        'Brug disse i blokindhold med dobbelte tuborgklammer, f.eks.',
    'Successfully created': 'Oprettet med succes',
    'Successfully updated': 'Opdateret med succes',
    'Failed to create template': 'Kunne ikke oprette skabelon',
    'Failed to update template': 'Kunne ikke opdatere skabelon',
    'Failed to load template': 'Kunne ikke indlæse skabelon',
    'Failed to delete template': 'Kunne ikke slette skabelon',
    'Yes, delete': 'Ja, slet',
    noPrintTemplatesFound: 'Ingen print skabeloner fundet',
    'Creditor number': 'Kreditornummer',
    Logo: 'Logo',
    'Logo URL': 'Logo URL',
    'Payment information': 'Betalingsinformation',
    'Base url for QR-code': 'Basis URL til QR-kode',
    'FIK number': 'FIK-nummer',
    'auto-calculated': 'auto-beregnet',
    'Company name': 'Firmanavn',
    Footer: 'Sidefod',
    'Legal entity': 'Juridisk enhed',
    'CVR number': 'CVR-nummer',
    'System block': 'Systemblok',
    Content: 'Indhold',
    'X position': 'X-position',
    'Y position': 'Y-position',
    'Font size': 'Skriftstørrelse',
    fontSizePT: 'Skriftstørrelse (pt)',
    'Max width': 'Maks bredde',
    'Max lines': 'Maks linjer',
    Bold: 'Fed',
    Alignment: 'Justering',
    Left: 'Venstre',
    Center: 'Center',
    Right: 'Højre',
    blockLabel: {
        logo: 'Logo',
        title: 'Titel',
        description: 'Beskrivelse',
        qr_code: 'QR-kode',
        run_number: 'Løbenummer',
        main_body: 'Brødtekst',
        alternative_payment: 'Alternativ betaling',
        fik_number: 'FIK-nummer',
        guidance_text: 'Vejledning',
        parking_address: 'P-zone',
        offense_label: 'Forseelse',
        offense_note: 'Forseelsesnote',
        footer_company: 'Firmanavn (sidefod)',
        footer_entity: 'Juridisk enhed (sidefod)',
        footer_cvr: 'CVR (sidefod)',
        footer_url: 'Hjemmeside (sidefod)',
    },
    'Training Modules': 'Træningsmoduler',
    'Create Training': 'Opret træning',
    'Edit Training Module': 'Rediger træningsmodul',
    'Create Training Module': 'Opret træningsmodul',
    'Read Duration (mins)': 'Læsetid (minutter)',
    'Read Time (mins)': 'Læsetid (minutter)',
    'No training modules found': 'Ingen træningsmoduler fundet',
    // access groups
    'Individual Settings': 'Individuelle indstillinger',
    'Access Group': 'Gruppe',
    'Select Access Group': 'Vælg gruppe',
    'Permissions are managed by the selected Access Group':
        'Rettigheder styres af den valgte gruppe',
    roups: 'Grupper',
    'Group Details': 'Gruppedetaljer',
    'Create Group': 'Opret gruppe',
    Organisation: 'Organisation',
    Addresses: 'Adresser',
    'Filter addresses by name or id': 'Filtrer adresser efter navn eller id',
    'Select all': 'Vælg alle',
    'Deselect all': 'Fravælg alle',
    'Loading permissions...': 'Indlæser rettigheder...',
    'No permissions available': 'Ingen rettigheder tilgængelige',
    Brugerindstillinger: 'Brugerindstillinger',
    'Name is required': 'Navn er påkrævet',
    'Failed to save group': 'Kunne ikke gemme gruppe',
    'Failed to fetch groups': 'Kunne ikke hente grupper',
    'Create Discount Code': 'Opret rabatkode',
    'Active Discount Codes': 'Aktive rabatkoder',
    'Inactive Discount Codes': 'Inaktive rabatkoder',
    'Discount Code Details': 'Rabatkode detaljer',
    'Discount code is required': 'Rabatkode er påkrævet',
    'Ticket rule is required': 'Billetregel er påkrævet',
    'Discounted price is required': 'Rabatpris er påkrævet',
    'Discounted price must be a number': 'Rabatpris skal være et tal',
    'Recipient email is invalid': 'Modtagerens email er ugyldig',
    'Recipient Email': 'Modtagerens email',
    'Valid from is invalid': 'Gyldig fra er ugyldig',
    'Valid to is invalid': 'Gyldig til er ugyldig',
    'Valid to must be after valid from':
        'Gyldig til skal være efter gyldig fra',
    'Please correct the highlighted fields':
        'Ret venligst de fremhævede felter',
    'Failed to create discount code': 'Kunne ikke oprette rabatkode',
    'Failed to update discount code': 'Kunne ikke opdatere rabatkode',
    'Failed to fetch discount codes': 'Kunne ikke hente rabatkoder',
    invalid_discount_code:
        'Rabatkoden er ugyldig eller kan ikke bruges til denne billet',
    'users.noAccessGroupsForOrganisation':
        'Ingen grupper for denne organisation',
    'An unexpected error occurred': 'Der opstod en uventet fejl',
    // notification templates - send modal
    Individual: 'Individuel',
    Recipients: 'Modtagere',
    'Filter templates by name or id': 'Filtrer skabeloner efter navn eller id',
    'Filter users by name': 'Filtrer brugere efter navn',
    'Filter access groups by name': 'Filtrer grupper efter navn',
    'Please select an organisation first':
        'Vælg venligst en organisation først',
    'Scroll to load more': 'Rul for at indlæse mere',
    'No users in selected groups': 'Ingen brugere i valgte grupper',

    // App Message Templates
    'App Message Templates': 'App annonceringsskabeloner',
    AppAnnouncements: 'App annonceringer',
    'Create App Message Template': 'Opret app beskedskabelon',
    'Edit App Message Template': 'Rediger app beskedskabelon',
    'App Message Template Details': 'App beskedskabelon detaljer',
    'Resource Name': 'Ressourcenavn',
    Priority: 'Prioritet',
    'Title (English)': 'Titel (Engelsk)',
    'Title (Danish)': 'Titel (Dansk)',
    'Description (English)': 'Beskrivelse (Engelsk)',
    'Body (English)': 'Brødtekst (Engelsk)',
    'Body (Danish)': 'Brødtekst (Dansk)',
    'Are you sure you want to delete this template?':
        'Er du sikker på, at du vil slette denne skabelon?',
    appMessageAllFieldsRequired: 'Udfyld venligst alle påkrævede felter.',
    appMessageResourceNameRequired: 'Indtast venligst et ressourcenavn.',
    appMessageTitleEnRequired: 'Indtast venligst en titel på engelsk.',
    appMessageTitleDaRequired: 'Indtast venligst en titel på dansk.',
    appMessageDescriptionEnRequired:
        'Indtast venligst en beskrivelse på engelsk.',
    appMessageDescriptionDaRequired:
        'Indtast venligst en beskrivelse på dansk.',
    'Successfully deleted': 'Slettet med succes',
    Resources: 'Ressourcer',
    'appAnnouncement.shownOnLabel': 'Hvor skal meddelelsen vises?',
    'appAnnouncement.shownOnHelp':
        'Vælg en eller flere ressourcer. Meddelelseskortet vises øverst på:',
    'appAnnouncement.shownOnFooter':
        'Vælger du flere ressourcer, udgives den samme meddelelse på alle de landingssider — nyttigt til beskeder, der berører mere end én del af appen.',
    'appAnnouncement.resource.homeHelp':
        'hovedskærmen som vagter lander på efter login',
    'appAnnouncement.resource.finesHelp':
        'landingssiden for Gebyrer/Bøder (efter tryk på Gebyrer-feltet på forsiden)',
    'appAnnouncement.resource.permitsHelp':
        'landingssiden for Tilladelser (efter tryk på Tilladelser-feltet på forsiden)',
    'appAnnouncement.resource.subscriptionsHelp':
        'landingssiden for Abonnementer (efter tryk på Abonnementer-feltet på forsiden)',
    'appAnnouncement.priority': 'Prioritet',
    'appAnnouncement.priorityHelp':
        'Lavere nummer vises først, når flere meddelelser deler en side.',
    'appAnnouncement.atLeastOneResource': 'Vælg venligst mindst én ressource',
    'appAnnouncement.tooManyResources':
        'Vælg højst 10 ressourcer pr. annoncering.',
    'appAnnouncement.titleTooLong': 'Titlen må højst være 255 tegn.',
    'appAnnouncement.bodyTooLong': 'Beskrivelsen må højst være 2000 tegn.',
    'appAnnouncement.priorityNegative': 'Prioritet skal være 0 eller højere.',
    'appAnnouncement.backgroundColor': 'Baggrundsfarve',
    'appAnnouncement.accentColor': 'Accentfarve',
    'appAnnouncement.fileHint': 'JPEG, PNG, GIF eller WEBP — op til 8 MB',
    'appAnnouncement.fileUnsupported':
        'Filtype ikke understøttet. Tilladt: JPEG, PNG, GIF, WEBP.',
    'appAnnouncement.fileTooLarge':
        'Filen er for stor. Maks. størrelse er 8 MB.',
    'appAnnouncement.notFound': 'Skabelon ikke fundet',
    'appAnnouncement.somethingWentWrong': 'Noget gik galt, prøv igen',
    'appAnnouncement.resourceConflict':
        'Disse ressourcer bruges allerede af en anden skabelon: {{list}}. Rediger eller slet den eksisterende skabelon, før du fortsætter.',
    'appAnnouncement.created': 'Oprettet med succes',
    'appAnnouncement.updated': 'Opdateret med succes',
    'appAnnouncement.deleted': 'Slettet med succes',
    'permitReason.nameAndDescriptionRequired':
        'Udfyld venligst både Navn og Beskrivelse.',
    'permitReason.createSuccess': 'Tilladelsesårsag oprettet.',
    'permitReason.updateSuccess': 'Tilladelsesårsag opdateret.',
    'permitReason.deleteSuccess': 'Tilladelsesårsag slettet.',
    'permitReason.createFailed':
        'Tilladelsesårsagen kunne ikke oprettes. Prøv venligst igen.',
    'permitReason.updateFailed':
        'Tilladelsesårsagen kunne ikke opdateres. Prøv venligst igen.',
    'permitReason.deleteFailed':
        'Tilladelsesårsagen kunne ikke slettes. Prøv venligst igen.',
    'permitType.nameRequired': 'Indtast venligst et navn.',
    'permitType.confirmDeletePrompt': 'Klik på Slet igen for at bekræfte.',
    'permitType.createSuccess': 'Tilladelsestype oprettet.',
    'permitType.updateSuccess': 'Tilladelsestype opdateret.',
    'permitType.createFailed':
        'Tilladelsestypen kunne ikke oprettes. Prøv venligst igen.',
    'permitType.updateFailed':
        'Tilladelsestypen kunne ikke opdateres. Prøv venligst igen.',
    'permitType.deleteFailed':
        'Tilladelsestypen kunne ikke slettes. Prøv venligst igen.',
    'fines.parkingLotsFetchFailed':
        'Kunne ikke hente parkeringspladser. Opdater venligst og prøv igen.',
    'fines.offenseListFetchFailed': 'Kunne ikke hente listen over årsager.',
    'fines.fineNotFound': 'Den ønskede afgift kunne ikke findes.',
    'fines.offlineId': 'Offline-ID',
    'fines.copyCoordinatesTooltip': 'Klik for at kopiere koordinater',
    'externalNote.createSuccess': 'Ekstern note-skabelon oprettet.',
    'externalNote.updateSuccess': 'Ekstern note-skabelon opdateret.',
    'externalNote.deleteSuccess': 'Ekstern note-skabelon slettet.',
    'externalNote.createFailed':
        'Den eksterne note-skabelon kunne ikke oprettes. Prøv venligst igen.',
    'externalNote.updateFailed':
        'Den eksterne note-skabelon kunne ikke opdateres. Prøv venligst igen.',
    'externalNote.deleteFailed':
        'Den eksterne note-skabelon kunne ikke slettes. Prøv venligst igen.',
    'cancelReason.nameAndDescriptionRequired':
        'Udfyld venligst både Navn og Beskrivelse.',
    'cancelReason.createSuccess': 'Annulleringsårsag oprettet.',
    'cancelReason.updateSuccess': 'Annulleringsårsag opdateret.',
    'cancelReason.deleteSuccess': 'Annulleringsårsag slettet.',
    'cancelReason.createFailed':
        'Annulleringsårsagen kunne ikke oprettes. Prøv venligst igen.',
    'cancelReason.updateFailed':
        'Annulleringsårsagen kunne ikke opdateres. Prøv venligst igen.',
    'cancelReason.deleteFailed':
        'Annulleringsårsagen kunne ikke slettes. Prøv venligst igen.',
    'cancelReason.filterPlaceholder':
        'Filtrer annulleringsårsager efter navn eller id',
    'parkingLot.nameRequired': 'Indtast venligst et navn.',
    'parkingLot.organisationRequired': 'Vælg venligst en organisation.',
    'parkingLot.permitSharingRequired':
        'Vælg venligst en deling af tilladelser.',
    'parkingLot.streetNameRequired': 'Indtast venligst et gadenavn.',
    'parkingLot.streetNumberRequired': 'Indtast venligst et husnummer.',
    'parkingLot.postalCodeRequired': 'Indtast venligst et postnummer.',
    'parkingLot.cityRequired': 'Indtast venligst en by.',
    'parkingLot.latitudeRequired': 'Indtast venligst en breddegrad.',
    'parkingLot.latitudeAboveMin': 'Breddegrad skal være mindst -90.',
    'parkingLot.latitudeBelowMax': 'Breddegrad skal være højst 90.',
    'parkingLot.longitudeRequired': 'Indtast venligst en længdegrad.',
    'parkingLot.longitudeAboveMin': 'Længdegrad skal være mindst -180.',
    'parkingLot.longitudeBelowMax': 'Længdegrad skal være højst 180.',
    'parkingLot.areaCoordinatesMin':
        'Områdets koordinater skal have mindst 3 punkter.',
    'parkingLot.economicDepartmentRequired':
        'Vælg venligst en økonomiafdeling.',
    'parkingLot.guardControlPercentRange':
        'P-vagtkontrol-procent skal være mellem 0% og 100%.',
    'parkingLot.selfTicketingPercentRange':
        'Selvbillettering-procent skal være mellem 0% og 100%.',
    'parkingLot.cameraControlPercentRange':
        'Kamerakontrol-procent skal være mellem 0% og 100%.',
    'parkingLot.permitPercentRange':
        'Tilladelses-procent skal være mellem 0% og 100%.',
    'parkingLot.subscriptionPercentRange':
        'Abonnements-procent skal være mellem 0% og 100%.',
    'parkingLot.guestRuleNameRequired':
        'Indtast venligst et navn til gæsteregel.',
    'parkingLot.negativeNumber': 'Værdien kan ikke være negativ.',
    'parkingLot.maxPermitsPerMonthTooLow':
        'Maks. tilladelser pr. måned skal være mindst lige så højt som maks. aktive tilladelser.',
    'parkingLot.invalidAddressId': 'Manglende eller ugyldigt adresse-ID.',
    'parkingLot.customCompanyRules': 'Brugerdefinerede firmaregler',
    'parkingLot.maxActivePermits': 'Maks. aktive tilladelser',
    Image: 'Billede',
    Remove: 'Fjern',
    'Drag and drop': 'Træk og slip',
    or: 'eller',
    'Upload image': 'Importer billede',
    'Background Color': 'Baggrundsfarve',
    'Accent Color': 'Accentfarve',
    Preview: 'Forhåndsvisning',
    'See more': 'Se mere',
    'See less': 'Se mindre',
    'JPEG, PNG, GIF or WEBP — up to 8 MB':
        'JPEG, PNG, GIF eller WEBP — op til 8 MB',
    'Unsupported file type. Allowed: JPEG, PNG, GIF, WEBP.':
        'Filtype ikke understøttet. Tilladt: JPEG, PNG, GIF, WEBP.',
    'File too large. Max size is 8 MB.':
        'Filen er for stor. Maks. størrelse er 8 MB.',
    'Could not read file': 'Kunne ikke læse filen',
    'Template not found': 'Skabelon ikke fundet',
    'Something went wrong, please try again': 'Noget gik galt, prøv igen',
    'These resources are already used by another template: {{list}}. Edit or delete the existing template before continuing.':
        'Disse ressourcer bruges allerede af en anden skabelon: {{list}}. Rediger eller slet den eksisterende skabelon, før du fortsætter.',
    Paragraph: 'Paragraf',
    'Custom observation time(Minutes)':
        'Brugerdefineret observationstid (minutter)',
    'Custom fine price': 'Afgiftspris multiplikator (× grundpris)',
    'Enter distance in meters (required)': 'Indtast afstand i meter (påkrævet)',
    'Indskriv afstand i meter (påkrævet)':
        'Indskriv afstand i meter (påkrævet)',
    'Local date and time (required)': 'Lokal dato og klokkeslæt (påkrævet)',
    'Angiv lokal dato og tid': 'P-skive',
    'Angiv lokal dato og tid (påkrævet)': 'Angiv lokal dato og tid (påkrævet)',
    'Key values': 'Oversættelser',
    'Time local date': 'Lokal dato og tid',
    'Measurement in meter check': 'Måling i målerkontrol',
    'Valve check (required)': 'Ventiltjek (påkrævet)',
    'Valve control check': 'Kontrol af ventilkontrol',
    Enabled: 'Aktivere',
    Disabled: 'Deaktiveret',
    'Street Qualifier': 'Gade kvalifikator',
    // observations modal
    observations: 'Observationer',
    Observations: 'Observationer',
    observationDetails: 'Observationsdetaljer',
    observationStartedAt: 'Observation startet kl.',
    isShared: 'Er delt',
    observationFilterAll: 'Alle',
    observationFilterShared: 'Delt',
    observationFilterNotShared: 'Ikke delt',
    observationPinsTruncated:
        'For mange observationer i visningen; resultatet blev begrænset.',
    internalNote: 'Intern note',
    externalNote: 'Ekstern note',
    externalNoteTemplates: 'Externe noteskabeloner',
    externalNoteDetails: 'Externe notedetaljer',
    createExternalNoteTemplate: 'Opret externe noteskabelon',
    updatedAt: 'Opdateret kl.',
    createdAt: 'Oprettet kl.',
    clickToCopyCoordinates: 'Klik for at kopiere koordinater',
    fineInterruptionDetails: 'Bøde Afbrydelse Detaljer',
    finesInterruption: 'Afbrydelser',
    removalReasons: 'Afbrydelsesårsager',
    back: 'Tilbage',
    regNr: 'Reg. nr.',
    parkinglotId: 'Parkeringsplads Id',
    parkingLot: 'Parkeringsplads',
    feeInterruptionReason: 'Afbrydelsesårsag',
    userName: 'Brugernavn',
    userNote: 'Vagtnummer',
    faildToFecthFineInterruptions: 'Kunne ikke hente afgiftafbrydelser',
    eventType: 'Hændelsestype',
    eventComment: 'Hændelseskommentar',
    locationReadDate: 'Placeringsaflæsningsdato',
    model: 'Model',
    comment: 'Kommentar',
    wrongDoing: 'Overtrædelse',
    vehicleInformationDmr: 'Køretøjsoplysninger (DMR)',
    failedToFetchObservations: 'Kunne ikke hente observationer',
    unableToGenerateReport200k:
        'Kan ikke generere rapport. Antallet af rækker overskred 200.000 — anvend venligst filtre for at minimere mængden.',
    regnoPseudonymizationInfo:
        'Reg. nr. for ScannerUsed-hændelser er pseudonymiseret. Det viste nummer er et anonymiseret ID, ikke den faktiske nummerplade. Det samme ID betyder, at samme nummerplade er blevet scannet flere gange.',
    dontSendFineToAddress: 'Send ikke afgift til adresse',
    enableDontSendFineToAddress: 'Aktivér Send ikke afgift til adresse',
    addNewAddress: '+ Tilføj ny adresse',
    MessageTemplates: 'Beskedskabeloner',
    MessageHistory: 'Beskeder',
    SendMessage: 'Send besked',
    MessageTemplate: 'Beskedskabelon',
    avanceretSoeg: 'Avanceret søg',
    faerreValg: 'Færre valg',
    SentAt: 'Sendt kl.',
    MessageDetails: 'Beskeddetaljer',
    noTranslationsAdded: 'Ingen oversættelser tilføjet',
    removeTranslation: 'Fjern oversættelse',
    addTranslation: 'Tilføj oversættelse...',

    reportOverallSummary: 'Samlet oversigt',
    reportPerAddressDetails: 'Detaljer pr. adresse',
    reportPerAttendant: 'Pr. vagt',
    shiftWardenOverview: 'P-Vagt Oversigt',
    shiftWardenDetails: 'P-Vagt Aktivitet',
    'View hourly breakdown': 'Se timevis analyse',
    shiftWardenGps: 'Vagt GPS',
    reportPerParkingLot: 'Pr. parkeringszone',
    reportPerStreet: 'Pr. gade',
    reportPerPatrolArea: 'Pr. patruljedistrikt',
    reportPaidTimeLimitedZoneSummary:
        'Oversigt over betalte tidsbegrænsede zoner',
    reportUserActivity: 'Brugeraktivitet',
    reportEvScans: 'EV-scanninger',
    reportCounterScans: 'Parkeringstælling',
    reportScanList: 'Scanliste',
    reportValveCheck: 'Ventilkontrol',
    'Valve Control': 'Ventilkontrol',
    'Initial check': 'Indledende kontrol',
    'Follow up check': 'Opfølgende kontrol',
    'No image': 'Intet billede',
    reportSelectReports: 'Vælg rapporter',
    reportSelectAll: 'Vælg alle',
    reportClear: 'Ryd',
    mapReportTimeoutHint:
        'Rapporten tog for lang tid. Prøv et kortere datointerval eller snævrere filtre, og prøv igen.',
    mapReportEmptyResult:
        'Ingen data matchede dine filtre. Rapporten blev ikke downloadet.',
    mapReportDownloadStarted: 'Download startet: {{name}}',
    mapReportTruncatedWarning:
        'Filen kan være ufuldstændig: rapporten nåede det maksimale antal rækker. Indsnævre filtrene for et fuldt udtræk.',
    mapReportExportScopeHint:
        'Excel-filen bruger søgefiltrene ovenfor. Varmekort og hvilke zonelayere der er synlige ændrer kun kortet, ikke rapporten.',
    mapActiveDateRangeLabel: 'Aktiv periode',
    mapActiveDateRangeUnlimited: 'Ingen datogrænse',
    mapActiveDateRangeSummary: '{{from}} – {{to}}',
    mapActiveTimeRangeSuffix: '· {{from}}–{{to}}',
    mapDatePresetLast7Days: 'Seneste 7 dage',
    mapDatePresetThisMonth: 'Denne måned',
    mapReportGenericFailure:
        'Rapporten kunne ikke genereres. Prøv venligst igen.',
    mapReportNetworkFailure:
        'Forbindelsen til serveren kunne ikke oprettes. Tjek din internetforbindelse, og prøv igen.',
    mapReportInternalError:
        'Der opstod en intern fejl under generering af rapporten. Prøv venligst igen.',
    AvailableOn: 'Tilgængelig på',
    fineInterruptions: 'Afgiftsafbrydelse',
    guardGps: 'Vagt Gps',
    flowType: 'Flowtype',
    flowType_0: 'Ukendt',
    flowType_1: 'Autostart & stop',
    flowType_2: 'Manuel start & stop',
    flowType_3: 'Genindtræden stop',
    flowType_4: 'Autostop efter 48t',
    flowType_5: 'Manuel stop efter 48t',
    flowType_6: 'Autostart, manuel stop',
    flowType_7: 'EasyPark stop succes',
    flowType_8: 'EasyPark stop fallback',
    flowType_9: 'AreaNo 0 stop',
    flowType_10: 'Cronjob stop efter 48t',
    flowType_11: 'Backoffice manuel stop',
    flowType_12: 'Manuel start, autostop',
    ShowPins: 'Vis Nåle',
    NoteTemplate: 'Tilladelsesskabelon',
    Visibility: 'Synlighed',
    Visibility_backoffice: 'Synlig kun for backoffice',
    Visibility_dashboard: 'Synlig for dashboard',
    Visibility_all: 'Synlig for alle organisationer',
    Delete_parking_status: 'Slet Parkeringsstatus',
    Parking_status_delete_check_info:
        'Vi kontrollerer om denne parkeringsstatus er i brug, inden den kan slettes.',
    Status_is_in_use: 'Status er i brug',
    Parking_status_in_use_info:
        'Du kan ikke slette denne status, før alle relaterede poster nedenfor er opdateret.',
    Status_is_not_in_use: 'Status er ikke i brug',
    Parking_status_not_in_use_info:
        'Ingen poster bruger i øjeblikket denne status. Den kan slettes uden problemer.',
    Usage_by_type: 'Brug fordelt på type',
    Failed_to_fetch_usage: 'Kunne ikke hente brug',
    Parking_status_no_records_found:
        'Ingen relaterede poster fundet for denne parkeringsstatus.',
    Confirm_delete: 'Bekræft sletning',
    Deleting: 'Sletter...',
    parkingStatusNameRequired: 'Indtast venligst et navn.',
    parkingStatusDanishRequired: 'Angiv venligst mindst én dansk oversættelse.',
    parkingStatusCancelReasonRequired:
        'Vælg venligst mindst én annulleringsårsag.',

    // Entra user
    'entraUser.banner':
        'Denne bruger administreres af Entra. Nogle felter kan ikke redigeres.',
    'entraUser.role': 'Entra Rolle',
    'entraUser.fieldDisabled': 'Dette felt administreres af Entra',
    Entra: 'Entra',
    'entraUser.permissionsDisabled':
        'Tilladelser administreres af Entra og kan ikke ændres her.',
    'fines.actionValue.measurementMeter': 'Opmålt afstand (cm)',
    'fines.actionValue.timeLocalDate': 'Tidspunkt',
    'fines.actionValue.pDisc1Time': 'P-skive tidspunkt 1',
    'fines.actionValue.pDisc2Time': 'P-skive tidspunkt 2',
    'fines.vehicleTypeLabel': 'Køretøjstype',
    'fines.observationDuration': 'varighed (min)',
    'fines.internalNoteFromApp': 'Intern note fra appen',
    'fines.externalNoteFromApp': 'Ekstern note fra appen',
    'fine.startdate': 'Oprettet i platform',
    'fine.startdate.tooltip':
        'Afgiftens synkroniseringstidspunkt med platformen',
    'fine.created': 'Afgift pålagt',
    'fine.created.tooltip':
        'Tidspunktet hvor afgiften er pålagt køretøjet af brugeren',
    'fine.enddate': 'Ingen yderligere afgifter indtil',
    'fine.vehicleinfo': 'Køretøjsinformation',
    'fines.feeReason': 'Leveringsmetode',
    'fines.attachedFineLabel': 'Afgift fastsat',
    'fines.attachedFineYes': 'Ja',
    'fines.attachedFineNo': 'Eftersendt',
    'fines.userName': 'Navn',
    'fines.userNote': 'Note',
    'fines.streetCode': 'Vejkode',
    observation: 'Observation',
    totalCount: 'Samlet antal',
    monthYear: 'Måned/år',
    nameIsRequired: 'Navn er påkrævet',
    nameCannotExceed255: 'Navn må ikke overstige 255 tegn',
    descriptionIsRequired: 'Beskrivelse er påkrævet',
    descriptionCannotExceed500: 'Beskrivelse må ikke overstige 500 tegn',
    priority: 'Prioritet',
    deletedBy: 'Slettet af',
    deletedReason: 'Årsag til sletning',
    parkingFeeID: 'Parkeringsafgift ID',
    gpsAge1Min: 'For 1 minut siden',
    gpsAgeXMins: 'For {{count}} minutter siden',
    gpsAge1Hour: 'For 1 time siden',
    gpsAgeXHours: 'For {{count}} timer siden',
    gpsAgeToday: 'I dag',
    gpsAgeYesterday: 'I går — {{date}}',
    gpsAgeWeekday: '{{weekday}} — {{date}}',
    gpsAgeXDays: 'For {{count}} dage siden — {{date}}',
    gpsAgeXMonths: 'For {{count}} måneder siden — {{date}}',
    gpsAgeXYears: 'For {{count}} år siden — {{date}}',
    gpsTracking: 'GPS Sporing',
    somethingWentWrong: 'Noget gik galt',
    unexpectedErrorOccurred:
        'Der opstod en uventet fejl. Du kan prøve at genindlæse siden eller nulstille visningen.',
    stackTrace: 'Staksporing',
    reloadPage: 'Genindlæs siden',
    noSubscriptionsFound: 'Ingen abonnementer fundet',
    noTrainingModulesFound: 'Ingen træningsmoduler fundet',
    noUsersFound: 'Ingen brugere fundet',
    noPermitsFound: 'Ingen tilladelser fundet',
    noGroupsFound: 'Ingen grupper fundet',
    noAppMessageTemplatesFound: 'Ingen app-beskedskabeloner fundet',
    noNotificationsFound: 'Ingen notifikationer fundet',
    noTrainingDataFound: 'Ingen træningsdata fundet',
    noFinesFound: 'Ingen afgifter fundet',
    noDataFound: 'Ingen data fundet',
    noDiscountCodesFound: 'Ingen rabatkoder fundet',
    noCameraPermitsOrFinesFound:
        'Ingen kameraafgifter eller tilladelser fundet',
    noCameraFinesFound: 'Ingen kameraafgifter fundet',
    noCameraPermitsFound: 'Ingen kameratilladelser fundet',
    noObservationsFound: 'Ingen observationer fundet',
    noFineInterruptionsFound: 'Ingen afgiftsunderbrengninger fundet',
    noParkingStatusFound: 'Ingen parkeringsstatus fundet',
    noParkingStatusesFound: 'Ingen parkeringsstatusser fundet',
    noAddressesFound: 'Ingen adresser fundet',
    noMessageTemplatesFound: 'Ingen beskedskabeloner fundet',
    noMessageHistoryFound: 'Ingen beskedhistorik fundet',
    'Both Name and Description are required fields':
        'Både Navn og Beskrivelse er obligatoriske felter',
    nameLessThan4: 'Navnet skal være mindst 4 tegn.',
    descriptionLessThan4: 'Beskrivelsen skal være mindst 4 tegn.',
    'fine.delete.title': 'Slet afgift',
    'fine.delete.warning':
        'Du er ved at slette denne afgift og alle tilknyttede data permanent. Dette kan ikke fortrydes.',
    'fine.delete.affectedData': 'Oplysninger der berøres af sletningen',
    'fine.delete.dataType': 'Datatype',
    'fine.delete.description': 'Beskrivelse',
    'fine.delete.personalData': 'Afgift og persondata',
    'fine.delete.personalDataDesc':
        'Selve afgiften slettes permanent inkl. nummerplade, landekode og GPS-lokation.',
    'fine.delete.imagesDesc': 'Alle billeder tilknyttet afgiften slettes.',
    'fine.delete.observation': 'Observation',
    'fine.delete.observationDesc':
        'Tilknyttet parkeringsobservation frigives og slettes.',
    'fine.delete.eventHistory': 'Hændelseshistorik',
    'fine.delete.eventHistoryDesc':
        'Hændelseslog for parkeringsvagts oprettelse af observation og afgift slettes.',
    'fine.delete.noticeTitle': 'Bemærk - Sletning sker efter 24 timer',
    'fine.delete.noticeBody':
        'Når du bekræfter, vil afgiften og alle tilknyttede data blive slettet permanent efter 24 timer. Denne handling kan ikke fortrydes.',
    viewImage: 'Se billede',
    imageTooBig: 'Billedet er for stort. Maksimal størrelse er 4 MB.',
    FineCreated: 'Afgift oprettet',
    FineSearched: 'Afgift søgt',
    PermitCreated: 'Tilladelse oprettet',
    PermitSearched: 'Tilladelse søgt',
    ScannerUsed: 'Scanner anvendt',
    FeeSearch: 'Gebyr søgning',
    FineObservation: 'Afgift observation',
    FineCancelled: 'Afgift annulleret',
    CreateCleanFine: 'Afbrudt afgiftsoprettelse',
    ParkedCar: 'Parkeret bil',
    ValidPermit: 'Gyldig tilladelse',
    InValidPermit: 'Ugyldig tilladelse',
    DeleteObservation: 'Slet observation',
    'Rows per page': 'Rækker pr. side',
    'Spots & sections': 'Pladser & sektioner',
    'Sections count': 'Antal sektioner',
    'Spot count': 'Antal pladser',
    'Spots and sections': 'Pladser og sektioner',
    'SmartHub enabled': 'SmartHub aktiveret',
    'Parking Lot Rules': 'P-zone regler',
    'Complaints handling': 'Klagebehandling',
    'Note for parkinglot specific guidelines':
        'Note til P-zone specifikke retningslinjer',
    'Passenger car': 'Personbil',
    Van: 'Varevogn',
    Truck: 'Lastbil',
    Bus: 'Bus',
    Motorcycle: 'Motorcykel',
    'Moped 45': 'Knallert 45',
    Trailer: 'Trailer',
    Diesel: 'Diesel',
    Electric: 'Elektrisk',
    Hybrid: 'Hybrid',
    Petrol: 'Benzin',
    searchForLocation: 'Søg efter lokation',
    'financeReports.createCustomInvoice': 'Opret tilpasset faktura',
    'financeReports.typeStandard': 'Standard',
    'financeReports.typeCustom': 'Tilpasset',
    'financeReports.customLines': 'Tilpassede linjer',
    'financeReports.customLinesHint':
        'Positiv enhedspris går til OPARKO-andel. Negativ enhedspris går til kundeandel.',
    'financeReports.addLine': 'Tilføj linje',
    'financeReports.lineDescription': 'Beskrivelse',
    'financeReports.lineQuantity': 'Antal',
    'financeReports.lineUnitPrice': 'Enhedspris',
    'financeReports.lineTotal': 'Linjetotal',
    'financeReports.saveCustomInvoice': 'Gem tilpasset faktura',
    'financeReports.customInvoiceCreated': 'Tilpasset faktura oprettet',
    'financeReports.customInvoiceUpdated': 'Tilpasset faktura opdateret',
    'financeReports.parkingAddressRequired': 'Parkeringsadresse er påkrævet',
    'financeReports.periodRequired': 'Periode start og slut er påkrævet',
    'financeReports.minimumRent': 'Minimumsleje',
    'financeReports.minimumRentAdjustment': 'Minimumslejejustering',
    'financeReports.rent': 'Leje',
};

export default dansk;
